/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    toNumber,
    get,
    getItemFromArray,
    BaseURL,
    replaceVariables,
    ConvertCutoutNameForDecks,
    GetHTMLColour,
    getPointForRef,
    midPointRef,
} from "../../components/Common";
import { API_BASE } from "../../AppConfig";
import AreaSelectField from "../../components/AreaSelectField";
import SpecModifyAttachmentDialog from "../context_options/SpecModifyAttachmentDialog";
import SpecModifyBeamDialog from "../context_options/SpecModifyBeamDialog";
import SpecModifyPostDialog from "../context_options/SpecModifyPostDialog";
import SpecNotesDialog from "../context_options/SpecNotesDialog";

import SpecModifyDownpipeDialog from "../context_options/SpecModifyDownpipeDialog";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import _debounce from "lodash/debounce";

import Babylon3D, { GetSkylights, zoomIn3D, zoomOut3D, zoomAll3D, updateSkylights3D, updateColours } from "./Babylon3D";
import paper from "paper";

import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import * as Paper from "./PaperFunctions";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import InputAdornment from "@material-ui/core/InputAdornment";
import ListSubheader from "@material-ui/core/ListSubheader";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import TuneIcon from "@material-ui/icons/Tune";
import Icon from "@material-ui/core/Icon";
import Crosshairs from "../../components/Crosshairs";

// Redux Actions
import { connect } from "react-redux";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import {
    updateAreaSpecification,
    uploadDocument,
    updateAreaSpecificationJob,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
// import { showDialog } from "../../redux_store/appState";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import SpecModifyBeamPostsDialog from "../context_options/SpecModifyBeamPostsDialog";
import Message from "../../components/Message";
import BSL_Dialog from "../../components/BSL_Dialog";
import BSL_TextInput from "../../components/BSL_TextInput";
import SpecExtraBeamDialog from "../context_options/SpecExtraBeamDialog";
import SpecSlatsTool from "../context_options/SpecSlatsTool";

import {
    THREED_MODE,
    THREED_MINI_MODE,
    SHOW_DISPLAY_OPTIONS,
    DRAWER_TOOLSET_EXPANDED,
    SHOW_MESSAGE,
    toggleDesigner,
    update2DDesigner,
    showDesignerMessage,
    showDialog,
} from "../../redux_store/appState";
import { updateLayout2D, updateLayout3D } from "../../redux_store/appStateHelper";
import { setToolSetArea } from "../../redux_store/appStateHelper";
import SpecModifyAttachmentDialog2 from "../context_options/SpecModifyAttachmentDialog2";
import { GetColourUpdateString, GetShapeUpdateString } from "./PaperFunctionHelper";
import HorizontalSplitIcon from "@material-ui/icons/HorizontalSplit";
import BSL_Button from "../../components/BSL_Button";
import BSL_Select from "../../components/BSL_Select";

const importedActions = {
    updateAreaSpecification,
    updateAreaSpecificationJob,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
    showDialog,
    setToolSetArea,
    toggleDesigner,
    updateLayout2D,
    update2DDesigner,
    showDesignerMessage,
    uploadDocument,
};
const mapStateToProps = (state) => ({
    app: state.app,
    job: state.job,
    config: {
        RoofSheetTypes: state.config.RoofSheetTypes,
        design_options: state.config.design_options,
        beam_types: state.config.beam_types,
        post_types: state.config.post_types,
    },
});

const chip_width = "1rem";

const styles = (theme) => ({
    qq2dCanvasContainer: {
        zIndex: 0,
        display: "block",
        position: "absolute",
        top: "0px",
        right: "0px",
        backgroundColor: "rgba(255, 255, 255, 255)",
        width: "100%",
        height: "100%",
        color: "#000",
        transition: "visibility 0.3s, opacity 0.3s linear",
        textAlign: "left",
        // cursor: 'crosshair',
    },

    qq2dCanvas: {
        width: "100vw",
        height: "100vh",
        // paddingRight: "280px",
        //         backgroundSize: "100px 100px, 100px 100px, 20px 20px, 20px 20px",
        // backgroundPosition: "-2px -2px, -2px -2px, -1px -1px, -1px -1px",
        // backgroundImage: "-webkit-linear-gradient(white 2px, transparent 2px),\
        // -webkit-linear-gradient(0, white 2px, transparent 2px),\
        // -webkit-linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px),\
        // -webkit-linear-gradient(0, rgba(255,255,255,.3) 1px, transparent 1px),\
        // -moz-linear-gradient(white 2px, transparent 2px),\
        // -moz-linear-gradient(0, white 2px, transparent 2px),\
        // -moz-linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px),\
        // -moz-linear-gradient(0, rgba(255,255,255,.3) 1px, transparent 1px),\
        // linear-gradient(white 2px, transparent 2px),\
        // linear-gradient(90deg, white 2px, transparent 2px),\
        // linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px),\
        // linear-gradient(90deg, rgba(255,255,255,.3) 1px, transparent 1px)",
    },
    snackbar: {
        zIndex: "1300",
    },
    typography: {
        padding: "20px",
    },
    menu_item: {
        fontFamily: theme.typography.fontFamily,
        "&:hover": {
            background: "#b9c9e6",
        },
    },
    popover: {
        paddingTop: "10px",
        fontFamily: theme.typography.fontFamily,
    },
    pop_header: {
        padding: "0 16px",
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontFamily: theme.typography.fontFamilySecondary,
    },
    pop_specs_header: {
        margin: "10px 0px",
        padding: "0px 10px",
        background: "#e8e8e8",
    },
    pop_specs: {
        padding: "0px 10px",
        color: "dark grey",
        fontFamily: theme.typography.fontFamily,
    },
    pop_specs_small_text: {
        width: "100%",
        justifyContent: "flex-end",
        fontSize: "10px",
        top: "-5px",
        paddingRight: "18px",
        height: "16px",
        "&:hover": {
            color: "#bb6a00",
        },
    },
    divider: {
        height: "3px",
        margin: "7px",
        background: "orange",
    },
    calculating: {
        color: "#ffffff",
        position: "fixed",
        zIndex: "10000",
        fontSize: "7pt",
        paddingLeft: "66px",
    },
    roofsheet_chip: {
        // display:"inline",
        borderRadius: chip_width,
        border: "1px solid grey",
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
        marginRight: "0.5rem",
        minWidth: chip_width,
        minHeight: chip_width,
        background: "#ffffff",
        display: "inline",
    },
    mini_button: {
        position: "absolute",
        right: "10px",
        lineHeight: 1.25,
        paddingTop: "5px",
    },
});

// const paper = paper;
var _this = {};

const ROOF_SHEETING = "ROOF_SHEETING";

const hitOptions = {
    // Trigger hit only on 'fill' part of the path with 0 tolerance
    segments: false,
    stroke: false,
    fill: true,
    tolerance: 6,
    match: (res) => {
        return res?.item?.ref;
    },
};

/* DES-1082 - Warning for Box/No Gutter when attached */
function gutterDialogAction(acceptedRisk, stateOfJob, areaIndex, gutterState) {
    const area_design_specs = stateOfJob.job.AreaSpecifications?.[areaIndex];

    if (
        (area_design_specs?.ATTACHMENTS?.AttachmentBottom == 1 &&
            (area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB == 0 ||
                area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB == 2)) ||
        (area_design_specs?.ATTACHMENTS?.AttachmentTop == 1 &&
            (area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterF == 0 ||
                area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterF == 2)) ||
        (area_design_specs?.ATTACHMENTS?.AttachmentAttachmentLeft == 1 &&
            (area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterL == 0 ||
                area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterL == 2)) ||
        (area_design_specs?.ATTACHMENTS?.AttachmentAttachmentRight == 1 &&
            (area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterR == 0 ||
                area_design_specs?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterR == 2) &&
            area_design_specs?.Acknowledgements?.BoxHouseGutterAcknowledgement)
    ) {
        if (acceptedRisk) {
            gutterState.gutter_dialog = false;
        } else {
            gutterState.gutter_dialog = true;
        }
    } else {
        gutterState.gutter_dialog = false;
    }
}

function wipe_start_end_marks() {
    if (paper.project.activeLayer.start_mark) {
        paper.project.activeLayer.start_mark.visible = false;
        paper.project.activeLayer.start_mark.remove();
        paper.project.activeLayer.start_mark = null;
    }
    if (paper.project.activeLayer.end_mark) {
        paper.project.activeLayer.end_mark.visible = false;
        paper.project.activeLayer.end_mark.remove();
        paper.project.activeLayer.end_mark = null;
    }
}

function GetRefs(pop_item, area_design_specs) {
    const DesignType = area_design_specs?.SHAPE?.DesignType;

    let is_portal = DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;
    let is_flat = DesignType === CONFIG.DESIGN_TYPES.FLAT;

    let IS_CUTOUT =
        pop_item.ref.startsWith("BackLeft") ||
        pop_item.ref.startsWith("BackRight") ||
        pop_item.ref.startsWith("BackMid") ||
        pop_item.ref.startsWith("FrontLeft") ||
        pop_item.ref.startsWith("FrontRight") ||
        pop_item.is_cutout;

    let AttachmentRef = "";
    let GutterRef = "";
    let CutoutPrefix = "";
    let CutoutSide = "";

    let ref = pop_item.ref;
    if (!ref || ref === true || ref === "unknown") ref = "";
    let ref2 = pop_item.ref2;
    if (!ref2 || ref2 === true || ref2 === "unknown") ref2 = "";

    if (IS_CUTOUT) {
        if (ref) {
            if (ref.startsWith("CFL") || ref.startsWith("FrontLeft")) CutoutPrefix = "FrontLeft";
            else if (ref.startsWith("CFR") || ref.startsWith("FrontRight")) CutoutPrefix = "FrontRight";
            else if (ref.startsWith("CBL") || ref.startsWith("BackLeft")) CutoutPrefix = "BackLeft";
            else if (ref.startsWith("CBM") || ref.startsWith("BackMid")) CutoutPrefix = "BackMid";
            else if (ref.startsWith("CBR") || ref.startsWith("BackRight")) CutoutPrefix = "BackRight";

            if (ref.includes("-Attachment")) AttachmentRef = ref;
            if (ref.includes("-HasGutter")) GutterRef = ref;
        }
        if (ref2) {
            if (!CutoutPrefix) {
                if (ref2.startsWith("CFL") || ref2.startsWith("FrontLeft")) CutoutPrefix = "FrontLeft";
                else if (ref2.startsWith("CFR") || ref2.startsWith("FrontRight")) CutoutPrefix = "FrontRight";
                else if (ref2.startsWith("CBL") || ref2.startsWith("BackLeft")) CutoutPrefix = "BackLeft";
                else if (ref2.startsWith("CBM") || ref2.startsWith("BackMid")) CutoutPrefix = "BackMid";
                else if (ref2.startsWith("CBR") || ref2.startsWith("BackRight")) CutoutPrefix = "BackRight";
            }

            if (ref2.includes(" C")) CutoutSide = "C";
            else if (ref2.includes(" A2")) CutoutSide = "A2";
            else if (ref2.includes(" A")) CutoutSide = "A";
            else if (ref2.includes(" Y2")) CutoutSide = "Y2";
            else if (ref2.includes(" Y")) CutoutSide = "Y";
            else if (ref2.includes(" X")) CutoutSide = "X";
        }

        if (CutoutPrefix) {
            if (AttachmentRef == "") {
                AttachmentRef = CutoutPrefix + "-Attachment";
            }
            if (!AttachmentRef.endsWith(CutoutSide)) {
                if (CutoutSide === "A2" || CutoutSide === "A" || CutoutSide === "Y2" || CutoutSide === "Y") {
                    AttachmentRef += CutoutSide;
                }
            }

            if (GutterRef == "") {
                if (CutoutSide === "C") {
                    let index = toNumber(ref2.split("/")[1]);
                    GutterRef = CutoutPrefix + "-" + index + "-CustomHasGutter";
                } else {
                    GutterRef = CutoutPrefix + "-HasGutter";
                }
            }
            if (CutoutSide != "" && CutoutSide !== "C" && !GutterRef.endsWith(CutoutSide)) {
                GutterRef += CutoutSide;
            }

            if (CutoutSide != "" && CutoutSide !== "C" && CutoutSide !== "X" && !AttachmentRef.endsWith(CutoutSide)) {
                AttachmentRef += CutoutSide;
            }
            if (CutoutSide === "A") {
                if (CutoutPrefix !== "BackMid" && AttachmentRef.endsWith("A")) {
                    AttachmentRef = CutoutPrefix + "-Attachment";
                }
            }
        }
    } else {
        // not cutout
        if (ref) {
            if (ref.includes("Gutter")) GutterRef = ref;
            if (ref.includes("Attachment")) AttachmentRef = ref;
        }
        if (ref2) {
            if (ref.includes("Gutter")) GutterRef = ref;
            if (ref.includes("Attachment")) AttachmentRef = ref;
        }

        if (AttachmentRef === "") {
            // need to infer from side text
            if (ref.includes("Left") || ref2.includes("Left")) AttachmentRef = "AttachmentLeft";
            else if (ref.includes("Right") || ref2.includes("Right")) AttachmentRef = "AttachmentRight";
            else if (ref.includes("Back") || ref2.includes("Back") || ref.includes("Top") || ref2.includes("Top"))
                AttachmentRef = "AttachmentTop";
            else if (
                ref.includes("Front") ||
                ref2.includes("Front") ||
                ref.includes("Bottom") ||
                ref2.includes("Bottom")
            )
                AttachmentRef = "AttachmentBottom";

            if (AttachmentRef === "") {
                // still not found, try other ways
                if (pop_item.is_beam) {
                    if (pop_item.typeQQ === "beam3") {
                        //need to find which side its on

                        if (is_portal) {
                            if (pop_item.typeQQ === "beam3") {
                                //need to find which side its on
                                if (pop_item.ref4) {
                                    let ref4 = pop_item.ref4.split("/");
                                    if (toNumber(ref4[1]) < 1000) {
                                        AttachmentRef = "AttachmentBottom";
                                    } else {
                                        AttachmentRef = "AttachmentTop";
                                    }
                                }
                            } else if (pop_item.infill_1_beam !== undefined) {
                                AttachmentRef = "AttachmentLeft";
                            } else if (pop_item.infill_2_beam !== undefined) {
                                AttachmentRef = "AttachmentRight";
                            }
                        } else {
                            if (pop_item.ref4) {
                                let ref4 = pop_item.ref4.split("/");
                                if (toNumber(ref4[0]) < 1000) {
                                    AttachmentRef = "AttachmentLeft";
                                } else {
                                    AttachmentRef = "AttachmentRight";
                                }
                            }
                        }
                    }
                } else if (pop_item.is_infill && is_portal) {
                    if (pop_item.sel_type === "infill_1") {
                        AttachmentRef = "AttachmentLeft";
                    } else {
                        AttachmentRef = "AttachmentRight";
                    }
                }
            }
        }

        if (AttachmentRef === "" && GutterRef != "") {
            if (GutterRef.includes("GutterL")) AttachmentRef = "AttachmentLeft";
            else if (GutterRef.includes("GutterR")) AttachmentRef = "AttachmentRight";
            else if (GutterRef.includes("GutterB")) AttachmentRef = "AttachmentTop";
            else if (GutterRef.includes("GutterF")) AttachmentRef = "AttachmentBottom";
        }

        if (GutterRef === "" && AttachmentRef != "") {
            if (AttachmentRef.includes("Left")) GutterRef = "GutterL";
            else if (AttachmentRef.includes("Right")) GutterRef = "GutterR";
            else if (AttachmentRef.includes("Back") || AttachmentRef.includes("Top")) GutterRef = "GutterB";
            else if (AttachmentRef.includes("Front") || AttachmentRef.includes("Bottom")) GutterRef = "GutterF";
        }
    }

    // let side = "X";
    // if (ref.includes("/")) {
    //     let split = ref.split("/");
    //     ref = split[0];
    //     side = split[1];
    // }
    // let gutter_tag = "GutterF";
    // let attach_tag = "AttachmentTop";
    // if (pop_item.is_cutout) {
    //     if (
    //         !pop_item.ref.includes("unknown") &&
    //         !pop_item.ref.includes("-Attachment") &&
    //         !pop_item.ref.includes("-HasGutter")
    //     )
    //         ref = pop_item.ref + "-Attachment";

    //     if (pop_item?.ref2) {
    //         if (pop_item.ref2.includes(" Y2")) {
    //             if (!ref.endsWith("Y2")) ref += "Y2";
    //             side = "Y2";
    //         } else if (pop_item.ref2.includes(" Y")) {
    //             if (!ref.endsWith("Y")) ref += "Y";
    //             side = "Y";
    //         } else if (pop_item.ref2.includes(" C/")) {
    //             side = "";
    //             gutter_tag = "";
    //             if (pop_item.ref2.startsWith("CB")) gutter_tag = "Back";
    //             else gutter_tag = "Front";
    //             if (pop_item.ref2.includes("L ")) gutter_tag += "Left";
    //             else gutter_tag += "Right";
    //             let index = toNumber(pop_item.ref2.split("/")[1]);
    //             gutter_tag += "-" + pop_item.ref2.split("/")[1] + "-CustomHasGutter";
    //             attach_tag = "";
    //         } else if (pop_item.ref.includes("BackMid")) {
    //             if (pop_item.ref2.includes(" A2") && !ref.endsWith("A2")) ref += "A2";
    //             else if (pop_item.ref2.includes(" A") && !ref.endsWith("A") && !ref.endsWith("A2"))
    //                 ref += "A";
    //         }
    //     }
    // }

    // let cutoutType = area_design_specs?.SHAPE?.CUTOUTS?.[pop_item.ref.split("-")[0] + "-CutoutType"];
    // // let cutoutOverhang = area_design_specs?.SHAPE?.CUTOUTS?.[pop_item.ref.split("-")[0] + "-Overhang"];
    // let cutoutOverhangRef = pop_item.ref.split("-")[0] + "-Overhang";
    // if (gutter_tag.includes("-CustomHasGutter")) {
    //     cutoutOverhangRef = gutter_tag.replace("HasGutter", "Overhang");
    // }
    // let cutoutOverhang = area_design_specs?.SHAPE?.CUTOUTS?.[cutoutOverhangRef];
    // if (!cutoutOverhang) cutoutOverhang = 0;

    // let cutout_overhangValue = pop_textfield_text === null ? cutoutOverhang : pop_textfield_text;

    // if (
    //     pop_item.is_beam &&
    //     pop_item.ref2 &&
    //     (pop_item.ref2.includes("Back/") ||
    //         pop_item.ref2.includes("Front/") ||
    //         pop_item.ref2.includes("Beam/"))
    // ) {
    //     if (pop_item.ref2.includes("Front/")) {
    //         attach_tag = "AttachmentBottom";
    //         gutter_tag = "GutterF";
    //     }
    //     if (pop_item.ref2.includes("Back/")) {
    //         attach_tag = "AttachmentTop";
    //         gutter_tag = "GutterB";
    //     }
    //     if (pop_item.typeQQ === "beam3") {
    //         //need to find which side its on
    //         if (pop_item.ref4) {
    //             let ref4 = pop_item.ref4.split("/");
    //             if (toNumber(ref4[0]) < 1000) {
    //                 attach_tag = "AttachmentLeft";
    //                 gutter_tag = "GutterL";
    //             } else {
    //                 attach_tag = "AttachmentRight";
    //                 gutter_tag = "GutterR";
    //             }
    //         }
    //     }
    // }

    // if (
    //     pop_item.is_attachment ||
    //     pop_item.is_attachment_ghost ||
    //     pop_item.is_attachment_roof ||
    //     pop_item.is_cutout
    // ) {
    //     if (ref !== "unknown") {
    //         attach_tag = ref;
    //         if (pop_item.ref === "AttachmentBottom") gutter_tag = "GutterF";
    //         else if (pop_item.ref === "AttachmentLeft") gutter_tag = "GutterL";
    //         else if (pop_item.ref === "AttachmentRight") gutter_tag = "GutterR";
    //         else if (pop_item.ref === "AttachmentTop") gutter_tag = "GutterB";
    //         else if (cutout && !pop_item.ref2.includes(" C/")) {
    //             gutter_tag = ref.replace("Attachment", "HasGutter");
    //             if (!gutter_tag.endsWith(side)) gutter_tag += side;
    //             attach_tag = attach_tag.replace("HasGutter", "Attachment");
    //         }
    //     }
    // } else if (pop_item.is_gutter || pop_item.is_barge) {
    //     gutter_tag = ref;
    //     if (gutter_tag.startsWith("Attachment")) gutter_tag = gutter_tag.replace("Attachment", "");
    //     if (pop_item.ref === "GutterF") attach_tag = "AttachmentBottom";
    //     else if (pop_item.ref === "GutterL") attach_tag = "AttachmentLeft";
    //     else if (pop_item.ref === "GutterR") attach_tag = "AttachmentRight";
    //     else if (pop_item.ref === "GutterB") attach_tag = "AttachmentTop";
    //     else if (cutout)
    //         attach_tag = ref
    //             .replace("HasGutterX", "Attachment")
    //             .replace("HasGutterY2", "AttachmentY2")
    //             .replace("HasGutterY", "AttachmentY");
    // } else if (pop_item.is_beam && is_portal) {
    //     if (pop_item?.ref2 && pop_item.ref2.includes("Left")) {
    //         attach_tag = "AttachmentLeft";
    //         gutter_tag = "GutterL";
    //     } else if (pop_item?.ref2 && pop_item.ref2.includes("Right")) {
    //         attach_tag = "AttachmentRight";
    //         gutter_tag = "GutterR";
    //     } else if (pop_item.typeQQ === "beam3") {
    //         //need to find which side its on
    //         if (pop_item.ref4) {
    //             let ref4 = pop_item.ref4.split("/");
    //             if (toNumber(ref4[1]) < 1000) {
    //                 attach_tag = "AttachmentBottom";
    //                 gutter_tag = "GutterF";
    //             } else {
    //                 attach_tag = "AttachmentTop";
    //                 gutter_tag = "GutterB";
    //             }
    //         }
    //     } else if (pop_item.infill_1_beam !== undefined) {
    //         attach_tag = "AttachmentLeft";
    //         gutter_tag = "GutterL";
    //     } else if (pop_item.infill_2_beam !== undefined) {
    //         attach_tag = "AttachmentRight";
    //         gutter_tag = "GutterR";
    //     }
    // } else if (pop_item.is_infill && is_portal) {
    //     if (pop_item.sel_type === "infill_1") {
    //         attach_tag = "AttachmentLeft";
    //         gutter_tag = "GutterL";
    //     } else {
    //         attach_tag = "AttachmentRight";
    //         gutter_tag = "GutterR";
    //     }
    // }

    return {
        GutterRef: GutterRef,
        AttachmentRef: AttachmentRef,
        CutoutPrefix: CutoutPrefix,
        IsCutout: IS_CUTOUT,
    };
}

function UpdateComponent(props) {
    const dispatch = useDispatch();
    window.dispatch = dispatch;
    const config = useSelector((state) => state.config);
    const app = useSelector((state) => state.app);
    const threeDMode = useSelector((state) => state.app.designer[APP.THREED_MODE]);
    const threeDMiniMode = useSelector((state) => state.app.designer[APP.THREED_MINI_MODE]);
    const SELECT_POINT = useSelector((state) => state.app.designer.designer2D?.[APP.SELECT_POINT]);
    const AREA_INDEX = useSelector((state) => state.app.designer.designer2D?.[APP.AREA_INDEX]);
    const toolopen = useSelector((state) => state.app.designer.designer3D?.[APP.DRAWER_TOOLSET_EXPANDED]);
    const [last_areaIndex, setlast_areaIndex] = React.useState(-1);
    const [last_loaded_svg_hash, setlast_loaded_svg_hash] = React.useState(null);
    const [debounce2dtimeout, setdebounce2dtimeout] = React.useState(100);

    const job = useSelector((state) => state.job);
    let colour_change = GetColourUpdateString(false, job);
    const svg = useSelector((state) => state.job.App.current_SVG);
    // let svg = get(this.props.app, "designer.designer2D.svgs.area_all");

    //     paper.project.activeLayer.rubberband = new paper.Path(from, middle, to);
    //     var rubberband = paper.project.activeLayer.rubberband;
    //     rubberband.name = "rubberband";
    //     rubberband.strokeColor = 'black';
    //     rubberband.dashArray = [3, 3];
    //     rubberband.visible = false;

    const LoadSVG = (quote_number, svg_filename, zoom_all = false, clear_all = false, load_if_in_error = false) => {
        let this_svg_load_path = quote_number + "/" + svg_filename;
        if (window.last_svg_load_attempt === this_svg_load_path) return; //already try/loaded
        window.svg = null;

        let last_was_layout = window.last_svg_load_attempt.includes("layout.svg");
        if (last_was_layout) zoom_all = true;

        window.last_svg_load_attempt = quote_number + "/" + svg_filename;
        let url_base = API_BASE() + "svg/" + this_svg_load_path;

        if (window.svg_data) {
            url_base = URL.createObjectURL(new Blob([window.svg_data], { type: "image/svg+xml" }));
        }

        paper.project.importSVG(url_base, {
            onLoad: (new_item, svg_raw) => {
                if (!new_item) return;
                new_item.svg_filename = this_svg_load_path;
                new_item.scale(1);
                if (clear_all && paper.project.activeLayer.children.length > 1) {
                    paper.project.activeLayer.removeChildren(0, paper.project.activeLayer.children.length - 1);
                }

                window.svg = new_item;
                Paper.FormatSVGToJob();
                Paper.UpdateAllSVGMaterials();
                Paper.GetMetaData();
                if (zoom_all) Paper.zoomAll();
                window.load_2d_errors = 0;
            },
            onError: (message, status) => {
                console.log("Error Loading SVG", message);
                if (!window.load_2d_errors) window.load_2d_errors = 1;
                else window.load_2d_errors++;
                if (load_if_in_error && window.load_2d_error < 3) dispatch(updateLayout2D());
                else if (clear_all) Paper.ClearAll();
            },
        });
    };

    const UpdateSVGsIfRequired = (svg_filename) => {
        console.log("post UpdateSVGsIfRequired");
        if (!svg_filename) return;

        if (window.svg === null || !window.svg) {
            LoadSVG("local", svg_filename, true, true, true);
        } else if (window.svg.svg_filename === "local/" + svg_filename) {
            Paper.UpdateAllSVGMaterials();
            return; //same file name; ignore
        } else {
            LoadSVG("local", svg_filename, false, true, true);
        }
    };

    // useEffect(() => {
    //     if (SELECT_POINT && toNumber(SELECT_POINT) > 2) {
    //         // console.log("Updating Paper Colours vis COMPONENT");
    //         // Paper.UpdateAllSVGMaterials();

    //         // var from = new paper.Point(0, 0);
    //         // var middle = new paper.Point(0, 0);
    //         // var to = new paper.Point(0, 0);
    //         paper.project.activeLayer.rubberband = new paper.Path();
    //         var rubberband = paper.project.activeLayer.rubberband;
    //         rubberband.name = "rubberband";
    //         rubberband.strokeColor = 'black';
    //         rubberband.dashArray = [3, 3];
    //         rubberband.visible = false;
    //     }
    // }, [SELECT_POINT]);

    useEffect(() => {
        if (window.svg) {
            console.log("Updating Paper Colours vis COMPONENT");
            if (!window.job && job) window.job = { ...job };
            Paper.UpdateAllSVGMaterials();
        }
    }, [colour_change]);

    useEffect(() => {
        console.log(" SVG: ", svg);

        if (!window.job && job) window.job = { ...job };
        if (!svg) {
            window.last_svg_load_attempt = Date.now().toString();
            LoadSVG(job.id, "layout.svg", true, true, true);
        } else if (window.svg_data) {
            // LoadSVGFromData(window.svg_data, job.id + "/" + svg);
        } else {
            UpdateSVGsIfRequired(svg);
        }
        Paper.ForceUpdate();
    }, [svg]);

    let shape_update = GetShapeUpdateString(threeDMode);

    useEffect(() => {
        console.log("shape_update", toolopen, window.shape_update_last);

        if (threeDMode && !threeDMiniMode && toolopen !== APP.BEAMS_AND_POSTS_TOOL) {
        } else if (window.svg && !job?.App?.Locked) {
            setlast_loaded_svg_hash(shape_update);
            update2D();
        }
        window.shape_update_last = shape_update;
    }, [shape_update]);

    useEffect(() => {
        if (window.svg && (!threeDMode || (threeDMode && threeDMiniMode))) {
            // update2DZoom(AREA_INDEX);
            if (last_areaIndex !== AREA_INDEX && AREA_INDEX > -1) {
                dispatch(APP.setDesignerLoadingBackdrop("Loading Area " + (AREA_INDEX + 1) + " Layout..."));
                setlast_areaIndex(AREA_INDEX);
            }
            dispatch(updateLayout2D()).then((result) => {
                setTimeout(
                    function () {
                        Paper.zoomAll(AREA_INDEX > -1 ? 0 : 300);
                    },
                    AREA_INDEX > -1 ? 700 : 1200
                );
                dispatch(APP.updateDesigner(APP.SHOW_LOADING_BACKDROP, false));
                // Paper.zoomAll(AREA_INDEX>-1?0:300);
            });
        }
    }, [AREA_INDEX]);

    const update2D = React.useCallback(
        _debounce((name) => {
            dispatch(updateLayout2D());
            setdebounce2dtimeout(1000);
            setTimeout(function () {
                setdebounce2dtimeout(100);
            }, 1000);
        }, debounce2dtimeout),
        []
    );

    const update2DZoom = React.useCallback(
        _debounce((area_index) => {
            dispatch(updateLayout2D()).then((result) => {
                setTimeout(function () {
                    Paper.zoomAll(area_index > -1 ? 0 : 300);
                }, 500);
                dispatch(APP.updateDesigner(APP.SHOW_LOADING_BACKDROP, false));
                // Paper.zoomAll(AREA_INDEX>-1?0:300);
            });
            setdebounce2dtimeout(1000);
            setTimeout(function () {
                setdebounce2dtimeout(100);
            }, 1000);
        }, debounce2dtimeout),
        []
    );

    useEffect(() => {
        if (!threeDMode || (threeDMode && threeDMiniMode)) {
            Paper.UpdateSkylights2D();
        }
        if ((!threeDMode || (threeDMode && threeDMiniMode)) && last_loaded_svg_hash !== shape_update) {
            // console.log("DISPATCHING UPDATE 3D LAYOUT");
            setlast_loaded_svg_hash(shape_update);
            dispatch(updateLayout2D());
        } else {
        }
    }, [threeDMode, threeDMiniMode]); // eslint-disable-next-line react-hooks/exhaustive-deps

    return <></>;
}

function CoordReporter(props) {
    const [output_coords, setoutput_coords] = React.useState({ x: 0, y: 0 });
    const [event_setup, setevent_setup] = React.useState(false);

    if (paper?.view && !event_setup) {
        paper.view.onMouseMove = (e) => {
            if (e.point) {
                let x = e.point.x;
                let y = e.point.y;
                if (window.paper_origin) {
                    x = x - window.paper_origin.x;
                    y = -(y - window.paper_origin.y);
                }
                setoutput_coords({ x: x, y: y });
            }
        };
        setevent_setup(true);
    }

    return (
        <div
            style={{
                position: "fixed",
                bottom: "6px",
                left: "80px",
            }}
        >
            <span style={{ fontWeight: "600" }}>X:</span>
            {output_coords.x.toFixed()}mm<span style={{ fontWeight: "600" }}> Y:</span>
            {output_coords.y.toFixed()}mm
        </div>
    );
}

const designerStyles = makeStyles({
    iconRoot: {
        textAlign: "center",
        // width: '36px',
        // height: '36px',
        display: "flex",
        alignItems: "center",
    },
    paper: {
        padding: "125px 20px 20px 20px",
        minWidth: "500px",
        maxWidth: "25%",
        backgroundColor: "#EDF0F3",
    },
});

function DesignerTools(props) {
    const classes = designerStyles();

    const dispatch = useDispatch();
    const threeDMode = useSelector((state) => state.app.designer[THREED_MODE]);
    const threeDMiniMode = useSelector((state) => state.app.designer[THREED_MINI_MODE]);
    const obj_area_all = useSelector((state) => state.app.designer?.designer3D?.objs?.area_all);
    const freestanding = useSelector((state) => state?.job?.QuoteParameters?.FreeStanding);
    const showDisplayOptions = useSelector((state) => state.app.designer[SHOW_DISPLAY_OPTIONS]);
    const SELECT_POINT = useSelector((state) => state.app.designer.designer2D?.[APP.SELECT_POINT]);
    const job = useSelector((state) => state?.job);
    const carportMode = job?.DesignParameters?.CarportMode === 1;

    return (
        <div
            style={{
                position: "fixed",
                bottom: "28px",
                left: "98px",
                zIndex: "9",
                display: "flex",
                flexDirection: "row",
                pointerEvents: "none",
            }}
        >
            {!carportMode && (
                <SegmentedButtonGroup
                    value={threeDMode ? (threeDMiniMode ? "Split" : "Model") : "Plan"}
                    disabled={SELECT_POINT}
                    style={{
                        marginRight: "5px",
                        pointerEvents: "all",
                    }}
                    items={[
                        {
                            Key: "Plan",
                            Display: (
                                <>
                                    <Icon className={classes.iconRoot}>
                                        <img
                                            src={BaseURL(
                                                "/images/" + (!threeDMode ? "plan-view-active.svg" : "plan-view.svg")
                                            )}
                                        />
                                    </Icon>
                                    Plan View
                                </>
                            ),
                        },
                        {
                            Key: "Split",
                            Display: (
                                <>
                                    <Icon className={classes.iconRoot}>
                                        <HorizontalSplitIcon />
                                    </Icon>
                                    Split
                                </>
                            ),
                        },
                        {
                            Key: "Model",
                            Display: (
                                <>
                                    <Icon className={classes.iconRoot}>
                                        <img
                                            src={BaseURL(
                                                "/images/" +
                                                    (threeDMode && !threeDMiniMode ? "3d-active.svg" : "3d.svg")
                                            )}
                                        />
                                    </Icon>
                                    Model View
                                </>
                            ),
                        },
                    ]}
                    onChange={(e, val) => {
                        if (val == "Split") {
                            dispatch(APP.updateDesigner(THREED_MODE, true));
                            if (threeDMiniMode === true) dispatch(APP.updateDesigner(THREED_MINI_MODE, "rotated"));
                            else dispatch(APP.updateDesigner(THREED_MINI_MODE, true));
                            if (obj_area_all === null) dispatch(updateLayout2D());
                        } else if (val == "Model") {
                            dispatch(APP.updateDesigner(THREED_MODE, true));
                            dispatch(APP.updateDesigner(THREED_MINI_MODE, false));
                            if (obj_area_all === null) dispatch(updateLayout3D());
                        } else {
                            dispatch(APP.updateDesigner(THREED_MODE, false));
                            dispatch(APP.updateDesigner(THREED_MINI_MODE, false));
                        }
                    }}
                    onClick={(e, val) => {
                        if (val == "Split") {
                            if (threeDMiniMode === true) dispatch(APP.updateDesigner(THREED_MINI_MODE, "rotated"));
                            else dispatch(APP.updateDesigner(THREED_MINI_MODE, true));
                        }
                    }}
                />
            )}
            {/* {threeDMode && */}
            <SegmentedButtonGroup
                value={showDisplayOptions}
                style={{
                    marginRight: "0px",
                    pointerEvents: "all",
                }}
                items={[
                    {
                        Key: true,
                        Display: (
                            <>
                                <TuneIcon style={{ marginRight: "2px" }} /> Display Options
                            </>
                        ),
                    },
                ]}
                onChange={(e, val) => {
                    dispatch(toggleDesigner(SHOW_DISPLAY_OPTIONS));
                }}
            />
            {!freestanding && (
                <div
                    style={{
                        paddingTop: "14px",
                        paddingLeft: "10px",
                        width: "400px",
                        textAlign: "left",
                        fontStyle: "italic",
                        color: threeDMode ? "#cdd3e0" : "#37455f",
                        pointerEvents: "none",
                    }}
                >
                    *Attachment brackets shown are indicative only.
                    <br />
                    Actual location and number to be determined on site by builder.
                </div>
            )}
            {/* } */}
        </div>
    );
}

const viewStyles = makeStyles({
    root: {},
});

function ViewTools(props) {
    const classes = viewStyles();
    const dispatch = useDispatch();
    const threeDMode = useSelector((state) => state.app.designer[THREED_MODE]);
    const threeDMiniMode = useSelector((state) => state.app.designer[APP.THREED_MINI_MODE]);

    return (
        <div
            style={{
                position: "fixed",
                bottom: "80px",
                left: "98px",
                zIndex: "9",
            }}
        >
            <SegmentedButtonGroup
                vertical
                value={""}
                items={[
                    { Key: "Fit", Display: <ZoomOutMapIcon /> },
                    { Key: "ZommIn", Display: <ZoomInIcon /> },
                    { Key: "ZoomOut", Display: <ZoomOutIcon /> },
                ]}
                onChange={(e, val) => {
                    if (threeDMode) {
                        if (val === "ZommIn") zoomIn3D();
                        if (val === "ZoomOut") zoomOut3D();
                        if (val === "Fit") zoomAll3D();
                        if (threeDMiniMode) {
                            if (val === "Fit") Paper.zoomAll();
                            if (val === "ZommIn") Paper.zoomIn();
                            if (val === "ZoomOut") Paper.zoomOut();
                        }
                    } else {
                        if (val === "Fit") Paper.zoomAll();
                        if (val === "ZommIn") Paper.zoomIn();
                        if (val === "ZoomOut") Paper.zoomOut();
                    }
                }}
            />
        </div>
    );
}

class QQ2DCanvas extends React.Component {
    constructor(props) {
        super(props);

        // if (props.item.CuttingData && props.item.CuttingData[props.editing_index] !== undefined) cutting_data = deepCopy(props.item.CuttingData[props.editing_index]);
        this.state = {
            snack_open: false,
            message: "",
            show_pop: false,
            pop_location: { x: 200, y: 400 },
            pop_item: null,
            pop_textfield_text: null,
            OH_Front_text: null,
            OH_Back_text: null,
            mod_attachment_dialog: false,
            mod_attachment2_dialog: false,
            mod_attachment2_saveAction: null,
            mod_attachment_item: null,
            mod_beam_dialog: false,
            mod_beam_item: null,
            mod_beam_posts_dialog: false,
            mod_beam_posts_item: null,
            mod_post_dialog: false,
            mod_post_item: null,
            mod_downpipe_dialog: false,
            mod_downpipe_item: null,
            edit_extra_beam_dialog: false,
            mod_downpipe_item: null,
            beam_adjustment_display_value: null,
            gutter_dialog: false,
        };
    }

    attachSide =
        (areaIndex, attachment_tag, gutter_tag, unattach = false, job, pop_item) =>
        (event) => {
            this.setState({
                show_pop: false,
            });

            let cutout = attachment_tag.startsWith("Back") || attachment_tag.startsWith("Front");
            let attachment_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.ATTACHMENTS;
            let gutter_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES;

            // speciual case handling step cutous
            // if (cutout && job) {
            //     // only applies to step cutouts
            //     // console.log("attachSide attach_item", pop_item);
            //     let cutout_type =
            //         job.AreaSpecifications[areaIndex]?.SHAPE?.CUTOUTS?.[
            //             attachment_tag.replace("-Attachment", "-CutoutType")
            //         ];
            //     if (cutout_type === "Step") {
            //         let l_or_r = attachment_tag.includes("Left") ? "L" : "R";
            //         let f_or_b = attachment_tag.includes("Back") ? "B" : "F";
            //         let side_ref = "C" + f_or_b + l_or_r;
            //         let x_ref = side_ref + " X";
            //         let y_ref = side_ref + " Y";

            //         let paats = job.AreaSpecifications[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;

            //         let side = pop_item?.ref2?.includes(" X") ? "X" : "Y";

            //         if (unattach) {
            //             let ref = side === "X" ? x_ref : y_ref;

            //             let data_paat_x = getItemFromArray(paats, "Ref", x_ref);
            //             let data_paat_y = getItemFromArray(paats, "Ref", y_ref);

            //             if (side === "X" && data_paat_y && data_paat_y.Length === 0) {
            //                 //fully unattach the side
            //                 this.props.deleteFromAreaSpecificationModificationArray(
            //                     areaIndex,
            //                     "ATTACHMENTS.PARTIAL_ATTACHMENTS",
            //                     y_ref,
            //                     false
            //                 );
            //             } else if (side === "Y" && data_paat_x && data_paat_x.Length === 0) {
            //                 //fully unattach the side
            //                 this.props.deleteFromAreaSpecificationModificationArray(
            //                     areaIndex,
            //                     "ATTACHMENTS.PARTIAL_ATTACHMENTS",
            //                     x_ref,
            //                     false
            //                 );
            //             } else {
            //                 //just set this side to partially attached 0;
            //                 let new_data_paat = {
            //                     Ref: ref,
            //                     Name: ref,
            //                     Kind: "AN",
            //                     Length: 0,
            //                     Offset: 0,
            //                     HasGutter: 1,
            //                     HasBeam: 1,
            //                 };
            //                 this.props.updateAreaSpecificationModificationArray(
            //                     areaIndex,
            //                     "ATTACHMENTS.PARTIAL_ATTACHMENTS",
            //                     ref,
            //                     null,
            //                     new_data_paat,
            //                     false
            //                 );
            //                 return;
            //             }
            //         } else {
            //             //attach
            //             // 1 remove all partial attachments
            //             // 2 turn on attachment as below...

            //             if (paats.length > 0) {
            //                 if (side === "Y")
            //                     this.props.deleteFromAreaSpecificationModificationArray(
            //                         areaIndex,
            //                         "ATTACHMENTS.PARTIAL_ATTACHMENTS",
            //                         x_ref,
            //                         false
            //                     );
            //                 if (side === "X")
            //                     this.props.deleteFromAreaSpecificationModificationArray(
            //                         areaIndex,
            //                         "ATTACHMENTS.PARTIAL_ATTACHMENTS",
            //                         y_ref,
            //                         false
            //                     );
            //             }
            //         }
            //     }
            // }

            if (gutter_tag)
                this.props.updateAreaSpecificationJob(
                    areaIndex,
                    gutter_section,
                    cutout ? "CUTOUTS" : null,
                    gutter_tag,
                    unattach ? 1 : 0
                );
            if (attachment_tag)
                this.props
                    .updateAreaSpecificationJob(
                        areaIndex,
                        attachment_section,
                        cutout ? "CUTOUTS" : null,
                        attachment_tag,
                        unattach ? 0 : 1
                    )
                    .then(() => {
                        if (unattach) {
                            this.props
                                .deleteFromAreaSpecificationModificationArray(
                                    areaIndex,
                                    "ATTACHMENTS.AttachmentModifications",
                                    pop_item?.ref2,
                                    true
                                )
                                .then(() => {
                                    this.props.deleteFromAreaSpecificationModificationArray(
                                        areaIndex,
                                        "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                                        pop_item?.ref2,
                                        false
                                    );
                                });
                        }
                    });

            // this.props.updateAreaSpecification(areaIndex, gutter_section, gutter_tag, unattach ? 1 : 0);
            // this.props.updateAreaSpecification(areaIndex, attachment_section, attachment_tag, unattach ? 0 : 1)
        };

    toggleGutter =
        (areaIndex, gutter_tag, unattach = false) =>
        (event) => {
            this.setState({
                show_pop: false,
            });

            let cutout = gutter_tag.startsWith("Back") || gutter_tag.startsWith("Front");
            let gutter_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES;

            this.props.updateAreaSpecificationJob(
                areaIndex,
                gutter_section,
                cutout ? "CUTOUTS" : null,
                gutter_tag,
                unattach ? 1 : 0
            );
        };

    updateGutter = (areaIndex, gutter_tag, value) => {
        this.setState({
            show_pop: false,
        });

        /* DES-1082 - Updated dialog based on gutter selection - Dialog to true on change */
        if (value == 0 || value == 2)
            if (
                (gutter_tag.toUpperCase() === "GUTTERB" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentTop == 1) ||
                (gutter_tag.toUpperCase() === "GUTTERF" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentBottom == 1) ||
                (gutter_tag.toUpperCase() === "GUTTERR" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentRight == 1) ||
                (gutter_tag.toUpperCase() === "GUTTERL" &&
                    this.props.job.AreaSpecifications[areaIndex].ATTACHMENTS.AttachmentLeft == 1)
            ) {
                this.setState({ gutter_dialog: true });
                //DES-1082 - Warning now appears on change to Box/House gutter even after initial warning is accepted.
                this.props.updateAreaSpecification(
                    areaIndex,
                    "Acknowledgements",
                    "BoxHouseGutterAcknowledgement",
                    false
                );
            }

        let cutout = gutter_tag.startsWith("Back") || gutter_tag.startsWith("Front");
        let gutter_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES;

        // console.log("updateGutter", areaIndex, gutter_section, gutter_tag, value);

        this.props.updateAreaSpecificationJob(areaIndex, gutter_section, cutout ? "CUTOUTS" : null, gutter_tag, value);

        return Promise.resolve("OK");
    };

    updateBeamMod =
        (areaIndex, ref, parameter, refresh_svg = true) =>
        (event) => {
            console.log("updateBeamMod");

            this.updateBeamModValue(areaIndex, ref, parameter, refresh_svg, event.target.value);
        };
    updateBeamModValue = (areaIndex, ref, parameter, refresh_svg = true, value = null) => {
        console.log("updateBeamModValue");

        let beam_modifications = get(this.props.job, "AreaSpecifications." + areaIndex + ".BEAMMODIFICATIONS");

        let thisModification = null;
        let lastModification = {};

        if (ref) {
            for (var mod of beam_modifications) {
                if (mod.Ref === ref) thisModification = mod;
                if (mod.Ref === ref) lastModification = { ...mod };
            }
        }

        // if (value === null) value = event.target.value;

        let newValue = value === "Default" ? "" : value;
        if (newValue === "" && thisModification === null) return; // no change, no mods
        else if (thisModification === null) {
            //new mod needed
            thisModification = {};
            thisModification.Ref = ref;

            let ref_split = ref.split(";");

            if (ref_split.length > 1) {
                thisModification.P1 = ref_split[0].replaceAll("/", ",");
                thisModification.P2 = ref_split[1].replaceAll("/", ",");
            }

            if (parameter === "Length" && newValue !== "") thisModification.Length = Number(newValue);
            else thisModification[parameter] = newValue;
            beam_modifications.push(thisModification);
        } else {
            if (parameter === "Length" && newValue !== "") thisModification.Length = Number(newValue);
            else thisModification[parameter] = newValue;
        }

        console.log(JSON.stringify(lastModification));
        console.log(JSON.stringify(thisModification));
        if (JSON.stringify(lastModification) !== JSON.stringify(thisModification)) {
            this.props.updateAreaSpecification(areaIndex, "BEAMMODIFICATIONS", null, beam_modifications);
        }
    };

    updateCustomCutoutValue = (areaIndex, in_ref, value, content_value) => {
        const cutouts = this.props.job?.AreaSpecifications?.[areaIndex]?.SHAPE?.CUTOUTS;
        console.log("updateCustomCutoutValue", areaIndex, in_ref, value, content_value);

        let this_ref = in_ref.replace("-X", "").replace("-Y", "");
        let cutout_section = in_ref.split("-")[0];
        let num_point = toNumber(in_ref.split("-")[1]);

        let diff = null;

        if (num_point === toNumber(cutouts[cutout_section + "-CustomNumSegments"])) {
            // this is the end point, and hende needs to move the previous point
            diff = content_value - value;
            this_ref = cutout_section + "-" + (num_point - 1) + "-CustomPoint";
        }

        let xy = cutouts[this_ref];
        const orig_y = toNumber(xy.split(",")[1]);
        const orig_x = toNumber(xy.split(",")[0]);

        let x = orig_x;
        let y = orig_y;
        if (in_ref.includes("-X")) {
            if (diff !== null) {
                if (orig_x < 0) x += diff;
                else x += diff;
            } else {
                x = value;
                if (orig_x < 0) x = -x;
            }
        } else if (in_ref.includes("-Y")) {
            if (diff !== null) {
                if (orig_y < 0) y -= diff;
                else y += diff;
            } else {
                y = value;
                if (orig_y < 0) y = -y;
            }
        }

        this.props.updateAreaSpecification(areaIndex, "SHAPE.CUTOUTS", this_ref, "(" + x + "," + y + ")");
    };

    updatePAATParameter = (areaIndex, ref, param, value) => {
        let paats = this.props.job?.AreaSpecifications?.[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;

        let thisModification = null;
        if (ref && paats) {
            for (var mod of paats) {
                if (mod.Ref === ref) {
                    thisModification = { ...mod };
                }
            }
        }
        if (thisModification) {
            this.setState({
                show_pop: false,
            });

            thisModification[param] = value;
            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                thisModification.Ref,
                null,
                thisModification
            );
        }
        return Promise.resolve("OK");
    };
    updatePAATValue = (areaIndex, item, value, base_value) => {
        console.log("updatePAATValue", areaIndex, item, value, base_value);
        let paats = this.props.job?.AreaSpecifications?.[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;
        let name = item.ref.split("/")[0];
        let dim_index = Number(item.ref.split("/")[1]);

        let thisModification = null;
        let lastModification = {};
        if (item.ref && paats) {
            for (var mod of paats) {
                if (mod.Name === name) {
                    thisModification = mod;
                    lastModification = { ...mod };
                }
            }
        }
        if (thisModification) {
            let length = thisModification.Length;
            let offset = thisModification.Offset;
            if (thisModification.Kind === "NAN") {
                if (dim_index === 1) {
                    offset = value;
                    length = thisModification.Length - (value - base_value);
                }
                if (dim_index === 2) {
                    length = value;
                }
                if (dim_index === 3) {
                    length = thisModification.Length - (value - base_value);
                }
            } else if (thisModification.Kind === "AN") {
                if (dim_index === 1) {
                    length = value;
                }
                if (dim_index === 2) {
                    length = thisModification.Length - (value - base_value);
                }
            } else if (thisModification.Kind === "NA") {
                if (dim_index === 1) {
                    offset = value;
                    length = thisModification.Length - (value - base_value);
                }
                if (dim_index === 2) {
                    offset = thisModification.OffSet - (value - base_value);
                    length = value;
                }
            }
            if (length < 100) length = 100;
            if (offset < 0) offset = 0;
            thisModification.Length = length;
            thisModification.Offset = offset;
        }

        console.log(JSON.stringify(thisModification));
        if (JSON.stringify(lastModification) !== JSON.stringify(thisModification)) {
            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                thisModification.Ref,
                null,
                thisModification
            );
        }
    };

    updateBeamAdjustment =
        (areaIndex, ref, parameter, refresh_svg = true) =>
        (event) => {
            console.log("updateBeamMod");

            this.updateBeamAdjustmentValue(areaIndex, ref, parameter, refresh_svg, event.target.value);
        };
    updateBeamAdjustmentValue = (areaIndex, ref, parameter, refresh_svg = true, value = null) => {
        console.log("updateBeamAdjustmentValue");

        let beam_adjustments = get(this.props.job, "AreaSpecifications." + areaIndex + ".BEAMADJUSTMENTS");

        let thisModification = null;
        let lastModification = {};

        if (ref) {
            for (var mod of beam_adjustments) {
                if (mod.Ref === ref) thisModification = mod;
                if (mod.Ref === ref) lastModification = { ...mod };
            }
        }

        // if (value === null) value = event.target.value;

        let newValue = value === "Default" ? "" : value;
        if (newValue === "" && thisModification === null) return; // no change, no mods
        else if (thisModification === null) {
            //new mod needed
            thisModification = {};
            thisModification.Ref = ref;

            let ref_split = ref.split("/");

            if (ref_split.length > 1) {
                thisModification.Section = ref_split[0];
                thisModification.Num = Number(ref_split[1]);
            }
            if (parameter === "Adjustment" && newValue !== "") thisModification.Adjustment = Number(newValue);
            else thisModification[parameter] = newValue;
            beam_adjustments.push(thisModification);
        } else {
            thisModification[parameter] = newValue;
        }

        console.log(JSON.stringify(lastModification));
        console.log(JSON.stringify(thisModification));
        if (JSON.stringify(lastModification) !== JSON.stringify(thisModification)) {
            this.props.updateAreaSpecification(areaIndex, "BEAMADJUSTMENTS", null, beam_adjustments);
        }
    };

    updateExtraBeamDimension = (areaIndex, pop_item, val) => {
        let edit_beam = null;
        if (pop_item?.ref) {
            if (areaIndex > -1 && this.props.job.AreaSpecifications[areaIndex]?.NewBeams) {
                edit_beam = getItemFromArray(
                    this.props.job.AreaSpecifications[areaIndex]?.NewBeams,
                    "Ref",
                    pop_item.ref
                );
            } else {
                for (var this_areaIndex in this.props.job.AreaSpecifications) {
                    areaIndex = Number(this_areaIndex);
                    edit_beam = getItemFromArray(
                        this.props.job.AreaSpecifications[areaIndex].NewBeams,
                        "Ref",
                        pop_item.ref
                    );
                    if (edit_beam) break;
                }
            }

            if (edit_beam) {
                let end = 1;
                if (pop_item.offset2 !== undefined) end = 2;
                let new_beam = { ...edit_beam };
                if (end === 1) {
                    new_beam.Offset1 = val;
                    new_beam.From1Side1 = Number(pop_item.side1);
                } else {
                    new_beam.Offset2 = val;
                    new_beam.From1Side2 = Number(pop_item.side2);
                }
                this.props.updateAreaSpecificationModificationArray(
                    areaIndex,
                    "NewBeams",
                    new_beam.Ref,
                    null,
                    new_beam,
                    true
                );
            }
        }
    };

    handleAddDownpipe = (areaIndex, location) => {
        let x = location.x;
        let y = location.y;
        if (window.paper_origin) {
            x = x - window.paper_origin.x;
            y = -(y - window.paper_origin.y);
        }

        let position_text = "(" + x.toFixed(0) + "," + y.toFixed(0) + ",0)";
        let downpipe = {
            Ref: position_text,
            Position: position_text,
            Kind: "Ground - Connection by Owner",
        };
        this.props.updateAreaSpecificationModificationArray(
            areaIndex,
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES + ".Downpipes",
            position_text,
            null,
            downpipe
        );
    };

    handleRemovePortalColumn = (areaIndex, item) => {
        let ref = item.is_beam ? item.ref2 : item.ref4;
        let item_exists = false;
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        if (area_design_specs?.PORTALPOSTS) {
            for (let item of area_design_specs?.PORTALPOSTS) {
                if (item.Ref === ref) item_exists = true;
            }
        }

        if (item_exists) {
            //remove
            this.props.deleteFromAreaSpecificationModificationArray(areaIndex, "PORTALPOSTS", ref);
        } else {
            let ref_split = ref.split("/");
            let portalPost = {
                Ref: ref,
                Section: ref_split[0],
                Num: ref_split[1],
            };
            this.props.updateAreaSpecificationModificationArray(areaIndex, "PORTALPOSTS", ref, null, portalPost);
        }

        this.setState({
            show_pop: false,
        });
    };

    handleSwapPostAlignment = (areaIndex, item) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let mod = null;
        if (area_design_specs?.POSTMODIFICATIONS) {
            for (let this_mod of area_design_specs?.POSTMODIFICATIONS) {
                if (this_mod.Ref === item.ref || this_mod.Ref2 === item.ref2) mod = this_mod;
            }
        }

        if (mod) {
            //update
            mod.SwapAlignment = !mod?.SwapAlignment;
            if (
                !mod.SwapAlignment &&
                !mod.Section &&
                !mod.Colour &&
                !mod.Length &&
                !(mod.TopConnection == undefined || mod.TopConnection === "")
            ) {
                this.props.deleteFromAreaSpecificationModificationArray(areaIndex, "POSTMODIFICATIONS", item.ref, 50);
            } else {
                this.props.updateAreaSpecificationModificationArray(
                    areaIndex,
                    "POSTMODIFICATIONS",
                    item.ref,
                    null,
                    mod
                );
            }
        } else {
            // new mod
            // let ref_split = item.ref.split("/");
            let post_mod = {
                Ref: item.ref,
                Ref2: item.ref2,
                Position: item.ref.replaceAll("/", ","),
                Section: "",
                Colour: "",
                Length: "",
                SwapAlignment: "true",
                TopConnection: "",
            };
            this.props.updateAreaSpecificationModificationArray(
                areaIndex,
                "POSTMODIFICATIONS",
                item.ref,
                null,
                post_mod
            );
        }

        this.setState({
            show_pop: false,
        });
    };

    handleRemoveDownpipe = (areaIndex, location_ref) => {
        // if (typeof location === "string") {
        //     if (location.includes("/")) {
        //         location = {
        //             x: toNumber(location.split("/")[0]),
        //             y: toNumber(location.split("/")[1]),
        //         }
        //     }
        // }
        // if (location?.x === undefined) {
        //     console.log("downpoint location not supplied. Cannot remove");
        //     return;
        // }
        // let x = location.x;
        // let y = location.y;
        // if (window.paper_origin) {
        //     x = x - window.paper_origin.x;
        //     y = -(y - window.paper_origin.y);
        // }
        // let position_text = "(" + x.toFixed(0) + "," + y.toFixed(0) + ",0)";
        this.props.deleteFromAreaSpecificationModificationArray(
            areaIndex,
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES + ".Downpipes",
            location_ref,
            "closest"
        );
    };

    handleDisableAutoDownpipes = (areaIndex) => {
        this.props.updateAreaSpecification(
            areaIndex,
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "AddAutomaticDownpipes",
            false
        );
    };

    handleFootingUpdate = (event, defaultFooting, item) => {
        console.log(event.target.value);
        console.log("defaultFooting", defaultFooting);

        const area_design_specs = this.props.job.AreaSpecifications[item?.areaIndex];

        let error = false;
        let ref = item.is_footing ? item.ref2 : item?.ref5 ? item?.ref5 : item.ref;

        //DES-683 - Bolt to Slab (Internal/External) implementation
        //        - Commented out some code to all footings are added to footings array

        let new_value = event.target.value; //;

        if (new_value === defaultFooting) {
            //delete any modifications
            this.props.deleteFromAreaSpecificationModificationArray(item.areaIndex, "Footings", ref);
        } else {
            // Special case - Merbau Post
            if (new_value === "Bolt to Slab (External Connector)") {
                if (area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostCol === "Merbau") {
                    error = {
                        error: true,
                        title: "Merbau is not available in Flanged.",
                        message: [
                            <>
                                Merbau is not available in Flanged, please select another post colour to change footing
                                type.
                            </>,
                        ],
                    };
                    this.props.showDialog(error?.title ? error?.title : "", error.message ? error?.message : "");
                    return;
                }
                if (
                    window.LYSAGHT &&
                    this.props.config.post_types[area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType]
                        .allow_flanged === false
                ) {
                    error = {
                        error: true,
                        title: `'${
                            area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType
                        }' is not available in Flanged.`,
                        message: [
                            <>
                                Post Type is not available in Flanged, please select another post colour to change
                                footing type.
                            </>,
                        ],
                    };
                    this.props.showDialog(error?.title ? error?.title : "", error.message ? error?.message : "");
                    return;
                }
            }

            let this_footing_text = new_value;
            let this_footing_mod = {
                Ref: ref,
                Ref2: item.ref2,
                Position: ref.replaceAll("/", ","),
                Kind: this_footing_text.includes("Concrete") ? "Concrete In" : "Bolt to Slab",
                Connector: this_footing_text.includes("External") ? 2 : this_footing_text.includes("Internal") ? 1 : 0,
            };
            this.props.updateAreaSpecificationModificationArray(
                item.areaIndex,
                "Footings",
                this_footing_mod.Ref,
                null,
                this_footing_mod
            );
        }
        // this.togglePop(false);
        // onChange={this.updateData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "FootingType", true)}
    };

    matchAllFootingInThisArea = (footingType, areaIndex) => {
        let new_footingTypeSetting = "Concrete In";
        let new_PostExternalConnectors = 0;
        if (footingType.includes("Slab")) {
            new_footingTypeSetting = "Bolt to Slab";
            if (footingType.includes("External")) new_PostExternalConnectors = 1;
        }
        this.props.updateAreaSpecification(
            areaIndex,
            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            "FootingType",
            new_footingTypeSetting
        );
        this.props.updateAreaSpecification(
            areaIndex,
            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            "PostExternalConnectors",
            new_PostExternalConnectors
        );
        this.props.updateAreaSpecification(areaIndex, "Footings", null, []);
        this.togglePop(false);
    };

    updateData =
        (areaIndex, section, parameter, refresh_svg = true) =>
        (event) => {
            console.log("updateData", areaIndex, section, parameter, event.target.value, refresh_svg);
            this.setState({
                show_pop: false,
            });

            this.props.updateAreaSpecification(areaIndex, section, parameter, event.target.value);
        };

    updateAreaSpecification =
        (areaIndex, section, parameter, value, refresh_svg = true, turn_off_pop = true) =>
        (event) => {
            this.updateAreaSpecificationValue(areaIndex, section, parameter, value, refresh_svg, turn_off_pop);
        };

    updateAreaSpecificationValue = (areaIndex, section, parameter, value, refresh_svg = true, turn_off_pop = true) => {
        console.log("updateAreaSpecification", areaIndex, section, parameter, value, refresh_svg);
        if (turn_off_pop)
            this.setState({
                show_pop: false,
            });

        this.props.updateAreaSpecification(areaIndex, section, parameter, value);
    };

    handle_add_deck_brace = (pop_item, areaIndex, brace_type) => {
        const area_design_specs = this.props.job.AreaSpecifications?.[areaIndex];
        let new_bracing_array = [];
        if (area_design_specs?.DECK_PARAMETERS?.DeckBracing)
            new_bracing_array = [...area_design_specs.DECK_PARAMETERS.DeckBracing];
        let new_brace = {};

        let position_text = "(0,0,0)";
        if (pop_item.click_point) {
            let x = pop_item.click_point.x;
            let y = pop_item.click_point.y;
            if (window.paper_origin) {
                x = x - window.paper_origin.x;
                y = -(y - window.paper_origin.y);
            }

            position_text = "(" + -y.toFixed(0) + "," + x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
        } else if (pop_item?.ref4) {
            let midpoint = midPointRef(pop_item?.ref4);
            position_text = "(" + -midpoint.y.toFixed(0) + "," + midpoint.x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
        }

        console.log("position_text", position_text);
        if (position_text === "(0,0,0)") return;

        new_brace.ref_point = position_text;
        new_brace.type = brace_type;
        new_brace.beam_ref = pop_item?.ref2;
        new_bracing_array.push(new_brace);

        this.props.updateAreaSpecification(areaIndex, "DECK_PARAMETERS", "DeckBracing", new_bracing_array);
    };

    deHover = () => {
        if (_this.last_hover) {
            _this.last_hover.shadowColor = null;
            _this.last_hover.shadowBlur = 0;
            if (_this.last_hover.fillColor)
                _this.last_hover.fillColor.alpha = _this.last_hover.fillColorAlpha_o
                    ? _this.last_hover.fillColorAlpha_o
                    : 1;
            _this.last_hover = null;
            if (_this.last_hover_matches) {
                _this.last_hover_matches.forEach(function (item_match) {
                    item_match.shadowColor = null;
                    item_match.shadowBlur = 0;
                    if (item_match.fillColor)
                        item_match.fillColor.alpha = item_match.fillColorAlpha_o ? item_match.fillColorAlpha_o : 1;
                });
            }
        }
    };

    toggleMod_attachment_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_attachment_dialog: open,
            mod_attachment_item: item,
        });
    };

    toggleMod_attachment2_dialog = (open, item, saveAction = null) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_attachment2_dialog: open,
            mod_attachment_item: item,
            mod_attachment2_saveAction: saveAction,
        });
    };

    toggleMod_beam_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_beam_dialog: open,
            mod_beam_item: item,
        });
    };

    toggleEdit_extra_beam_dialog = (open) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            edit_extra_beam_dialog: open,
        });
    };

    toggleMod_beam_posts_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_beam_posts_dialog: open,
            mod_beam_posts_item: item,
        });
    };

    toggleMod_post_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_post_dialog: open,
            mod_post_item: item,
        });
    };

    toggleMod_downpipe_dialog = (open, item) => {
        if (!open) this.togglePop(false);
        this.setState({
            show_pop: false,
            mod_downpipe_dialog: open,
            mod_downpipe_item: item,
        });
    };

    togglePop = (show, x, y, pop_item) => {
        //console.log("pop_item", pop_item?.typeQQ, pop_item);
        if (!show && _this.selected_item) {
            paper.project.deselectAll();
            _this.selected_item = null;

            wipe_start_end_marks();
            this.deHover();
        }
        this.setState({
            show_pop: show,
            pop_location: {
                x: x,
                y: y,
            },
            pop_item: pop_item,
            pop_textfield_text: null,
            OH_Front_text: null,
            OH_Back_text: null,
            beam_adjustment_display_value: null,
        });
    };

    setMessage = (open, message) => {
        this.setState({
            open: open,
            message: message,
        });
    };

    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.props.toggleDesigner(SHOW_MESSAGE);
        // this.setMessage(false, "");
    };

    handleClick = () => {
        this.setMessage(true, "");
    };

    componentDidMount() {
        // console.log("mounting");
        this.InitialisePaper("qqCanvas");

        // this.UpdateSVGsIfRequired({"area_all":"layout.svg"});

        // this.ClearAndLoadSVG(this.props.job.id, "layout.svg");

        // let svg = get(this.props.job, "QuoteParameters.ENGINEERING.svg");
        // if (svg)
        // {
        //     // Paper.ForceUpdate();
        //     // let blob = new Blob([svg], {type: 'image/svg+xml'});
        //     // var svg_url = URL.createObjectURL(blob);
        //     this.UpdateSVGsIfRequired({"area_all":svg});
        // }
        // this.props.updateLayout(this.props.job);

        if (this.props.visible) {
            let svg = get(this.props.app, "designer.designer2D.svgs.area_all");
            if (!window.job && this.props.job) window.job = { ...this.props.job };
            if (this.props?.job?.id) {
                this.LoadSVG(this.props.job.id, "layout.svg", true, true);
            } else {
                this.UpdateSVGsIfRequired(svg);
            }
            Paper.ForceUpdate();
        }
    }
    componentDidUpdate() {
        // const { app } = this.props;
        // const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
        // if (this.state?.pop_item?.is_point) {
        //     if (SELECT_POINT) {
        //         console.log("SEELECT");
        //         console.log(this.state.pop_item);
        //     }
        // }
        // if (this.props.visible) {
        //     let svg = get(this.props.app, "designer.designer2D.svgs.area_all");
        //     if (!svg) {
        //         this.LoadSVG(this.props.job.id, "layout.svg", true, true);
        //     }
        //     else {
        //         this.UpdateSVGsIfRequired(svg);
        //     }
        //     Paper.ForceUpdate();
        // }
    }

    isPostRHS(popItem, areaIndex) {
        const areaSpecs = this.props?.job?.AreaSpecifications?.[areaIndex];
        const designType = areaSpecs?.SHAPE?.DesignType;

        let isRHS = false;
        let ref;
        let postType;

        // Get popItem reference. Which property we choose depends on whether the user clicked a post or footing
        if (popItem?.is_footing) {
            ref = popItem?.ref2;
        } else if (popItem?.ref5) {
            ref = popItem?.ref5;
        } else {
            ref = popItem?.ref;
        }

        // Get post type. Must account for possible post modifications
        if (areaSpecs?.POSTMODIFICATIONS) {
            const modifiedPost = areaSpecs?.POSTMODIFICATIONS.find((item) => item.Ref === ref);
            postType = modifiedPost ? modifiedPost?.Section : areaSpecs?.BEAMS_AND_POSTS?.PostType;
        } else {
            postType = areaSpecs?.BEAMS_AND_POSTS?.PostType;
        }

        // Check if post is RHS
        if (postType) {
            const designOptions = this.props?.config?.design_options?.[designType];
            const optionsRHS = designOptions?.post?.options["Box with RHS Insert"];
            isRHS = optionsRHS?.includes(postType);
        }

        return isRHS;
    }

    render() {
        const {
            open,
            message,
            show_pop,
            pop_location,
            pop_item,
            pop_textfield_text,
            OH_Front_text,
            OH_Back_text,
            beam_adjustment_display_value,
        } = this.state;
        const { classes, config, app, job } = this.props;
        const carportMode = job?.DesignParameters?.CarportMode === 1;
        const THREED_MODE = app.designer[APP.THREED_MODE];
        const THREED_MINI_MODE = app.designer[APP.THREED_MINI_MODE];
        const TOOL_DRAWER_WIDTH = app.designer[APP.TOOL_DRAWER_WIDTH];
        const modelFileName = app.designer.designer3D.objs.area_all;
        const BACKGROUND_MODE = app.designer.designer3D[APP.BACKGROUND_MODE];
        const SHOW_GRAPH_BG = app.designer.designer2D[APP.SHOW_GRAPH_BG];
        const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
        const UNLOCKED = app.designer[APP.UNLOCKED];

        const locked =
            ((job?.OrderStatus === "PENDING" || job?.OrderStatus === "ACCEPTED" || this.props?.job?.App?.Locked) &&
                !UNLOCKED) ||
            carportMode;

        window.job = { ...job };
        window.app = { ...app };
        window.THREED_MODE = THREED_MODE;
        window.THREED_MINI_MODE = THREED_MINI_MODE;

        let edit_item = null;
        let areaIndex = pop_item?.areaIndex !== undefined ? Number(pop_item?.areaIndex) : 0;

        let pop_menu_items = [];
        let pop_menu_items_details = [];
        let pop_alignment = "left";
        if (pop_location.x < window.innerWidth * 0.3) pop_alignment = "left";
        if (pop_location.x > window.innerWidth * 0.6) pop_alignment = "right";

        let is_cyclonic = false;
        let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
        if (region === "C" || region === "D") {
            is_cyclonic = true;
        }

        if (pop_item && pop_item.ref && locked) {
            if (pop_item.is_point) {
            } else {
            }
        } else if (pop_item && pop_item.ref && !locked) {
            console.log(pop_item);
            if (areaIndex < 0) areaIndex = 0;
            const area_design_specs = job.AreaSpecifications?.[areaIndex];
            const DesignType = area_design_specs?.SHAPE?.DesignType;

            let is_portal = DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;
            let is_flat = DesignType === CONFIG.DESIGN_TYPES.FLAT;

            let show_front_back_overhangs = false;

            wipe_start_end_marks();

            // if (pop_item.material && pop_item.material === "Centenary Box Gutter") {
            //     pop_menu_items.push(<Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>Modify Box Gutter</Typography>);
            //     pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, pop_item.ref, 1)}>Switch to Normal Gutter</MenuItem>);
            //     pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, pop_item.ref, 0)}>Turn Gutter Off</MenuItem>);
            // }
            // else if (pop_item.is_gutter) {
            //     pop_menu_items.push(<Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>Modify Gutter</Typography>);
            //     pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, pop_item.ref, 2)}>Switch to Box Gutter</MenuItem>);
            //     pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, pop_item.ref, 0)}>Turn Gutter Off</MenuItem>);
            // }
            if (pop_item.is_point && DesignType !== CONFIG.DESIGN_TYPES.DECK) {
                pop_menu_items.push(
                    <MenuItem
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.toggleMod_downpipe_dialog(true, pop_item);
                        }}
                    >
                        Add Downpipe...
                    </MenuItem>
                );
            } else if (pop_item.is_note) {
                if (areaIndex > -1 && job.AreaSpecifications[areaIndex]?.DrawingNotes) {
                    edit_item = getItemFromArray(job.AreaSpecifications[areaIndex]?.DrawingNotes, "Ref", pop_item.ref);
                } else {
                    for (var this_areaIndex in job.AreaSpecifications) {
                        areaIndex = Number(this_areaIndex);
                        edit_item = getItemFromArray(
                            job.AreaSpecifications[areaIndex].DrawingNotes,
                            "Ref",
                            pop_item.ref
                        );
                        if (edit_item) break;
                    }
                }
            } else if (pop_item.is_slat || pop_item.sel_type === "slat_label") {
                // let pt = "0,0";
                // let pt2 = "0,0";
                // if (pop_item.segments?.[0]?.point) {
                //     let point = window.origin_convert(pop_item.segments?.[0]?.point);
                //     let point = pop_item.segments?.[0]?.point;
                //     pt = point.x + "," + point.y;
                // }
                // if (pop_item.segments?.[1]?.point) {
                //     let point = window.origin_convert(pop_item.segments?.[1]?.point);
                //     let point = pop_item.segments?.[1]?.point;
                //     pt2 = point.x + "," + point.y;
                // }
                if (areaIndex > -1 && job.AreaSpecifications[areaIndex]?.SlatPanels) {
                    edit_item = getItemFromArray(job.AreaSpecifications[areaIndex]?.SlatPanels, "Ref", pop_item.ref);
                    if (!edit_item)
                        getItemFromArray(job.AreaSpecifications[areaIndex]?.SlatPanels, "Ref", pop_item.ref);
                } else {
                    for (var this_areaIndex in job.AreaSpecifications) {
                        areaIndex = Number(this_areaIndex);
                        edit_item = getItemFromArray(job.AreaSpecifications[areaIndex].SlatPanels, "Ref", pop_item.ref);
                        if (edit_item) break;
                    }
                    if (!edit_item)
                        for (var this_areaIndex in job.AreaSpecifications) {
                            areaIndex = Number(this_areaIndex);
                            edit_item = getItemFromArray(
                                job.AreaSpecifications[areaIndex].SlatPanels,
                                "Ref",
                                pop_item.ref
                            );
                            if (edit_item) break;
                        }
                }
            }
            // if (pop_item.is_cutout) {
            //     let cutoutType = area_design_specs.SHAPE.CUTOUTS[pop_item.ref + "-CutoutType"];
            //     pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }}>Cutout Type :&nbsp;
            //         <AreaSelectField
            //                 value={cutoutType}
            //                 dark
            //                 items={["None", "Angle", "Step"]}
            //                 clip_overflow
            //                 onChange={(e) => {
            //                     // this.handleFootingUpdate(e, default_FootingType, pop_item)
            //                     this.togglePop(false);
            //                     this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS", pop_item.ref + "-CutoutType", e.target.value);
            //                 }}
            //             /></MenuItem>);
            // }
            else if (pop_item.is_downpipe) {
                if (pop_item.ref === "Auto")
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handleDisableAutoDownpipes(areaIndex);
                            }}
                        >
                            Remove All Auto Added Downpipes
                        </MenuItem>
                    );
                else if (pop_item.ref)
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.handleRemoveDownpipe(areaIndex, pop_item.ref);
                            }}
                        >
                            Remove Downpipe
                        </MenuItem>
                    );
            } else if (pop_item.ref && pop_item.is_dimension) {
                let section = this.props.job.AreaSpecifications[areaIndex].SHAPE;
                let this_ref = pop_item.ref;
                if (this_ref === "Length OD" || this_ref === "Length OG") this_ref = "Length";
                if (this_ref === "Depth OD" || this_ref === "Depth OG") this_ref = "Depth";
                if (this_ref === "Flyover Length") this_ref = "Length";

                let attribute = this_ref;
                let subSection = null;

                console.log(section);
                console.log(this_ref);
                console.log(pop_item);

                if (["JoinAngle", "JoinOffset"].includes(pop_item.ref)) {
                    section = section.AREAJOIN;
                    // attribute = attribute;
                    subSection = "AREAJOIN";
                }
                if (attribute.includes("-") && (attribute.startsWith("Back") || attribute.startsWith("Front"))) {
                    section = section.CUTOUTS;
                    // attribute = "CUTOUTS." + attribute;
                    subSection = "CUTOUTS";
                }

                let is_beam_adjustment = false;
                let is_extra_beam = false;
                let is_paat = false;
                let is_cutout_custom = false;
                if (pop_item.typeQQ.includes("/paat")) is_paat = true;
                else if (pop_item.typeQQ.includes("/extrabeam")) is_extra_beam = true;
                else if (pop_item.typeQQ.includes("/cutout") && pop_item.ref.includes("CustomPoint"))
                    is_cutout_custom = true;
                else if (pop_item.ref.includes("/")) is_beam_adjustment = true;

                let base_value = toNumber(section[this_ref] ? section[this_ref] : pop_textfield_text);
                let display_value = pop_textfield_text === null ? section[pop_item.ref] : pop_textfield_text;
                if (display_value === "-" && is_beam_adjustment) {
                } else if (display_value !== "")
                    display_value = toNumber(display_value, is_beam_adjustment ? true : false);
                let adjustment_value = 0;
                let content_value = display_value;
                if (pop_item.content) {
                    content_value = toNumber(pop_item.content, is_beam_adjustment ? true : false);
                }
                if (pop_textfield_text === null && content_value) {
                    display_value = toNumber(content_value, is_beam_adjustment ? true : false);
                }

                let extra_beam_offset = -1;
                if (is_extra_beam) {
                    if (pop_item.offset1 !== undefined) extra_beam_offset = Number(pop_item.offset1);
                    if (pop_item.offset2 !== undefined) extra_beam_offset = Number(pop_item.offset2);
                    base_value = Number(extra_beam_offset);
                }

                if (content_value !== base_value) adjustment_value = content_value - base_value;
                // console.log("display_value", display_value);
                // console.log("pop_item.ref]", pop_item.ref);
                // console.log("base_value", base_value);
                // console.log("adjustment_value", adjustment_value);
                // console.log("content_value", content_value);

                if (is_beam_adjustment) {
                    adjustment_value = 0;
                    if (pop_textfield_text === null) {
                        let beam_adjustments = get(
                            this.props.job,
                            "AreaSpecifications." + areaIndex + ".BEAMADJUSTMENTS"
                        );
                        let thisModification = null;
                        for (var mod of beam_adjustments) {
                            if (mod.Ref === pop_item.ref && mod.Adjustment) {
                                display_value = mod.Adjustment;
                            }
                        }
                    }
                }

                let design_option = config.design_options[DesignType];

                let max_side_overhang =
                    area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
                let min_side_overhang =
                    area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_side_overhang;

                // let min;
                // let max;
                let name = is_extra_beam ? "Extra Beam Offset" : pop_item.ref;
                if (is_paat) name = "Partial Attachment - " + name;

                let range = {
                    min: 0,
                    max: 20000,
                    default: 0,
                };

                if (this_ref === "Length") {
                    range.min = 200;
                    range.max = 30000;
                    if (design_option?.length_range) range = { ...range, ...design_option.length_range };
                }
                if (this_ref === "Depth") {
                    range.min = 300;
                    range.max = 12000;
                    if (design_option?.depth_range) range = { ...range, ...design_option.depth_range };
                }
                if (this_ref === "Height") {
                    range.min = 2100;
                    range.max = 4000;
                    if (design_option?.height_range) range = { ...range, ...design_option.height_range };
                }
                if (this_ref === "OH_Left" || this_ref === "Frame_OH_Left") {
                    name = "Left Overhang";
                    range.min = 0;
                    range.max = 1000;
                    if (design_option?.overhang_left_range) range = { ...range, ...design_option.overhang_left_range };

                    if (min_side_overhang) range.min = min_side_overhang;
                    if (max_side_overhang) range.max = max_side_overhang;

                    if (is_portal && this_ref === "Frame_OH_Left") {
                        name = "Left Frame Overhang";
                        range.max = design_option?.max_frame_overhang ? design_option?.max_frame_overhang : 1200;
                    }
                }
                if (this_ref === "OH_Right" || this_ref === "Frame_OH_Right") {
                    name = "Right Overhang";
                    range.min = 0;
                    range.max = 1000;
                    if (design_option?.overhang_right_range)
                        range = { ...range, ...design_option.overhang_right_range };

                    let min_side_overhang =
                        this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]
                            ?.RoofSheetData?.min_side_overhang;
                    if (min_side_overhang) range.min = min_side_overhang;
                    if (max_side_overhang) range.max = max_side_overhang;

                    if (is_portal && this_ref === "Frame_OH_Right") {
                        name = "Right Frame Overhang";
                        range.max = design_option?.max_frame_overhang ? design_option?.max_frame_overhang : 1200;
                    }
                }

                let max_overhang =
                    this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData
                        ?.max_overhang;

                let max_frontback_end_span =
                    this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData
                        ?.max_frontback_end_span;

                if (pop_item.ref === "OH_Back") {
                    let min_front_overhang =
                        this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]
                            ?.RoofSheetData?.min_front_overhang;

                    name = "Back Overhang";
                    range.min = 0;
                    range.max = max_frontback_end_span !== undefined ? max_frontback_end_span : 200;
                    if (design_option?.overhang_back_range) range = { ...range, ...design_option.overhang_back_range };
                    if (min_front_overhang)
                        range.min =
                            max_frontback_end_span < min_front_overhang ? max_frontback_end_span : min_front_overhang;
                    if (max_frontback_end_span) range.max = max_frontback_end_span;
                }
                if (pop_item.ref === "OH_Front") {
                    let min_front_overhang =
                        this.props.job.AreaSpecifications[areaIndex]?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]
                            ?.RoofSheetData?.min_front_overhang;

                    console.log(max_frontback_end_span);
                    name = "Front Overhang";
                    range.min =
                        min_front_overhang !== undefined
                            ? max_frontback_end_span < min_front_overhang
                                ? max_frontback_end_span
                                : min_front_overhang
                            : 0;
                    range.max = max_frontback_end_span !== undefined ? max_frontback_end_span : 200;
                    if (design_option?.overhang_front_range)
                        range = { ...range, ...design_option.overhang_front_range };

                    if (min_front_overhang)
                        range.min =
                            max_frontback_end_span < min_front_overhang ? max_frontback_end_span : min_front_overhang;
                    if (max_frontback_end_span) range.max = max_frontback_end_span;
                }

                let ref = this_ref;
                if (DesignType === CONFIG.DESIGN_TYPES.DECK) {
                    console.log("ref", ref);
                    ref = ConvertCutoutNameForDecks(ref);
                    if (ref.includes("-WidthX")) ref = ref.replace("-WidthX", "-WidthY");
                    else if (ref.includes("-WidthY")) ref = ref.replace("-WidthY", "-WidthX");
                }

                if (ref.includes("-Offset")) {
                    name = ref.replace("-Offset", " Offset");
                    range.min = 500;
                    range.max = 20000;
                    if (design_option?.length_range) range = { ...range, ...design_option.length_range };
                }
                if (ref.includes("WidthX")) {
                    name = ref.replace("-WidthX", " Cutout Length");
                    range.min = 500;
                    range.max = 20000;
                    if (design_option?.length_range) range = { ...range, ...design_option.length_range };
                }
                if (ref.includes("WidthY")) {
                    name = ref.replace("-WidthY", " Cutout Width");
                    range.min = 300;
                    range.max = 12000;
                    if (design_option?.depth_range) range = { ...range, ...design_option.depth_range };
                }

                range = replaceVariables(area_design_specs, range);

                if (is_extra_beam) {
                    range.min = 0;
                    range.max = 20000;
                }

                if (is_cutout_custom) {
                    const cutouts = this.props.job?.AreaSpecifications?.[areaIndex]?.SHAPE?.CUTOUTS;
                    let cutout_side = ref.split("-")[0];
                    range.max = toNumber(cutouts[cutout_side + "-Width" + (ref.includes("-X") ? "X" : "Y")]);
                    range.min = -range.max;
                }

                if (subSection === "AREAJOIN") {
                    // Modify max range for join areas
                    range.min = 0;
                    range.max = toNumber(this.props.job?.AreaSpecifications?.[areaIndex]?.SHAPE?.Depth);
                    if (this.props.job?.AreaSpecifications.length > 1) {
                        if (this.props.job?.AreaSpecifications.length > 0) {
                            if (base_value > 0) {
                                range.max = toNumber(this.props.job?.AreaSpecifications?.[areaIndex + 1]?.SHAPE?.Depth);
                            }
                        }
                    }
                }

                // if (max === "Area.ROOF_SHEETING.RoofSheetData.max_overhang") {
                //     max = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang;
                // }
                // if (max === undefined) max = 20000;
                // if (min === "Area.ROOF_SHEETING.RoofSheetData.max_overhang") min = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang;
                // if (min === undefined) min = 0;

                pop_menu_items.push(
                    <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                        Modify {name}
                    </Typography>
                );
                // pop_menu_items.push(<TextField
                //     value={display_value}
                //     style={{ color: "black", width: "100%", paddingLeft: "10px" }}
                //     // autoFocus={true}
                //     InputProps={{
                //         endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                //     }}
                //     onFocus={event => {
                //         event.target.select()
                //     }}
                //     onBlur={(e) => {
                //         if (is_beam_adjustment) {
                //             this.updateBeamAdjustmentValue(areaIndex, pop_item.ref, "Adjustment", true, Number(e.target.value));
                //         }
                //         else {
                //             if (Number(e.target.value) - adjustment_value === base_value) return;
                //             this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, attribute, Number(e.target.value) - adjustment_value);
                //         }
                //     }}
                //     onKeyPress={(e) => {
                //         if (e.key === "Enter") {
                //             this.togglePop(false);
                //             e.target.blur();
                //         }
                //     }}
                //     onChange={(e) => {
                //         this.setState({ pop_textfield_text: e.target.value });
                //         // this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, pop_item.ref, e.target.value);
                //     }}
                // />);
                pop_menu_items.push(
                    <BSL_TextInput
                        // helperText={is_extra_beam?<></>:null}
                        value={display_value}
                        style={{ color: "black", width: "100%", padding: "5px 10px 5px 10px" }}
                        autoFocus={true}
                        selectAll={true}
                        endAdornment="mm"
                        min={range.min}
                        max={range.max}
                        tooltipDelay={500}
                        onFocus={(event) => {
                            event.target.select();
                        }}
                        onBlur={(val) => {
                            if (is_cutout_custom) {
                                let base_val = content_value;
                                // if (base_val > range.max) base_val = range.max;
                                // if (base_val < range.min) base_val = range.min;
                                this.updateCustomCutoutValue(areaIndex, pop_item.ref, Number(val), base_val);
                            } else if (is_paat) {
                                this.updatePAATValue(areaIndex, pop_item, Number(val), content_value);
                            } else if (is_beam_adjustment) {
                                this.updateBeamAdjustmentValue(
                                    areaIndex,
                                    pop_item.ref,
                                    "Adjustment",
                                    true,
                                    Number(val)
                                );
                            } else if (is_extra_beam) {
                                if (Number(val) - adjustment_value === base_value) return;
                                this.updateExtraBeamDimension(areaIndex, pop_item, Number(val) - adjustment_value);
                            } else {
                                if (Number(val) - adjustment_value === base_value) return;

                                let value = Number(val) - adjustment_value;

                                if (subSection && subSection === "AREAJOIN" && base_value < 0) {
                                    value = -Number(val); // Negative base value, return negative change
                                }
                                this.props.updateAreaSpecificationJob(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    subSection,
                                    attribute,
                                    value
                                );
                            }
                        }}
                        onKeyPress={(e) => {
                            if (e.key === "Enter") {
                                this.togglePop(false);
                                e.target.blur();
                                //DES-808 - Added funcitonality to change cutout value from pop-up
                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    "CUTOUTS." + pop_item.ref,
                                    e.target.value
                                );
                            }
                        }}
                        onChange={(val) => {
                            this.setState({ pop_textfield_text: val });
                            // this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, pop_item.ref, e.target.value);
                        }}
                    />
                    //     <TextField
                    //     className={classNames}
                    //     id={props.dataField}
                    //     label={label}
                    //     value={value}
                    //     error={error ? true : false}
                    //     helperText={error ? error : (helperText ? helperText : "")}
                    //     // onChange={(e) => {updateAreaSpecification(props.areaIndex, props.section, (props.subsection ? props.subsection + "." : "") + props.dataField, e.target.value); updateSVG()}}
                    //     onChange={(e) => (onChange?onChange(e):null)}
                    //     onBlur={(e) => (onBlur?onBlur(e):null)}
                    //     onKeyPress={(e) => (onKeyPress?onKeyPress(e):null)}
                    //     // onBlur={(e) => validateJobState(props.section, (props.subsection ? props.subsection + "." : "") + props.dataField, e.target.value)}
                    //     FormHelperTextProps={{ className: classes.helper }}
                    //     InputProps={{
                    //         endAdornment: (endAdornment ? endAdornment : ""),
                    //         style: combined_input_style
                    //     }}
                    //     InputLabelProps={{
                    //         style: (labelStyle ? labelStyle : { color: "#b4bdff" }),
                    //     }}
                    //     FormHelperTextProps={{
                    //         style: (helperTextStyle ? helperTextStyle : {
                    //             color: "#FFEB3B",
                    //             fontStyle: "italic"
                    //         }),
                    //     }}

                    // />
                );
            } else if (DesignType === CONFIG.DESIGN_TYPES.DECK) {
                if (
                    (pop_item.is_attachment ||
                        pop_item.is_attachment_ghost ||
                        pop_item.is_gutter ||
                        pop_item.is_attachment_roof ||
                        pop_item.is_barge ||
                        pop_item.is_cutout) &&
                    pop_item.ref
                ) {
                    const area_design_specs = get(job, "AreaSpecifications." + areaIndex);
                    let ref_data = GetRefs(pop_item, area_design_specs);

                    console.log("REFS", ref_data);
                    let ref = pop_item.ref;
                    let cutout = ref_data.IsCutout;
                    let gutter_tag = ref_data.GutterRef;
                    let attach_tag = ref_data.AttachmentRef;

                    // let attach_tag = "AttachmentTop";
                    // if (pop_item.is_cutout) {
                    //     ref = pop_item.ref + "-Attachment";
                    // }

                    // let cutout =
                    //     pop_item.ref.startsWith("Back") || pop_item.ref.startsWith("Front") || pop_item.is_cutout;

                    // if (
                    //     pop_item.is_attachment ||
                    //     pop_item.is_attachment_ghost ||
                    //     pop_item.is_attachment_roof ||
                    //     pop_item.is_cutout
                    // ) {
                    //     attach_tag = ref;
                    // }

                    let side_is_attached;
                    if (cutout)
                        side_is_attached = get(
                            area_design_specs,
                            BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS." + attach_tag
                        );
                    else side_is_attached = get(area_design_specs, BASIC_SPECS_SECTIONS.ATTACHMENTS + "." + attach_tag);

                    pop_menu_items.push(
                        <Typography
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Modify Deck Attachments
                        </Typography>
                    );
                    if (cutout) {
                        let cutoutType = "";
                        if (pop_item.ref) {
                            cutoutType = area_design_specs.SHAPE.CUTOUTS[pop_item.ref.split("-")[0] + "-CutoutType"];
                        }

                        // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }}>Cutout Type :&nbsp;
                        //     <AreaSelectField
                        //         value={cutoutType}
                        //         dark
                        //         items={["None", "Step"]}
                        //         clip_overflow
                        //         onChange={(e) => {
                        //             // this.handleFootingUpdate(e, default_FootingType, pop_item)
                        //             this.togglePop(false);
                        //             this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS", pop_item.ref.split("-")[0] + "-CutoutType", e.target.value);
                        //         }}
                        //     /></MenuItem>);

                        pop_menu_items.push(
                            <MenuItem
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                    this.togglePop(false);
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref.split("-")[0] + "-CutoutType",
                                        cutoutType === "Step" ? "None" : "Step"
                                    );
                                }}
                            >
                                {cutoutType === "Step" ? "Remove Step Cutout" : "Add Step Cutout"}
                            </MenuItem>
                        );
                    }
                    let attach_item = pop_item;

                    //fix up item if attachment one in paper
                    let search = Paper.GetItems({ ref: attach_tag, ref2: pop_item?.ref2, areaIndex: areaIndex });
                    if (search.length == 0 && pop_item?.ref2?.startsWith("C")) {
                        // for cutouts
                        search = Paper.GetItems({ ref: pop_item.ref, ref2: pop_item?.ref2, areaIndex: areaIndex });
                    }
                    if (search.length == 0) search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                    if (search && search.length > 0) {
                        attach_item = search[0];
                    }

                    if (side_is_attached) {
                        pop_menu_items.push(
                            <MenuItem
                                classes={{ root: classes.menu_item }}
                                onClick={() => this.toggleMod_attachment2_dialog(true, attach_item)}
                                style={{ minWidth: "270px" }}
                            >
                                Modify Attachment...{" "}
                                <BSL_Button
                                    tight
                                    className={classes.mini_button}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.attachSide(areaIndex, attach_tag, "", true, job, attach_item)(e);
                                    }}
                                >
                                    Unattach
                                </BSL_Button>
                            </MenuItem>
                        );
                    } else {
                        pop_menu_items.push(
                            <MenuItem
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    let attach_item = pop_item;
                                    //fix up item if attachment one in paper
                                    let search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                                    if (search && search.length > 0) {
                                        attach_item = search[0];
                                    }
                                    this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                        this.attachSide(areaIndex, attach_tag, "", false, job, attach_item)(e);
                                    });
                                }}
                            >
                                Attach this side...
                            </MenuItem>
                        );
                    }
                }
                if (pop_item.is_post && pop_item.add_post_index !== undefined) {
                    pop_menu_items.push(
                        <Typography
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Posts
                        </Typography>
                    );
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={(e) => {
                                // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                this.togglePop(false);
                                let new_post_array = area_design_specs?.DECK_PARAMETERS?.DeckPosts.filter(
                                    (item, index) => {
                                        return index !== toNumber(pop_item.add_post_index);
                                    }
                                );
                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    "DECK_PARAMETERS",
                                    "DeckPosts",
                                    new_post_array
                                );
                            }}
                        >
                            Delete Post
                        </MenuItem>
                    );
                }
                if (pop_item.is_beam && (pop_item.is_perimeter || pop_item.beamName === "Bearer")) {
                    pop_menu_items.push(
                        <Typography
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Posts
                        </Typography>
                    );
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={(e) => {
                                // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                this.togglePop(false);
                                let new_post_array = [];
                                if (area_design_specs?.DECK_PARAMETERS?.DeckPosts)
                                    new_post_array = [...area_design_specs.DECK_PARAMETERS.DeckPosts];
                                let new_post = {};

                                let position_text = "(0,0,0)";
                                if (pop_item.click_point) {
                                    let x = pop_item.click_point.x;
                                    let y = pop_item.click_point.y;
                                    if (window.paper_origin) {
                                        x = x - window.paper_origin.x;
                                        y = -(y - window.paper_origin.y);
                                    }

                                    position_text = "(" + -y.toFixed(0) + "," + x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
                                } else if (pop_item?.ref4) {
                                    let midpoint = midPointRef(pop_item?.ref4);
                                    position_text = "(" + -midpoint.y.toFixed(0) + "," + midpoint.x.toFixed(0) + ",0)"; // x and y changed to suit rotated nature of decks
                                }

                                console.log("position_text", position_text);
                                if (position_text === "(0,0,0)") return;

                                new_post.ref_point = position_text;
                                new_post.location = -1;
                                new_post.beam_ref = pop_item?.ref2;
                                new_post_array.push(new_post);

                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    "DECK_PARAMETERS",
                                    "DeckPosts",
                                    new_post_array
                                );
                            }}
                        >
                            Add Post (in this location)
                        </MenuItem>
                    );
                }
                if (
                    (pop_item.is_beam && (pop_item.is_perimeter || pop_item.beamName.includes("Bearer"))) ||
                    pop_item.is_brace
                ) {
                    pop_menu_items.push(
                        <Typography
                            classes={{ root: classes.pop_header }}
                            variant="overline"
                            display="block"
                            gutterBottom
                        >
                            Bracing
                        </Typography>
                    );
                }
                if (pop_item.is_beam && (pop_item.is_perimeter || pop_item.beamName.includes("Bearer"))) {
                    let show_add_brace = true;
                    if (pop_item?.deck_bracing) {
                        let braces = pop_item?.deck_bracing.split("/");
                        let post_behind = area_design_specs?.BEAMS_AND_POSTS?.CornerPostsFullHeight === 3;
                        if (!post_behind) show_add_brace = false;
                        pop_menu_items.push(
                            <MenuItem
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                    let indexes_int = [];
                                    for (let index of braces) {
                                        indexes_int.push(toNumber(index));
                                    }
                                    this.togglePop(false);
                                    let new_bracing_array = [];
                                    if (area_design_specs?.DECK_PARAMETERS?.DeckBracing) {
                                        new_bracing_array = area_design_specs?.DECK_PARAMETERS?.DeckBracing.filter(
                                            (item, index) => {
                                                if (indexes_int.includes(index)) {
                                                    //don't add
                                                    return false;
                                                }
                                                return true;
                                            }
                                        );
                                    }

                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        "DECK_PARAMETERS",
                                        "DeckBracing",
                                        new_bracing_array
                                    );
                                }}
                            >
                                Delete Brace{braces.length > 1 ? "s" : ""}
                            </MenuItem>
                        );
                    }
                    if (show_add_brace) {
                        let post_type =
                            this.props.config?.post_types?.[
                                area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType
                            ];

                        console.log("post_type", post_type);

                        pop_menu_items.push(
                            <MenuItem
                                classes={{ root: classes.menu_item }}
                                // onClick={(e) => {
                                //     // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                //     this.togglePop(false);
                                //     this.handle_add_deck_brace(pop_item, areaIndex, "6mm Wire Rope - 2 Tek");
                                // }}
                            >
                                Add Brace{" "}
                                <BSL_Select
                                    tight={true}
                                    value={""}
                                    onChange={(e) => {
                                        this.togglePop(false);
                                        this.handle_add_deck_brace(pop_item, areaIndex, e.target.value);
                                        // setValue({ ...value, ["BeamType3"]: e.target.value })
                                    }}
                                    items={[
                                        { Key: "", Display: "Select Brace Type..." },
                                        { Key: "30x1.0 Strap - 2 Teks", Display: "30x1.0 Strap (2 Tek - 4.7kN)" },
                                        {
                                            Key: "30x1.0 Strap - 3 Teks",
                                            Display: "30x1.0 Strap (3 Tek - 7.05kN)",
                                            disabled: post_type.depth < 80,
                                            disabledTooltip: "Not available to post less that 75mm wide.",
                                        },
                                        { Key: "6mm Wire Rope - 4 Teks", Display: "6mm Wire Rope (4 Teks - 13kN)" },
                                        { Key: "M12 Rod - 6 Teks", Display: "M12 Rod (6 Teks - 20kN)" },
                                    ]}
                                ></BSL_Select>
                            </MenuItem>
                        );
                    }
                }
                if (pop_item.is_brace) {
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={(e) => {
                                // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                this.togglePop(false);
                                let new_bracing_array = area_design_specs?.DECK_PARAMETERS?.DeckBracing.filter(
                                    (item) => {
                                        return item.ref_point != pop_item.ref.replaceAll("/", ",");
                                    }
                                );
                                this.props.updateAreaSpecification(
                                    areaIndex,
                                    "DECK_PARAMETERS",
                                    "DeckBracing",
                                    new_bracing_array
                                );
                            }}
                        >
                            Delete Brace
                        </MenuItem>
                    );
                }
            } else if (pop_item.is_skylight) {
                pop_menu_items.push(
                    <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                        Modify Skylight
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.togglePop(false);
                            pop_item.is_skylight = false;
                            this.UpdateSkylights(pop_item?.babylon);
                        }}
                    >
                        Remove Skylight
                    </MenuItem>
                );
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs_header }} variant="overline" display="block" gutterBottom>SPECIFICATIONS</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Material:</span> Ampelite Polycarbonate</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Colour:</span> Clear</Typography>);
            } else if (pop_item.is_roofsheet) {
                let skylight = area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING].SkylightSubType;

                pop_menu_items.push(
                    <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                        Modify Roof Sheet
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem
                        disabled={pop_item.is_next_to_skylight || !skylight}
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.togglePop(false);
                            pop_item.is_skylight = true;
                            this.UpdateSkylights(pop_item?.babylon);
                        }}
                    >
                        Add Skylight{pop_item.is_next_to_skylight ? " (Cannot add due to spacing requirement)" : ""}
                    </MenuItem>
                );
                // pop_menu_items.push(<Divider classes={{ root: classes.divider }} />);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs_header }} variant="overline" display="block" gutterBottom>SPECIFICATIONS</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Material:</span> Corrugated Iron 0.42</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Colour:</span> Classic Cream/Grey</Typography>);
            } else if (pop_item.is_post || pop_item.is_footing) {
                let col_headers = null;
                let col_headers_split = null;
                let columns_section = false;
                let coltype_index = null;
                let embedment_index = null;
                let embed = null;
                let compression_index = null;
                let compression = null;
                let deflection = null;

                let loads = this.props.job.QuoteParameters?.ENGINEERING?.EngineeringLoads;
                if (loads !== undefined) {
                    var splitted = loads.split(/\r?\n/);

                    for (let split of splitted) {
                        if (split.includes("***COLUMNS***")) columns_section = true;
                        if (columns_section) {
                            if (split.startsWith("NAME|")) {
                                col_headers = split;
                                col_headers_split = col_headers.split("|");
                                coltype_index = col_headers_split.indexOf("COLUMN_TYPE");
                                embedment_index = col_headers_split.indexOf("EMBEDMENT");
                                compression_index = col_headers_split.indexOf("total_compression_kn");
                            } else if (col_headers_split) {
                                let col_split = split.split("|");
                                embed = Number(col_split[embedment_index]);
                                compression = col_split[compression_index];
                            }
                        }
                    }
                }

                let col_results =
                    this.props.job.QuoteParameters?.ENGINEERING?.EngineeringResults?.ColumnResultsDetailed;
                if (col_results && pop_item.nameQQ) {
                    if (col_results[pop_item.nameQQ]) {
                        embed = col_results[pop_item.nameQQ].embedment;
                        compression = col_results[pop_item.nameQQ].total_compression_kn;
                        deflection = col_results[pop_item.nameQQ].max_deflection_mm;
                    }
                }

                let default_FootingType = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].FootingType;
                let default_PostExternalConnectors =
                    area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostExternalConnectors;

                if (default_FootingType === "Bolt to Slab") {
                    if (default_PostExternalConnectors === 1) default_FootingType += " (External Connector)";
                    else default_FootingType += " (Internal Connector)";
                }

                let footingType = default_FootingType;

                const areaFootingMods = area_design_specs?.Footings;

                let ref = pop_item.is_footing ? pop_item.ref2 : pop_item?.ref5 ? pop_item?.ref5 : pop_item.ref;
                let footing_mod = areaFootingMods ? getItemFromArray(areaFootingMods, "Ref", ref) : null;

                if (footing_mod) {
                    let connector_text = "";
                    if (footing_mod.Kind.includes("Bolt") && footing_mod.Connector === 1)
                        connector_text = " (Internal Connector)";
                    if (footing_mod.Kind.includes("Bolt") && footing_mod.Connector === 2)
                        connector_text = " (External Connector)";
                    footingType = footing_mod.Kind + connector_text;
                }

                let footing_options = [];
                const concreteInGround = { Key: "Concrete In", Display: "Concrete in Ground" };
                const boltToSlabInternal = {
                    Key: "Bolt to Slab (Internal Connector)",
                    Display: "Bolt to Slab (Internal Connector)",
                };
                const boltToSlabExternal = {
                    Key: "Bolt to Slab (External Connector)",
                    Display: "Bolt to Slab (External Connector)",
                };
                // const boltToSlabExternalFlange = {
                //     Key: "Bolt to Slab (External Connector)",
                //     Display: "Bolt to Slab Flange Post",
                // };

                if (window.LYSAGHT) {
                    boltToSlabExternal.Display = "Bolt to Slab Flange Post";
                    let post_type =
                        this.props.config?.post_types?.[
                            area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType
                        ];

                    if (post_type?.allow_flanged === false) {
                        boltToSlabExternal.disabled = true;
                        boltToSlabExternal.disabledTooltip = "Flanged is not available in this post type";
                    }

                    if (job?.DesignParameters?.Freestanding) {
                        // boltToSlabExternal.disabled = true;
                        // boltToSlabExternal.disabledTooltip = "Flanged is not available in Freestanding structures";
                        boltToSlabInternal.disabled = true;
                        boltToSlabInternal.disabledTooltip = "Bolt to Slab is not available in Freestanding structures";
                    }
                    if (is_cyclonic) {
                        boltToSlabInternal.disabled = true;
                        boltToSlabInternal.disabledTooltip = "Bolt to Slab is not available in Cyclonic regions";
                    }
                } else {
                    if (job?.DesignParameters?.Freestanding || this.isPostRHS(pop_item, areaIndex)) {
                        boltToSlabExternal.disabled = true;
                        boltToSlabExternal.disabledTooltip =
                            "External Connector is not available in Freestanding structures";
                        boltToSlabInternal.disabled = true;
                        boltToSlabInternal.disabledTooltip = "Bolt to Slab is not available in Freestanding structures";
                    }
                }

                footing_options = [concreteInGround, boltToSlabInternal, boltToSlabExternal];

                pop_menu_items.push(
                    <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                        Modify Post & Footing
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem
                        classes={{ root: classes.menu_item }}
                        onClick={() => this.toggleMod_post_dialog(true, pop_item)}
                    >
                        Modify Post...
                    </MenuItem>
                );
                if (
                    !window.LYSAGHT &&
                    area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
                    (pop_item.ref4 || pop_item?.post_data?.ref4)
                ) {
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() =>
                                this.handleRemovePortalColumn(
                                    areaIndex,
                                    pop_item?.post_data ? pop_item?.post_data : pop_item
                                )
                            }
                        >
                            Remove Portal Column
                        </MenuItem>
                    );
                }
                pop_menu_items.push(
                    <MenuItem
                        classes={{ root: classes.menu_item }}
                        onClick={() => {
                            this.toggleMod_downpipe_dialog(true, pop_item);
                        }}
                    >
                        Add Downpipe...
                    </MenuItem>
                );

                if (pop_item?.align_swappable) {
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() =>
                                this.handleSwapPostAlignment(
                                    areaIndex,
                                    pop_item?.post_data ? pop_item?.post_data : pop_item
                                )
                            }
                        >
                            Swap Corner Post Beam Alignment
                        </MenuItem>
                    );
                }
                pop_menu_items.push(<Divider classes={{ root: classes.divider }} />);
                pop_menu_items.push(
                    <Typography
                        classes={{ root: classes.pop_specs_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        FOOTING
                    </Typography>
                );
                pop_menu_items.push(
                    <MenuItem classes={{ root: classes.menu_item }}>
                        Footing Type :&nbsp;
                        {/* <AreaSelectField
                            value={footingType}
                            dark
                            items={footing_options}
                            clip_overflow
                            onChange={(e) => this.handleFootingUpdate(e, default_FootingType, pop_item)}
                        /> */}
                        <BSL_Select
                            tight={true}
                            value={footingType}
                            onChange={(e) => this.handleFootingUpdate(e, default_FootingType, pop_item)}
                            items={footing_options}
                        ></BSL_Select>
                    </MenuItem>
                );
                {
                    !job?.DesignParameters?.Freestanding &&
                        pop_menu_items.push(
                            <Button
                                onClick={() => this.matchAllFootingInThisArea(footingType, areaIndex)}
                                classes={{ root: classes.pop_specs_small_text }}
                                color="secondary"
                            >
                                APPLY TO ALL FOOTINGS IN AREA {pop_item.areaNumber}
                            </Button>
                        );
                }

                if (pop_item?.lengthQQ) {
                    pop_menu_items_details.push(
                        <Typography classes={{ root: classes.pop_specs }} variant="caption" display="block">
                            <span style={{ fontWeight: 600 }}>Post Length:</span> {pop_item?.lengthQQ.toFixed(0)} mm
                        </Typography>
                    );
                }

                {
                    embed &&
                        pop_menu_items_details.push(
                            <Typography classes={{ root: classes.pop_specs }} variant="caption" display="block">
                                <span style={{ fontWeight: 600 }}>Embedment:</span> {embed} mm
                            </Typography>
                        );
                }

                {
                    compression !== undefined &&
                        pop_menu_items_details.push(
                            <Typography classes={{ root: classes.pop_specs }} variant="caption" display="block">
                                <span style={{ fontWeight: 600 }}>Total Compression Load:</span>{" "}
                                {Number(compression).toFixed(2)} kN
                            </Typography>
                        );
                }

                {
                    deflection !== undefined &&
                        pop_menu_items_details.push(
                            <Typography classes={{ root: classes.pop_specs }} variant="caption" display="block">
                                <span style={{ fontWeight: 600 }}>Max Deflection:</span> {Number(deflection).toFixed(1)}{" "}
                                mm
                            </Typography>
                        );
                }

                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Material:</span> Corrugated Iron 0.42</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Colour:</span> Classic Cream/Grey</Typography>);
            } else if (pop_item.is_beam) {
                // const beam1 = ;
                // const beam2 = config.design_options["Flat"].beam_2;
                // const beam3 = config.design_options["Flat"].beam_3;
                // const beam4 = config.design_options["Flat"].beam_4;

                // const area_design_specs = (job && job.AreaSpecifications && job.AreaSpecifications[areaIndex]) ? job.AreaSpecifications[areaIndex] : {};
                // let NumExtraPostsFront1 = area_design_specs && area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]["NumExtraPostsFront1"]
                //     ? area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]["NumExtraPostsFront1"]
                //     : 0;

                // DRAW DIRECTION ARROWS
                if (pop_item?.segments) {
                    let start_pnt = pop_item.segments[0].point;
                    let end_pnt = pop_item.segments[1].point;

                    if (pop_item?.ref4 && window?.origin_convert_reverse) {
                        let ref4_split = pop_item?.ref4.split(";");
                        start_pnt = getPointForRef(ref4_split[0]);
                        start_pnt = window.origin_convert_reverse(start_pnt);
                        console.log("BEAM ENDS start_pnt", start_pnt);
                        start_pnt = new paper.Point(start_pnt.x, start_pnt.y);

                        end_pnt = getPointForRef(ref4_split[1]);
                        end_pnt = window.origin_convert_reverse(end_pnt);
                        console.log("BEAM ENDS end_pnt", end_pnt);
                        end_pnt = new paper.Point(end_pnt.x, end_pnt.y);
                    }

                    paper.project.activeLayer.start_mark = new paper.Path.Circle({
                        center: start_pnt,
                        radius: 300,
                        fillColor: null,
                        strokeColor: "darkgreen",
                        strokeWidth: 30,
                        dashArray: [30, 20],
                    });
                    paper.project.activeLayer.end_mark = new paper.Path.Circle({
                        center: end_pnt,
                        radius: 300,
                        fillColor: null,
                        strokeColor: "darkred",
                        strokeWidth: 30,
                        dashArray: [30, 20],
                    });
                }

                let NumExtraPostsFront1 = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.NumExtraPostsFront1"
                );
                let NumInternalRafters = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.NumInternalRafters"
                );
                let NumExtraPurlins = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.NumExtraPurlins");

                let isExtraBeam = pop_item?.Extra;

                let first_rafter_omitted = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.OmitLeftBeam"
                );
                let last_rafter_omitted = get(
                    job,
                    "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.OmitRightBeam"
                );

                let beamType = pop_item.typeQQ ? pop_item.typeQQ : "";
                if (pop_item.typeQQ && pop_item.typeQQ === "beam" && pop_item.nameQQ) {
                    if (pop_item.nameQQ.startsWith("FB")) beamType = "beam1";
                    if (pop_item.nameQQ.startsWith("CB")) beamType = "beam1";
                    if (pop_item.nameQQ.startsWith("P")) beamType = "beam2";
                    if (pop_item.nameQQ.startsWith("R")) beamType = "beam3";
                    if (pop_item.nameQQ.startsWith("SF")) beamType = "beam3";
                }

                let beamTypeAreaColour = pop_item.colour;
                let beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType1");
                let beamConfigType = config.design_options[DesignType].beam_1;
                if (beamType === "beam1") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol1");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType1");
                }
                if (beamType === "beam2") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol2");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType2");
                    beamConfigType = config.design_options[DesignType].beam_2;
                }
                if (beamType === "beam3") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol3");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType3");
                    beamConfigType = config.design_options[DesignType].beam_3;
                }
                if (beamType === "beam4") {
                    beamTypeAreaColour = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamCol4");
                    beamTypeAreaSection = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.BeamType4");
                    beamConfigType = config.design_options[DesignType].beam_4;
                }

                let beam_menu_items = [];
                let default_beam_item = (
                    <MenuItem key={"Default"} value={"Default"}>
                        {"Default (" + beamTypeAreaSection + ")"}
                    </MenuItem>
                );
                for (let key in beamConfigType.options) {
                    beam_menu_items.push(<ListSubheader>{key}</ListSubheader>);
                    for (let key2 in beamConfigType.options[key]) {
                        let beam = beamConfigType.options[key][key2];
                        let id = beam.id ? beam.id : key2;
                        let name = beam.name ? beam.name : key2;
                        if (key2 === beamTypeAreaSection) {
                            default_beam_item = (
                                <MenuItem key={"Default"} value={"Default"}>
                                    {beam.thumbnail && (
                                        <div className={classes.roofsheet_chip}>
                                            <img alt="sheet thumb" src={beam.thumbnail} style={{ height: "32px" }} />
                                        </div>
                                    )}
                                    Default ({name})
                                </MenuItem>
                            );
                        } else {
                            beam_menu_items.push(
                                <MenuItem key={id} value={key2}>
                                    {beam.thumbnail && (
                                        <div className={classes.roofsheet_chip}>
                                            <img alt="sheet thumb" src={beam.thumbnail} style={{ height: "32px" }} />
                                        </div>
                                    )}
                                    {name}
                                </MenuItem>
                            );
                        }
                    }
                }

                beam_menu_items.splice(0, 0, default_beam_item);

                let PostCol = get(job, "AreaSpecifications." + areaIndex + ".BEAMS_AND_POSTS.PostCol");

                let colourMatch = {
                    Default: beamTypeAreaColour,
                    "Match Post": PostCol,
                };

                let beam_modifications = get(job, "AreaSpecifications." + areaIndex + ".BEAMMODIFICATIONS");

                let thisModification = null;

                if (pop_item.ref) {
                    for (var mod of beam_modifications) {
                        if (mod.Ref === pop_item.ref) thisModification = mod;
                    }
                }

                let beam_adjustments = get(job, "AreaSpecifications." + areaIndex + ".BEAMADJUSTMENTS");
                let thisAdjustment = null;

                if (pop_item.ref) {
                    for (var mod of beam_adjustments) {
                        if (mod.Ref === pop_item.ref2) thisAdjustment = mod;
                    }
                }

                let display_value =
                    pop_textfield_text === null
                        ? thisModification && thisModification.Length !== ""
                            ? thisModification.Length
                            : ""
                        : pop_textfield_text;
                if (display_value !== "") display_value = toNumber(display_value, false);

                let beam_adjustment_display =
                    beam_adjustment_display_value === null
                        ? thisAdjustment
                            ? thisAdjustment.Adjustment
                            : 0
                        : beam_adjustment_display_value;
                if (beam_adjustment_display !== "" && beam_adjustment_display !== "-")
                    beam_adjustment_display = toNumber(beam_adjustment_display, true);

                let beam_name = "Beam";
                if (isExtraBeam) beam_name = "Extra Beam";
                else if (beamType !== "beam" && beamConfigType.Name) beam_name = beamConfigType.Name;

                let is_cutout_beam = false;
                let cutoutType = "";
                let cutoutOverhang = 0;
                let cutoutBeamY = 1;
                if (pop_item.ref2) {
                    is_cutout_beam =
                        ((pop_item.ref2.startsWith("Back") || pop_item.ref2.startsWith("Front")) &&
                            pop_item.ref2.includes("-")) ||
                        pop_item.is_cutout;
                    if (is_cutout_beam) {
                        beam_name = "Cutout Beam";
                        cutoutType = area_design_specs.SHAPE.CUTOUTS[pop_item.ref2.split("-")[0] + "-CutoutType"];
                        cutoutOverhang = area_design_specs.SHAPE.CUTOUTS[pop_item.ref2.split("-")[0] + "-Overhang"];
                        cutoutBeamY = area_design_specs.SHAPE.CUTOUTS[pop_item.ref2.split("-")[0] + "-HasBeamY"];
                        display_value = pop_textfield_text === null ? cutoutOverhang : pop_textfield_text;
                    }
                }

                pop_menu_items.push(
                    <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                        Modify/Shift {beam_name}
                    </Typography>
                );

                if (beamType === "beam3" && is_flat && !is_cutout_beam)
                    // pop_menu_items.push(
                    //     <MenuItem
                    //         classes={{ root: classes.menu_item }}
                    //         onClick={this.updateAreaSpecification(
                    //             areaIndex,
                    //             BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                    //             "OmitLeftBeam",
                    //             first_rafter_omitted ? 0 : 1
                    //         )}
                    //     >
                    //         {first_rafter_omitted ? "Add" : "Remove"} First Rafter
                    //     </MenuItem>
                    // );
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            First (Left) Return Beam :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(first_rafter_omitted)}
                                items={[
                                    { Key: 0, Display: "On" },
                                    { Key: 1, Display: "Off" },
                                    { Key: 2, Display: "If Required (eg; supports a purlin)" },
                                ]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="OmitLeftBeam"
                                clip_overflow
                                refresh_svg
                                onChange={(e) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                        "OmitLeftBeam",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );
                if (beamType === "beam3" && is_flat && !is_cutout_beam)
                    // pop_menu_items.push(
                    //     <MenuItem
                    //         classes={{ root: classes.menu_item }}
                    //         onClick={this.updateAreaSpecification(
                    //             areaIndex,
                    //             BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                    //             "OmitRightBeam",
                    //             last_rafter_omitted ? 0 : 1
                    //         )}
                    //     >
                    //         {last_rafter_omitted ? "Add" : "Remove"} Last Rafter
                    //     </MenuItem>
                    // );
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Last (Right) Return Beam :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(last_rafter_omitted)}
                                items={[
                                    { Key: 0, Display: "On" },
                                    { Key: 1, Display: "Off" },
                                    { Key: 2, Display: "If Required (eg; supports a purlin)" },
                                ]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="OmitRightBeam"
                                clip_overflow
                                refresh_svg
                                onChange={(e) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                        "OmitRightBeam",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );
                if (beamType === "beam1" && !is_cutout_beam) {
                    show_front_back_overhangs = true;
                }
                // if (beamType === "beam1") pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }}>Num Internal Posts :&nbsp;
                // <AreaSelectField
                //         style={{ marginTop: "0px" }}
                //         selectStyle={{ color: "black", marginTop: "0px" }}
                //         value={NumExtraPostsFront1}
                //         items={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]}
                //         areaIndex={areaIndex}
                //         section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                //         dataField="NumExtraPostsFront1"
                //         clip_overflow
                //         refresh_svg
                //         onChange={this.updateData(areaIndex, BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "NumExtraPostsFront1", true)}
                //     // onChange={this.updateRoofData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType")}
                //     /></MenuItem>);
                if ((beamType === "beam3" || beamType === "beam2") && is_flat)
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Num Internal Rafters :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(NumInternalRafters)}
                                items={[...Array(13).keys()]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="NumInternalRafters"
                                clip_overflow
                                refresh_svg
                                onChange={this.updateData(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                    "NumInternalRafters",
                                    true
                                )}
                                // onChange={this.updateRoofData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType")}
                            />
                        </MenuItem>
                    );
                if ((beamType === "beam3" || beamType === "beam2") && is_portal)
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Num Internal Rafters :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(NumInternalRafters)}
                                items={[...Array(13).keys()]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="NumInternalRafters"
                                clip_overflow
                                refresh_svg
                                onChange={this.updateData(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                    "NumInternalRafters",
                                    true
                                )}
                                // onChange={this.updateRoofData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType")}
                            />
                        </MenuItem>
                    );
                if (beamType === "beam3" || beamType === "beam2")
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Num Extra Purlin Rows :&nbsp;
                            <AreaSelectField
                                style={{ marginTop: "0px" }}
                                selectStyle={{ color: "black", marginTop: "0px" }}
                                value={toNumber(NumExtraPurlins)}
                                items={[...Array(13).keys()]}
                                areaIndex={areaIndex}
                                section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                dataField="NumExtraPurlins"
                                clip_overflow
                                refresh_svg
                                onChange={this.updateData(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                    "NumExtraPurlins",
                                    true
                                )}
                                // onChange={this.updateRoofData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType")}
                            />
                        </MenuItem>
                    );
                if (!isExtraBeam)
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleMod_beam_dialog(true, pop_item)}
                        >
                            Modify Beam Specifications...
                        </MenuItem>
                    );
                pop_menu_items.push(
                    <MenuItem
                        classes={{ root: classes.menu_item }}
                        onClick={() => this.toggleMod_beam_posts_dialog(true, pop_item)}
                    >
                        Modify/Add Posts...
                    </MenuItem>
                );

                if (
                    !window.LYSAGHT &&
                    area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
                    pop_item.ref2
                ) {
                    let ref = pop_item.ref2;
                    let add_post = false;
                    if (area_design_specs?.PORTALPOSTS) {
                        for (let item of area_design_specs?.PORTALPOSTS) {
                            if (item.Ref === ref) add_post = true;
                        }
                    }

                    if (pop_item?.beamName) {
                        if (pop_item.beamName.includes("No Post")) add_post = true;
                        if (pop_item.beamName.includes("Portal Rafter (Standard)")) add_post = false;
                    }
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.handleRemovePortalColumn(areaIndex, pop_item)}
                        >
                            {add_post ? "Add" : "Remove"} Portal Column
                        </MenuItem>
                    );
                }
                if (isExtraBeam) {
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() => this.toggleEdit_extra_beam_dialog(true)}
                        >
                            Edit Extra Beam Details...
                        </MenuItem>
                    );
                    pop_menu_items.push(
                        <MenuItem
                            classes={{ root: classes.menu_item }}
                            onClick={() => {
                                this.togglePop(false);
                                this.props.deleteFromAreaSpecificationModificationArray(
                                    areaIndex,
                                    "NewBeams",
                                    pop_item.ref5
                                );
                            }}
                        >
                            Delete Extra Beam
                        </MenuItem>
                    );
                }
                if (is_cutout_beam) {
                    let max_overhang =
                        area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang;
                    if (pop_item.ref2.endsWith(" Y") || pop_item.ref2.endsWith(" Y2")) {
                        max_overhang =
                            area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
                    }
                    // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE + "." + "CUTOUTS", attach_tag.replace("Attachment", "CutoutType"), "None")}>Remove this cutout</MenuItem>);
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Cutout Type :&nbsp;
                            <AreaSelectField
                                value={cutoutType}
                                dark
                                items={
                                    pop_item?.ref2?.startsWith("BackMid")
                                        ? ["None", "Box", "Bay"]
                                        : ["None", "Angle", "Step", "Custom"]
                                }
                                clip_overflow
                                onChange={(e) => {
                                    // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                    this.togglePop(false);
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref2.split("-")[0] + "-CutoutType",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );
                    //toggle cutout "Y" beams
                    if (cutoutType !== "None")
                        pop_menu_items.push(
                            <MenuItem classes={{ root: classes.menu_item }}>
                                Cutout Side Beams :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={toNumber(cutoutBeamY)}
                                    items={[
                                        { Key: 0, Display: "Off" },
                                        { Key: 1, Display: "On" },
                                    ]}
                                    clip_overflow
                                    onChange={(e) => {
                                        this.togglePop(false);
                                        this.props.updateAreaSpecification(
                                            areaIndex,
                                            BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                            pop_item.ref2.split("-")[0] + "-HasBeamY",
                                            e.target.value
                                        );
                                    }}
                                />
                            </MenuItem>
                        );
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Cutout Overhang :&nbsp;{" "}
                            <BSL_TextInput
                                // helperText={is_extra_beam?<></>:null}
                                value={display_value}
                                style={{ color: "black", width: "100px", margin: "0px" }}
                                // autoFocus={true}
                                // selectAll={true}
                                tight
                                endAdornment="mm"
                                min={0}
                                max={max_overhang}
                                tooltipDelay={500}
                                onFocus={(event) => {
                                    event.target.select();
                                }}
                                onBlur={(val) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref2.split("-")[0] + "-Overhang",
                                        val
                                    );
                                    this.setState({ pop_textfield_text: null });
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        this.togglePop(false);
                                        e.target.blur();
                                    }
                                }}
                                onChange={(val) => {
                                    this.setState({ pop_textfield_text: val });
                                }}
                                disabled={max_overhang === 0}
                            />
                        </MenuItem>
                    );
                    if (cutoutType === "Custom") {
                        pop_menu_items.push(
                            <MenuItem classes={{ root: classes.menu_item }}>
                                Num Custom Segments :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={
                                        area_design_specs.SHAPE.CUTOUTS[
                                            pop_item.ref2.split("-")[0] + "-CustomNumSegments"
                                        ]
                                    }
                                    items={[2, 3, 4, 5, 6]}
                                    areaIndex={areaIndex}
                                    section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                    clip_overflow
                                    refresh_svg
                                    onChange={this.updateData(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref2.split("-")[0] + "-CustomNumSegments",
                                        true
                                    )}
                                    // onChange={this.updateRoofData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType")}
                                />
                            </MenuItem>
                        );
                    }
                }
                // if (beamType === "beam1" && !is_cutout_beam) {

                //DES-179 - Need to be able to see elevation dimensions easily
                Object.byString = function (o, s) {
                    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
                    s = s.replace(/^\./, ""); // strip a leading dot
                    var a = s.split(".");
                    console.log(s);
                    for (var i = 0, n = a.length; i < n; ++i) {
                        var k = a[i];
                        if (k in o) {
                            o = o[k];
                        } else {
                            return;
                        }
                    }
                    console.log(JSON.stringify(o));
                    return o;
                };

                let popBeam = null;
                if (pop_item?.typeQQ) popBeam = pop_item?.typeQQ.toString();
                //changes beam1/2/3 to beam_1/2/3
                let position = null;
                if (popBeam) position = popBeam.search(/\d/);
                if (position) {
                    popBeam = [popBeam.slice(0, position), "_", popBeam.slice(position)].join("");

                    let beamTypeSection = beamTypeAreaSection;
                    if (thisModification && thisModification?.Section) beamTypeSection = thisModification?.Section;
                    let beamTypeDepth = Object.byString(config.beam_types, beamTypeSection)?.depth.toString();

                    let beamHeight = pop_item.ref.split(/[;/())]+/);

                    let zHeight = Math.min(beamHeight[3], beamHeight[6]);

                    if (pop_item?.lengthQQ) {
                        pop_menu_items_details.push(
                            <Typography
                                classes={{ root: classes.pop_specs }}
                                variant="caption"
                                display="block"
                                gutterBottom
                            >
                                <span style={{ fontWeight: "bold" }}>Beam Length:</span> {pop_item?.lengthQQ.toFixed(0)}{" "}
                                mm
                            </Typography>
                        );
                    }
                    pop_menu_items_details.push(
                        <Typography
                            classes={{ root: classes.pop_specs }}
                            variant="caption"
                            display="block"
                            gutterBottom
                        >
                            <span style={{ fontWeight: "bold" }}>Clear Head Height:</span>{" "}
                            {(zHeight - Number(beamTypeDepth)).toFixed(0)} mm (underside of beam)
                        </Typography>
                    );
                }
                // }
                // pop_menu_items.push(<Divider classes={{ root: classes.divider }} />);
                // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }}>
                //     <AreaSelectField
                //         label="Beam Section"
                //         style={{ color: "black", marginTop: "0px" }}
                //         selectStyle={{ color: "black", marginTop: "10px" }}
                //         labelStyle={{ color: "black", marginTop: "0px" }}
                //         value={(thisModification && thisModification.Section) ? thisModification.Section : "Default"}
                //         items={[beam_menu_items]}
                //         areaIndex={areaIndex}
                //         section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                //         dataField="BeamType2"
                //         clip_overflow
                //         onChange={this.updateBeamMod(areaIndex, pop_item.ref, "Section", true)}
                //     /></MenuItem>);
                // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }}>
                //     <ColourSelector

                //         text="Colour"
                //         colourList={["Default", ...Centenary_Beam_Colours_Array]}
                //         value={(thisModification && thisModification.Colour) ? thisModification.Colour : "Default"}
                //         onChange={this.updateBeamMod(areaIndex, pop_item.ref, "Colour", true)}
                //         id="Beam_colour"
                //         colourMatch={colourMatch}
                //         defaultColour={beamTypeColourDefault}
                //         blacktext
                //         style={{ color: "black", width: "100%", textAlign: "left", marginTop: "-5px" }}
                //     // classes={{ label: classes.whiteText, labelFocussed: classes.whiteText }}
                //     /></MenuItem>);
                // pop_menu_items.push(<TextField
                //     label="Custom Length"
                //     value={display_value}
                //     style={{ color: "black", width: "250px", paddingLeft: "10px", display: "block" }}
                //     InputProps={{
                //         endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                //     }}
                //     onFocus={event => {
                //         event.target.select()
                //     }}
                //     onBlur={this.updateBeamMod(areaIndex, pop_item.ref, "Length", true)}
                //     onKeyPress={(e) => {
                //         console.log(e.key);
                //         if (e.key === "Enter") {
                //             this.togglePop(false);
                //             this.updateBeamModValue(areaIndex, pop_item.ref, "Length", true, Number(e.target.value));
                //         }
                //     }}
                //     onChange={(e) => {
                //         this.setState({ pop_textfield_text: e.target.value });
                //         // this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, pop_item.ref, e.target.value);
                //     }}
                //     helperText="*will not affect the layout, just material list. Leave blank for default length."
                // />);
                // if (pop_item.ref2) pop_menu_items.push(<TextField
                //     label="Shift Beam"
                //     value={beam_adjustment_display}
                //     style={{ color: "black", width: "250px", paddingLeft: "10px", display: "block" }}
                //     InputProps={{
                //         endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                //     }}
                //     onFocus={event => {
                //         event.target.select()
                //     }}
                //     onBlur={this.updateBeamAdjustment(areaIndex, pop_item.ref2, "Adjustment", true)}
                //     onKeyPress={(e) => {
                //         console.log(e.key);
                //         if (e.key === "Enter") {
                //             this.togglePop(false);
                //             this.updateBeamAdjustmentValue(areaIndex, pop_item.ref2, "Adjustment", true, Number(e.target.value));
                //         }
                //     }}
                //     onChange={(e) => {
                //         this.setState({ beam_adjustment_display_value: e.target.value });
                //         // this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, pop_item.ref, e.target.value);
                //     }}
                //     helperText={"Min/Max=-" + pop_item.adj + ", *a negative number will move the beam towards the front fascia, or to the left."}
                // />);
                // pop_menu_items.push(<Divider classes={{ root: classes.divider }} />);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Material:</span> {pop_item.material}</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Colour:</span> {pop_item.colour}</Typography>);
            }

            let show_attachment_and_gutter_options = false;
            if (pop_item.is_beam && is_portal) {
                if (pop_item.typeQQ === "beam3") show_attachment_and_gutter_options = true;
                if (pop_item.infill_1_beam !== undefined) show_attachment_and_gutter_options = true;
                if (pop_item.infill_2_beam !== undefined) show_attachment_and_gutter_options = true;
            }
            if (
                pop_item.is_beam &&
                pop_item.ref2 &&
                (pop_item.ref2.includes("Back/") || pop_item.ref2.includes("Front/") || pop_item.ref2.includes("Beam/"))
            ) {
                show_attachment_and_gutter_options = true;
            }

            if (
                (pop_item.is_attachment || pop_item.is_attachment_ghost || pop_item.is_attachment_roof) &&
                pop_item?.segments
            ) {
                // DRAW DIRECTION ARROWS
                // wipe_start_end_marks();
                paper.project.activeLayer.start_mark = new paper.Path.Circle({
                    center: pop_item.segments[pop_item.is_attachment_ghost ? 1 : 0].point,
                    radius: 300,
                    fillColor: null,
                    strokeColor: "darkgreen",
                    strokeWidth: 30,
                    dashArray: [30, 20],
                });
                paper.project.activeLayer.end_mark = new paper.Path.Circle({
                    center: pop_item.segments[pop_item.is_attachment_ghost ? 0 : 1].point,
                    radius: 300,
                    fillColor: null,
                    strokeColor: "darkred",
                    strokeWidth: 30,
                    dashArray: [30, 20],
                });
            }

            if (
                (pop_item.is_attachment ||
                    pop_item.is_attachment_ghost ||
                    pop_item.is_gutter ||
                    pop_item.is_attachment_roof ||
                    pop_item.is_barge ||
                    pop_item.is_cutout ||
                    pop_item.is_infill ||
                    show_attachment_and_gutter_options) &&
                pop_item.ref &&
                !pop_item.is_post &&
                DesignType !== CONFIG.DESIGN_TYPES.DECK
            ) {
                const area_design_specs = get(job, "AreaSpecifications." + areaIndex);
                let ref_data = GetRefs(pop_item, area_design_specs);

                console.log("REFS", ref_data);
                let ref = pop_item.ref;
                let cutout = ref_data.IsCutout;
                let gutter_tag = ref_data.GutterRef;
                let attach_tag = ref_data.AttachmentRef;

                let cutout_prefix = ref_data.CutoutPrefix;

                let cutoutType = "";
                let cutoutOverhangRef = "";
                let cutoutOverhang = 0;

                if (cutout) {
                    cutoutType = area_design_specs?.SHAPE?.CUTOUTS?.[cutout_prefix + "-CutoutType"];
                    cutoutOverhangRef = cutout_prefix + "-Overhang";
                    if (attach_tag) cutoutOverhangRef = attach_tag.replace("Attachment", "Overhang");
                    if (gutter_tag.includes("-CustomHasGutter")) {
                        cutoutOverhangRef = gutter_tag.replace("HasGutter", "Overhang");
                    }
                    cutoutOverhang = area_design_specs?.SHAPE?.CUTOUTS?.[cutoutOverhangRef];
                    if (!cutoutOverhang) cutoutOverhang = 0;
                }

                let cutout_overhangValue = pop_textfield_text === null ? cutoutOverhang : pop_textfield_text;

                let side_is_attached;
                if (cutout)
                    side_is_attached = get(area_design_specs, BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS." + attach_tag);
                else side_is_attached = get(area_design_specs, BASIC_SPECS_SECTIONS.ATTACHMENTS + "." + attach_tag);

                let side_has_gutter;
                if (cutout)
                    side_has_gutter = get(area_design_specs, BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS." + gutter_tag);
                else side_has_gutter = area_design_specs?.[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES]?.[gutter_tag];

                // if (is_attachment_ghost)

                let this_PAAT;
                if (gutter_tag.includes("_HasGutter")) {
                    let index = toNumber(gutter_tag.replace("_HasGutter", "").replace("_", ""));
                    this_PAAT = area_design_specs?.[BASIC_SPECS_SECTIONS.ATTACHMENTS]?.PARTIAL_ATTACHMENTS?.[index - 1];
                    // side_has_gutter = this_PAAT?.HasGutter;
                    if (this_PAAT) {
                        if (this_PAAT.Name.includes("Back")) gutter_tag = "GutterB";
                        if (this_PAAT.Name.includes("Front")) gutter_tag = "GutterF";
                        if (this_PAAT.Name.includes("Left")) gutter_tag = "GutterL";
                        if (this_PAAT.Name.includes("Right")) gutter_tag = "GutterR";
                        side_has_gutter = area_design_specs?.[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES]?.[gutter_tag];
                    }
                }
                // console.log(area_design_specs, "attach_tag", attach_tag, "gutter_tag", gutter_tag);

                let this_mods = getItemFromArray(
                    area_design_specs?.[BASIC_SPECS_SECTIONS.ATTACHMENTS]?.AttachmentModifications,
                    "Ref",
                    pop_item.ref2
                );

                // else if (area_design_specs?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                //     //for portals need to check for PAATs
                //     this_PAAT = getItemFromArray(area_design_specs?.[BASIC_SPECS_SECTIONS.ATTACHMENTS]?.PARTIAL_ATTACHMENTS, "Ref", pop_item.ref2);

                //     if (this_PAAT) {
                //         if (this_PAAT.Name.includes("Back")) gutter_tag = "GutterB";
                //         if (this_PAAT.Name.includes("Front")) gutter_tag = "GutterF";
                //         if (this_PAAT.Name.includes("Left")) gutter_tag = "GutterL";
                //         if (this_PAAT.Name.includes("Right")) gutter_tag = "GutterR";
                //         side_has_gutter = area_design_specs?.[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES]?.[gutter_tag];
                //     }
                // }

                let paats = area_design_specs?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;
                if (ref && paats) {
                    for (var mod of paats) {
                        if (mod.Ref.includes(attach_tag.replace("Attachment", ""))) {
                            this_PAAT = { ...mod };
                            break;
                        } else if (mod.Ref.includes(pop_item.ref2)) {
                            this_PAAT = { ...mod };
                            break;
                        }
                    }
                }
                if (this_PAAT) {
                    if (
                        pop_item.is_attachment_ghost &&
                        side_is_attached &&
                        area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT
                    )
                        side_has_gutter = this_PAAT?.HasGutter;
                }

                let side_has_attachment_gutter = get(
                    area_design_specs,
                    BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES + ".Attachment" + gutter_tag
                );

                let show_attachment_options = true;
                if (cutout && cutoutType === "None") {
                    show_attachment_options = false;
                }
                // let side_has_gutter = area_design_specs && area_design_specs[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES][gutter_tag]
                //     ? area_design_specs[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES][gutter_tag]
                //     : 0;

                pop_menu_items.push(
                    <Typography classes={{ root: classes.pop_header }} variant="overline" display="block" gutterBottom>
                        Modify Gutter/Attachment
                    </Typography>
                );

                console.log(
                    "side_has_gutter",
                    side_has_gutter,
                    "side_has_attachment_gutter",
                    side_has_attachment_gutter,
                    this_PAAT
                );

                pop_item.attach_tag = attach_tag;
                pop_item.gutter_tag = gutter_tag;

                if (
                    gutter_tag === "GutterF" ||
                    gutter_tag == "GutterB" ||
                    attach_tag === "AttachmentBottom" ||
                    attach_tag === "AttachmentTop"
                )
                    show_front_back_overhangs = true;

                if (show_attachment_options) {
                    // if (side_is_attached) {
                    let AttachmentType = "";
                    let FasciaType = "";
                    if (job?.DesignParameters.USE_ATTACHMENTS_2) {
                        let attach_item = pop_item;

                        //fix up item if attachment one in paper
                        let search = Paper.GetItems({ ref: attach_tag, ref2: pop_item?.ref2, areaIndex: areaIndex });
                        if (search.length == 0 && pop_item?.ref2?.startsWith("C")) {
                            // for cutouts
                            search = Paper.GetItems({ ref: pop_item.ref, ref2: pop_item?.ref2, areaIndex: areaIndex });
                        }
                        if (search.length == 0) search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                        if (search && search.length > 0) {
                            attach_item = search[0];
                        }

                        let attach_mod = area_design_specs?.ATTACHMENTS?.AttachmentModifications.filter(
                            (e) => e.Ref === attach_item["ref2"]
                        )[0];
                        if (attach_mod) {
                            AttachmentType = attach_mod?.AttachmentType ?? "";
                            FasciaType = attach_mod?.FasciaType ?? "";
                        }

                        // console.log("attach_item", attach_item, AttachmentType, FasciaType, "pop_item", pop_item);

                        if (side_is_attached) {
                            pop_menu_items.push(
                                <MenuItem
                                    classes={{ root: classes.menu_item }}
                                    onClick={() => this.toggleMod_attachment2_dialog(true, attach_item)}
                                    style={{ minWidth: "270px" }}
                                >
                                    Modify Attachment...{" "}
                                    <BSL_Button
                                        tight
                                        className={classes.mini_button}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            this.attachSide(
                                                areaIndex,
                                                attach_tag,
                                                gutter_tag,
                                                true,
                                                job,
                                                attach_item
                                            )(e);
                                        }}
                                    >
                                        Unattach
                                    </BSL_Button>
                                </MenuItem>
                            );
                        } else if (cutoutType !== "Custom") {
                            pop_menu_items.push(
                                <MenuItem
                                    classes={{ root: classes.menu_item }}
                                    onClick={(e) => {
                                        let attach_item = pop_item;
                                        //fix up item if attachment one in paper
                                        let search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                                        if (search && search.length > 0) {
                                            attach_item = search[0];
                                        }
                                        this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                            this.attachSide(
                                                areaIndex,
                                                attach_tag,
                                                gutter_tag,
                                                false,
                                                job,
                                                attach_item
                                            )(e);
                                        });
                                    }}
                                >
                                    Attach this side...
                                </MenuItem>
                            );
                        }
                    } else {
                        pop_menu_items.push(
                            <MenuItem
                                classes={{ root: classes.menu_item }}
                                onClick={(e) => {
                                    let attach_item = pop_item;
                                    if (!side_is_attached && job?.DesignParameters.USE_ATTACHMENTS_2) {
                                        //fix up item if attachment one in paper
                                        let search = Paper.GetItems({ ref: attach_tag, areaIndex: areaIndex });
                                        if (search && search.length > 0) {
                                            attach_item = search[0];
                                        }
                                    }
                                    if (
                                        !side_is_attached &&
                                        job?.DesignParameters.USE_ATTACHMENTS_2 &&
                                        attach_item.lengthQQ
                                    ) {
                                        this.toggleMod_attachment2_dialog(true, attach_item, () => {
                                            this.attachSide(
                                                areaIndex,
                                                attach_tag,
                                                gutter_tag,
                                                side_is_attached ? true : false,
                                                job,
                                                attach_item
                                            )(e);
                                        });
                                    } else {
                                        this.attachSide(
                                            areaIndex,
                                            attach_tag,
                                            gutter_tag,
                                            side_is_attached ? true : false
                                        )(e);
                                    }
                                }}
                            >
                                {side_is_attached ? "Unattach" : "Attach"} this side
                            </MenuItem>
                        );
                        if (side_is_attached)
                            pop_menu_items.push(
                                <MenuItem
                                    classes={{ root: classes.menu_item }}
                                    onClick={() => this.toggleMod_attachment_dialog(true, pop_item)}
                                >
                                    Modify Attachment...
                                </MenuItem>
                            );
                    }

                    if (side_is_attached && this_mods && this_mods.FasciaType === "Wall") {
                        pop_menu_items.push(
                            <MenuItem classes={{ root: classes.menu_item }}>
                                Gutter :&nbsp;
                                <AreaSelectField
                                    value={this_mods.gutter}
                                    dark
                                    items={[
                                        {
                                            Key: this_mods.gutter,
                                            Display: this_mods.gutter === 1 ? "Wall Gutter" : "No Gutter Allowed",
                                        },
                                    ]}
                                    clip_overflow
                                />
                            </MenuItem>
                        );
                    } else if (this_PAAT && area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
                        if (
                            true ||
                            pop_item.is_attachment_ghost ||
                            pop_item.is_barge ||
                            (pop_item.is_gutter && pop_item?.ref?.includes("HasGutter"))
                        ) {
                            let selected = 0;
                            if (this_PAAT?.HasGutter && side_has_gutter) selected = 1;
                            else if (side_has_gutter) selected = 2;
                            else if (this_PAAT?.HasGutter) selected = 3;

                            pop_menu_items.push(
                                <MenuItem classes={{ root: classes.menu_item }}>
                                    Gutter :&nbsp;
                                    <AreaSelectField
                                        value={selected}
                                        dark
                                        items={[
                                            { Key: 0, Display: "No Gutter" },
                                            { Key: 1, Display: "Full Gutter" },
                                            { Key: 2, Display: "Part Gutter (Attachment Only)" },
                                            { Key: 3, Display: "Part Gutter (Unattached Only)" },
                                        ]}
                                        clip_overflow
                                        onChange={(e) => {
                                            {
                                                let paat_setting = e.target.value === 1 || e.target.value === 3 ? 1 : 0;
                                                let gutter_setting =
                                                    e.target.value === 1 || e.target.value === 2 ? 1 : 0;

                                                this.updatePAATParameter(
                                                    areaIndex,
                                                    this_PAAT.Ref,
                                                    "HasGutter",
                                                    paat_setting
                                                ).then(this.updateGutter(areaIndex, gutter_tag, gutter_setting));

                                                // this.updatePAATParameter(
                                                //     areaIndex,
                                                //     this_PAAT.Ref,
                                                //     "HasGutter",
                                                //     e.target.value
                                                // );
                                            }
                                        }}
                                    />
                                </MenuItem>
                            );
                        } else {
                            pop_menu_items.push(
                                <MenuItem classes={{ root: classes.menu_item }}>
                                    Gutter :&nbsp;
                                    <AreaSelectField
                                        value={side_has_gutter}
                                        dark
                                        items={
                                            AttachmentType.includes("Flyover") || FasciaType.includes("Riser")
                                                ? [
                                                      { Key: 0, Display: "No Gutter" },
                                                      { Key: 1, Display: "Normal Gutter" },
                                                  ]
                                                : [
                                                      { Key: 0, Display: "No Gutter (House Gutter Only)" },
                                                      { Key: 1, Display: "Double Gutter" },
                                                      { Key: 2, Display: "Box Gutter" },
                                                  ]
                                        }
                                        clip_overflow
                                        onChange={(e) => {
                                            // this.updatePAATParameter(
                                            //     areaIndex,
                                            //     this_PAAT.Ref,
                                            //     "HasGutter",
                                            //     e.target.value > 0 ? 1 : 0
                                            // ).then(this.updateGutter(areaIndex, gutter_tag, e.target.value));
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }}
                                    />
                                </MenuItem>
                            );
                        }
                    } else if (pop_item?.is_attachment || side_is_attached) {
                        if (area_design_specs?.SHAPE?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL)
                            if (pop_item.is_attachment_ghost) {
                                pop_menu_items.push(
                                    <MenuItem classes={{ root: classes.menu_item }}>
                                        Gutter :&nbsp;
                                        <AreaSelectField
                                            value={side_has_gutter}
                                            dark
                                            items={[
                                                { Key: 0, Display: "No Gutter" },
                                                { Key: 1, Display: "Normal Gutter" },
                                            ]}
                                            clip_overflow
                                            onChange={(e) => {
                                                this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                            }}
                                        />
                                    </MenuItem>
                                );
                            } else {
                                pop_menu_items.push(
                                    <MenuItem classes={{ root: classes.menu_item }}>
                                        Gutter :&nbsp;
                                        <AreaSelectField
                                            value={this_PAAT ? side_has_attachment_gutter : side_has_gutter}
                                            dark
                                            items={[
                                                { Key: 0, Display: "No Gutter (House Gutter Only)" },
                                                { Key: 1, Display: "Double Gutter" },
                                                { Key: 2, Display: "Box Gutter" },
                                            ]}
                                            clip_overflow
                                            onChange={(e) => {
                                                if (this_PAAT) {
                                                    this.updatePAATParameter(
                                                        areaIndex,
                                                        this_PAAT.Ref,
                                                        "HasGutter",
                                                        e.target.value
                                                    ).then(
                                                        this.updateGutter(
                                                            areaIndex,
                                                            "Attachment" + gutter_tag,
                                                            e.target.value
                                                        )
                                                    );
                                                } else {
                                                    this.updateGutter(areaIndex, gutter_tag, e.target.value).then(
                                                        this.updateGutter(
                                                            areaIndex,
                                                            "Attachment" + gutter_tag,
                                                            e.target.value
                                                        )
                                                    );
                                                }
                                            }}
                                        />
                                    </MenuItem>
                                );
                            }
                        if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED)
                            pop_menu_items.push(
                                <MenuItem classes={{ root: classes.menu_item }}>
                                    Gutter :&nbsp;
                                    <AreaSelectField
                                        value={side_has_gutter}
                                        dark
                                        items={[
                                            { Key: 0, Display: "No Gutter (House Gutter Only)" },
                                            { Key: 1, Display: "Double Gutter" },
                                            { Key: 2, Display: "Box Gutter" },
                                        ]}
                                        clip_overflow
                                        onChange={(e) => {
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }}
                                    />
                                </MenuItem>
                            );
                        if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT)
                            pop_menu_items.push(
                                <MenuItem classes={{ root: classes.menu_item }}>
                                    Gutter :&nbsp;
                                    <AreaSelectField
                                        value={side_has_gutter}
                                        dark
                                        items={
                                            AttachmentType.includes("Flyover") || FasciaType.includes("Riser")
                                                ? [
                                                      { Key: 0, Display: "No Gutter" },
                                                      { Key: 1, Display: "Normal Gutter" },
                                                  ]
                                                : [
                                                      { Key: 0, Display: "No Gutter (House Gutter Only)" },
                                                      { Key: 1, Display: "Double Gutter" },
                                                      { Key: 2, Display: "Box Gutter" },
                                                  ]
                                        }
                                        clip_overflow
                                        onChange={(e) => {
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }}
                                    />
                                </MenuItem>
                            );
                    } else if (!pop_item.is_attachment) {
                        if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED)
                            pop_menu_items.push(
                                <MenuItem classes={{ root: classes.menu_item }}>
                                    Gutter :&nbsp;
                                    <AreaSelectField
                                        value={side_has_gutter}
                                        dark
                                        items={[
                                            { Key: 0, Display: "No Gutter" },
                                            { Key: 1, Display: "Double Gutter" },
                                            { Key: 2, Display: "Box Gutter" },
                                        ]}
                                        clip_overflow
                                        onChange={(e) => {
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }}
                                    />
                                </MenuItem>
                            );
                        else
                            pop_menu_items.push(
                                <MenuItem classes={{ root: classes.menu_item }}>
                                    Gutter :&nbsp;
                                    <AreaSelectField
                                        value={side_has_gutter}
                                        dark
                                        items={[
                                            { Key: 0, Display: "No Gutter" },
                                            { Key: 1, Display: "Normal Gutter" },
                                            { Key: 2, Display: "Box Gutter" },
                                        ]}
                                        clip_overflow
                                        onChange={(e) => {
                                            console.log("update gutter", areaIndex, gutter_tag, e.target.value);
                                            this.updateGutter(areaIndex, gutter_tag, e.target.value);
                                        }}
                                    />
                                </MenuItem>
                            );
                    }
                    // }
                    // else {
                    // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.attachSide(areaIndex, attach_tag, gutter_tag)}>Attach this side</MenuItem>);
                    // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.toggleGutter(areaIndex, gutter_tag, !side_has_gutter)}>{side_has_gutter ? "Remove" : "Add"} Gutter</MenuItem>);
                    // if (side_has_gutter === 2 && !cutout) pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, gutter_tag, 1)}>Use Normal Gutter</MenuItem>);
                    // else if (side_has_gutter === 1 && !cutout) pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, gutter_tag, 2)}>Use Box Gutter</MenuItem>);
                    // }

                    if ((attach_tag === "AttachmentLeft" || attach_tag === "AttachmentRight") && is_flat) {
                        let beam_side = "Left";
                        if (attach_tag === "AttachmentRight") beam_side = "Right";
                        let side_beam_omitted =
                            area_design_specs &&
                            area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]["Omit" + beam_side + "Beam"];
                        // pop_menu_items.push(
                        //     <MenuItem
                        //         classes={{ root: classes.menu_item }}
                        //         onClick={this.updateAreaSpecification(
                        //             areaIndex,
                        //             BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                        //             "Omit" + beam_side + "Beam",
                        //             side_beam_omitted ? 0 : 1
                        //         )}
                        //     >
                        //         {side_beam_omitted ? "Add" : "Remove"} {beam_side === "Left" ? "First" : "Last"} Rafter
                        //     </MenuItem>
                        // );

                        pop_menu_items.push(
                            <MenuItem classes={{ root: classes.menu_item }}>
                                {beam_side === "Left" ? "First (Left)" : "Last (Right)"} Return Beam :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={toNumber(side_beam_omitted)}
                                    items={[
                                        { Key: 0, Display: "On" },
                                        { Key: 1, Display: "Off" },
                                        { Key: 2, Display: "If Required (eg; supports a purlin)" },
                                    ]}
                                    areaIndex={areaIndex}
                                    section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                    dataField={"Omit" + beam_side + "Beam"}
                                    clip_overflow
                                    refresh_svg
                                    onChange={(e) => {
                                        this.props.updateAreaSpecification(
                                            areaIndex,
                                            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
                                            "Omit" + beam_side + "Beam",
                                            e.target.value
                                        );
                                    }}
                                />
                            </MenuItem>
                        );
                    }
                }
                if (cutout) {
                    let max_overhang =
                        area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang;

                    if (pop_item.ref2.endsWith(" Y") || pop_item.ref2.endsWith(" Y2")) {
                        max_overhang =
                            area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
                    }
                    // pop_menu_items.push(<MenuItem classes={{ root: classes.menu_item }} onClick={this.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE + "." + "CUTOUTS", attach_tag.replace("Attachment", "CutoutType"), "None")}>Remove this cutout</MenuItem>);
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Cutout Type :&nbsp;
                            <AreaSelectField
                                value={cutoutType}
                                dark
                                items={
                                    pop_item?.ref?.startsWith("BackMid") || pop_item?.ref2 === "CBM"
                                        ? ["None", "Box", "Bay"]
                                        : ["None", "Angle", "Step", "Custom"]
                                }
                                clip_overflow
                                onChange={(e) => {
                                    // this.handleFootingUpdate(e, default_FootingType, pop_item)
                                    this.togglePop(false);
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref.split("-")[0] + "-CutoutType",
                                        e.target.value
                                    );
                                }}
                            />
                        </MenuItem>
                    );

                    let cutoutBeamY = area_design_specs.SHAPE.CUTOUTS[pop_item.ref.split("-")[0] + "-HasBeamY"];

                    //toggle cutout "Y" beams
                    if (cutoutType !== "None")
                        pop_menu_items.push(
                            <MenuItem classes={{ root: classes.menu_item }}>
                                Cutout Side Beams :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={toNumber(cutoutBeamY)}
                                    items={[
                                        { Key: 0, Display: "Off" },
                                        { Key: 1, Display: "On" },
                                    ]}
                                    clip_overflow
                                    onChange={(e) => {
                                        this.togglePop(false);
                                        this.props.updateAreaSpecification(
                                            areaIndex,
                                            BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                            pop_item.ref.split("-")[0] + "-HasBeamY",
                                            e.target.value
                                        );
                                    }}
                                />
                            </MenuItem>
                        );
                    pop_menu_items.push(
                        <MenuItem classes={{ root: classes.menu_item }}>
                            Cutout Overhang :&nbsp;{" "}
                            <BSL_TextInput
                                // helperText={is_extra_beam?<></>:null}
                                value={cutout_overhangValue}
                                style={{ color: "black", width: "100px", margin: "0px" }}
                                // autoFocus={true}
                                // selectAll={true}
                                tight
                                endAdornment="mm"
                                min={0}
                                max={max_overhang}
                                tooltipDelay={500}
                                onFocus={(event) => {
                                    event.target.select();
                                }}
                                onBlur={(val) => {
                                    this.props.updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        cutoutOverhangRef,
                                        val
                                    );
                                    this.setState({ pop_textfield_text: null });
                                }}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        this.togglePop(false);
                                        e.target.blur();
                                    }
                                }}
                                onChange={(val) => {
                                    this.setState({ pop_textfield_text: val });
                                }}
                                disabled={max_overhang === 0}
                            />
                        </MenuItem>
                    );
                    if (cutoutType === "Custom") {
                        pop_menu_items.push(
                            <MenuItem classes={{ root: classes.menu_item }}>
                                Num Custom Segments :&nbsp;
                                <AreaSelectField
                                    style={{ marginTop: "0px" }}
                                    selectStyle={{ color: "black", marginTop: "0px" }}
                                    value={
                                        area_design_specs.SHAPE.CUTOUTS[
                                            pop_item.ref.split("-")[0] + "-CustomNumSegments"
                                        ]
                                    }
                                    items={[2, 3, 4, 5, 6]}
                                    areaIndex={areaIndex}
                                    section={BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS}
                                    clip_overflow
                                    refresh_svg
                                    onChange={this.updateData(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS",
                                        pop_item.ref.split("-")[0] + "-CustomNumSegments",
                                        true
                                    )}
                                    // onChange={this.updateRoofData(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamType")}
                                />
                            </MenuItem>
                        );
                    }
                }

                pop_menu_items.push(<Divider classes={{ root: classes.divider }} />);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs_header }} variant="overline" display="block" gutterBottom>SPECIFICATIONS</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Type:</span> To Metal Fascia</Typography>);
                // pop_menu_items.push(<Typography classes={{ root: classes.pop_specs }} variant="caption" display="block" gutterBottom><span style={{ fontWeight: "bold" }}>Wall:</span> Brick Wall</Typography>);
            }

            if (show_front_back_overhangs) {
                let OH_Front = area_design_specs.SHAPE.OH_Front;
                let OH_Back = area_design_specs.SHAPE.OH_Back;

                let OH_Front_text_display_value = OH_Front_text === null ? OH_Front : OH_Front_text;
                if (OH_Front_text_display_value !== "")
                    OH_Front_text_display_value = toNumber(OH_Front_text_display_value, false);

                let OH_Back_text_display_value = OH_Back_text === null ? OH_Back : OH_Back_text;
                if (OH_Back_text_display_value !== "")
                    OH_Back_text_display_value = toNumber(OH_Back_text_display_value, false);

                let range_front = {
                    min: 0,
                    max: 200,
                    default: 0,
                };

                let range_back = {
                    min: 0,
                    max: 200,
                    default: 0,
                };

                let design_option = config.design_options[DesignType];
                if (design_option?.overhang_back_range)
                    range_back = { ...range_back, ...design_option.overhang_back_range };
                if (design_option?.overhang_front_range)
                    range_front = { ...range_front, ...design_option.overhang_front_range };

                range_back = replaceVariables(area_design_specs, range_back);
                range_front = replaceVariables(area_design_specs, range_front);

                pop_menu_items.push(
                    <div style={{ display: "flex" }}>
                        <BSL_TextInput
                            label="Front Overhang"
                            tight
                            selectAll={true}
                            endAdornment="mm"
                            tooltipDelay={500}
                            min={range_front.min}
                            max={range_front.max}
                            value={OH_Front_text_display_value}
                            style={{ color: "black", width: "120px", paddingLeft: "10px" }}
                            onFocus={(event) => {
                                event.target.select();
                            }}
                            onBlur={(val) => {
                                this.togglePop(false);
                                this.setState({ OH_Front_text: val });
                                this.updateAreaSpecificationValue(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    "OH_Front",
                                    Number(val),
                                    true,
                                    false
                                );
                            }}
                            onKeyPress={(e) => {
                                console.log(e.key);
                                if (e.key === "Enter") {
                                    e.target.blur();
                                }
                            }}
                            onChange={(val) => {
                                this.setState({ OH_Front_text: val });
                            }}
                        />
                        <BSL_TextInput
                            label="Back Overhang"
                            // style={{ color: "black", width: "100%", padding: "5px 10px 5px 10px" }}
                            tight
                            selectAll={true}
                            endAdornment="mm"
                            tooltipDelay={500}
                            min={range_back.min}
                            max={range_back.max}
                            value={OH_Back_text_display_value}
                            style={{ color: "black", width: "120px", paddingLeft: "10px" }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                            }}
                            onFocus={(event) => {
                                event.target.select();
                            }}
                            onBlur={(val) => {
                                this.togglePop(false);
                                this.setState({ OH_Back_text: val });
                                this.updateAreaSpecificationValue(
                                    areaIndex,
                                    BASIC_SPECS_SECTIONS.SHAPE,
                                    "OH_Back",
                                    Number(val),
                                    true,
                                    false
                                );
                            }}
                            onKeyPress={(e) => {
                                console.log(e.key);
                                if (e.key === "Enter") {
                                    e.target.blur();
                                }
                            }}
                            onChange={(val) => {
                                this.setState({ OH_Back_text: val });
                                // this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, pop_item.ref, e.target.value);
                            }}
                        />
                    </div>
                );
            }

            if (pop_menu_items_details.length > 0) {
                pop_menu_items.push(
                    <Typography
                        classes={{ root: classes.pop_specs_header }}
                        variant="overline"
                        display="block"
                        gutterBottom
                    >
                        DETAILS
                    </Typography>
                );
                pop_menu_items.push(pop_menu_items_details);
            }
        }

        // console.log(paper?.view?.scale);

        if (paper?.project) paper.project._needsUpdate = true;
        if (paper?.project) paper.project.view.update();

        return (
            <>
                {SELECT_POINT && SELECT_POINT !== "MoveLabels" && !show_pop && <Crosshairs />}
                <DesignerTools />
                <ViewTools />

                {/* <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        classes={{ root: classes.snackbar }}
                        open={app.designer.SHOW_MESSAGE}
                        autoHideDuration={4000}
                        onClose={this.handleClose}
                    >
                        <SnackbarContent
                            classes={{ root: classes.snackbar }}
                            message={app.designer.MESSAGE}
                            action={
                                <React.Fragment>
                                    <IconButton size="small" aria-label="close" color="inherit" onClick={this.handleClose}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>
                            } />
                    </Snackbar> */}

                <Message
                    open={app.designer.SHOW_MESSAGE}
                    message={app.designer.MESSAGE?.message ? app.designer.MESSAGE?.message : app.designer.MESSAGE}
                    type={app.designer.MESSAGE?.type ? app.designer.MESSAGE?.type : "error"}
                    onClose={this.handleClose}
                />

                <Babylon3D
                    adaptToDeviceRatio={false}
                    threeDMode={THREED_MODE}
                    threeDMiniMode={THREED_MINI_MODE}
                    TOOL_DRAWER_WIDTH={TOOL_DRAWER_WIDTH}
                    modelFileName={modelFileName}
                    backgroundMode={BACKGROUND_MODE}
                    togglePop={this.togglePop}
                    setToolSetArea={this.props.setToolSetArea}
                    uploadDocument={this.props.uploadDocument}
                    job={job}
                    app={app}
                />
                <UpdateComponent />
                <div className={classes.qq2dCanvasContainer + (this.props.visible ? "" : " invisible")}>
                    <canvas
                        id="qqCanvas"
                        className={classes.qq2dCanvas}
                        resize="true"
                        style={{
                            backgroundImage: SHOW_GRAPH_BG
                                ? "linear-gradient(white 2px, transparent 2px), linear-gradient(90deg, white 2px, transparent 2px), linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.3) 1px, transparent 1px)"
                                : "none",
                        }}
                    ></canvas>
                    {/* <CoordReporter /> */}

                    <Popover
                        open={show_pop && pop_menu_items.length > 0}
                        onClose={() => this.togglePop(false)}
                        anchorReference="anchorPosition"
                        anchorPosition={{
                            top: pop_location.y ? pop_location.y : 0,
                            left: pop_location.x ? pop_location.x : 0,
                        }}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: pop_alignment,
                        }}
                        classes={{ root: classes.popover }}
                    >
                        {pop_menu_items}
                    </Popover>
                    {this.state.mod_attachment_dialog && (
                        <SpecModifyAttachmentDialog
                            onClose={() => this.toggleMod_attachment_dialog(false, null)}
                            open={this.state.mod_attachment_dialog}
                            item={this.state.mod_attachment_item}
                        />
                    )}
                    {this.state.mod_attachment2_dialog && (
                        <SpecModifyAttachmentDialog2
                            onCancel={() => this.toggleMod_attachment2_dialog(false, null)}
                            onSave={() => {
                                if (this.state.mod_attachment2_saveAction) this.state.mod_attachment2_saveAction();
                                this.toggleMod_attachment2_dialog(false, null);
                            }}
                            open={this.state.mod_attachment2_dialog}
                            item={this.state.mod_attachment_item}
                            attach_tag={this.state.mod_attachment_item.attach_tag}
                        />
                    )}
                    {/* {this.state.mod_attachment_dialog && app?.user?.id.includes("kevinchan") && window.debug && (
                        <SpecModifyAttachmentDialog2
                            onClose={() => this.toggleMod_attachment_dialog(false, null)}
                            open={this.state.mod_attachment_dialog}
                            item={this.state.mod_attachment_item}
                        />
                    )} */}
                    {this.state.mod_beam_dialog && (
                        <SpecModifyBeamDialog
                            onClose={() => this.toggleMod_beam_dialog(false, null)}
                            open={this.state.mod_beam_dialog}
                            item={this.state.mod_beam_item}
                        />
                    )}
                    {this.state.mod_beam_posts_dialog && (
                        <SpecModifyBeamPostsDialog
                            onClose={() => this.toggleMod_beam_posts_dialog(false, null)}
                            open={this.state.mod_beam_posts_dialog}
                            item={this.state.mod_beam_posts_item}
                        />
                    )}
                    {this.state.mod_post_dialog && (
                        <SpecModifyPostDialog
                            onClose={() => this.toggleMod_post_dialog(false, null)}
                            open={this.state.mod_post_dialog}
                            item={this.state.mod_post_item}
                        />
                    )}
                    {this.state.mod_downpipe_dialog && (
                        <SpecModifyDownpipeDialog
                            onClose={() => this.toggleMod_downpipe_dialog(false, null)}
                            open={this.state.mod_downpipe_dialog}
                            item={this.state.mod_downpipe_item}
                        />
                    )}

                    {pop_item?.is_note && edit_item && show_pop && (
                        <SpecNotesDialog
                            areaIndex={areaIndex}
                            edit_note={edit_item}
                            onClose={() => {
                                this.togglePop(false);
                            }}
                        />
                    )}
                    {pop_item && (pop_item.is_slat || pop_item.sel_type === "slat_label") && edit_item && show_pop && (
                        <SpecSlatsTool
                            areaIndex={areaIndex}
                            edit_item={edit_item}
                            onClose={() => {
                                this.togglePop(false);
                            }}
                        />
                    )}

                    {this.state.edit_extra_beam_dialog && pop_item && (
                        <SpecExtraBeamDialog
                            areaIndex={areaIndex}
                            edit_item={pop_item}
                            showButtons={false}
                            onClose={() => {
                                this.toggleEdit_extra_beam_dialog(false);
                            }}
                        />
                    )}
                    {/* DES-1082 - Warning for Box/No Gutter when attached
                    {this.state.gutter_dialog &&
                        (this.props?.job?.AreaSpecifications?.[areaIndex]?.Acknowledgements
                            ?.BoxHouseGutterAcknowledgement === false ||
                            this.props?.job?.AreaSpecifications?.[areaIndex]?.Acknowledgements
                                ?.BoxHouseGutterAcknowledgement === undefined) && (
                            <GutterDialog gutterState={this.state} areaIndex={areaIndex} pop_item={pop_item} />
                        )} */}
                </div>
                {/* <img
                    style={{ display: "none" }}
                    src={BaseURL("images/icons8-error-48.png")}
                    alt="Warning"
                    id="designer_warning"
                ></img> */}
            </>
        );
    }
    // ALL 2D CANVAS RELATED STUFF

    LoadSVG(quote_number, svg_filename, zoom_all = false, clear_all = false) {
        let this_svg_load_path = quote_number + "/" + svg_filename;
        if (window.last_svg_load_attempt === this_svg_load_path) return; //already try/loaded
        window.svg = null;

        window.last_svg_load_attempt = quote_number + "/" + svg_filename;

        let url_base = API_BASE() + "svg/" + this_svg_load_path;

        console.log("LoadSVG url_base", url_base);

        paper.project.importSVG(url_base, {
            onLoad: (new_item, svg_raw) => {
                if (!new_item) return;
                new_item.svg_filename = this_svg_load_path;
                new_item.scale(1);
                if (clear_all && paper.project.activeLayer.children.length > 1) {
                    paper.project.activeLayer.removeChildren(0, paper.project.activeLayer.children.length - 1);
                }

                window.svg = new_item;
                Paper.FormatSVGToJob();
                Paper.UpdateAllSVGMaterials();
                Paper.GetMetaData();
                if (zoom_all) Paper.zoomAll();
            },
            onError: (message, status) => {
                console.log("Error Loading SVG");
                if (clear_all) Paper.ClearAll();
            },
        });
    }

    UpdateSVGsIfRequired(svg_filename) {
        if (!svg_filename) return;

        if (window.svg === null || !window.svg) {
            this.LoadSVG("local", svg_filename, true, true);
        } else if (window.svg.svg_filename === "local/" + svg_filename) {
            Paper.UpdateAllSVGMaterials();
            return; //same file name; ignore
        } else {
            this.LoadSVG("local", svg_filename, false, true);
        }
    }

    InitialisePaper(id) {
        // return;
        // Get a reference to the canvas object
        var canvas = window.document.getElementById(id);
        // Create an empty project and a view for the canvas:
        paper.setup(canvas);
        paper.project.options.handleSize = 6;
        paper.settings.hitTolerance = 6;
        paper.view.zoom = 1;
        paper.view.scale = 25;
        paper.view.scale = 25;
        paper.view.viewSize = new paper.Size(1920, 1200);

        window.paper = paper;
        window.paper_canvas = canvas;

        paper.view.onMouseDown = (e) => {
            window.dragging = false;
            _this.downPoint = e.point;
            _this.downPointScreen = new paper.Point(e.event.x, e.event.y);
            _this.downButton = e.event.button;

            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            if (SELECT_POINT === "MoveLabels") {
                let _hitOptions = (_hitOptions = {
                    // trigger only words
                    // class: paper.PointText,
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 6,
                    match: (res) => {
                        return res?.item ? Object.getPrototypeOf(res.item)?._class === "PointText" : false;
                    },
                });

                var hitResult = paper.project.activeLayer.hitTest(e.point, _hitOptions); // isPointInPath
                if (hitResult?.item) {
                    _this.last_hover = hitResult?.item;
                } else {
                    _this.last_hover = null;
                }
            }
        };

        const addMovedLabels = (move_labels, parent_item) => {
            if (parent_item.children && parent_item.children.length > 0) {
                parent_item.children.forEach(function (item) {
                    console.log(
                        "getPrototypeOf",
                        Object.getPrototypeOf(item)?._class,
                        item?.content_original ? item?.content_original : item.content
                    );
                    if (item.label_pos_ref && Object.getPrototypeOf(item)?._class === "PointText" && item.orig_point) {
                        let distance = item.orig_point.getDistance(item.point);
                        console.log(
                            "distance",
                            distance,
                            item?.content_original ? item?.content_original : item.content
                        );
                        if (distance > 10 || item.has_adjusted_position) {
                            let x_offset = item.point.x - item.orig_point.x;
                            let y_offset = item.point.y - item.orig_point.y;

                            let pnt = getPointForRef(
                                item?.has_adjusted_position ? item.has_adjusted_position : item.label_pos_ref
                            );
                            pnt.x += x_offset;
                            pnt.y -= y_offset;

                            move_labels.push({
                                AreaIndex: item?.areaIndex,
                                Text: item?.content_original ? item?.content_original : item.content,
                                Position: item.label_pos_ref,
                                AdjustedPosition: "(" + pnt.x.toFixed(2) + "/" + pnt.y.toFixed(2) + "/0.00)",
                            });
                        }
                    }

                    if (item.children && item.children.length > 0) {
                        move_labels = addMovedLabels(move_labels, item);
                    }
                });
            }
            return move_labels;
        };

        const saveMoveLabels = () => {
            let move_labels = addMovedLabels([], paper.project.activeLayer);
            // paper.project.activeLayer.children.forEach(function (item) {
            //     // console.log(
            //     //     "getPrototypeOf",
            //     //     Object.getPrototypeOf(item)?._class,
            //     //     item?.content_original ? item?.content_original : item.content
            //     // );
            //     if (item.label_pos_ref && Object.getPrototypeOf(item)?._class === "PointText" && item.orig_point) {
            //         let distance = item.orig_point.getDistance(item.point);
            //         console.log("distance", distance, item?.content_original ? item?.content_original : item.content);
            //         if (distance > 10 || item.has_adjusted_position) {
            //             let x_offset = item.point.x - item.orig_point.x;
            //             let y_offset = item.point.y - item.orig_point.y;

            //             let pnt = getPointForRef(
            //                 item?.has_adjusted_position ? item.has_adjusted_position : item.label_pos_ref
            //             );
            //             pnt.x += x_offset;
            //             pnt.y -= y_offset;

            //             move_labels.push({
            //                 Text: item?.content_original ? item?.content_original : item.content,
            //                 Position: item.label_pos_ref,
            //                 AdjustedPosition: "(" + pnt.x.toFixed(2) + "/" + pnt.y.toFixed(2) + "/0.00)",
            //             });
            //         }
            //     }
            // });
            console.log("move_labels", move_labels);
            this.props.update2DDesigner(APP.SELECTED_POINT, move_labels);
        };

        console.log("InitialisePaper this.props", this.props);
        paper.view.onKeyUp = (e) => {
            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            if (SELECT_POINT && e.key === "escape") {
                if (SELECT_POINT !== "MoveLabels") this.props.update2DDesigner(APP.SELECTED_POINT, false);
                this.props.update2DDesigner(APP.SELECT_POINT, false);
                var rubberband = paper?.project?.activeLayer?.rubberband;

                if (rubberband) {
                    rubberband.removeSegments();
                    if (current) current.remove();
                    if (arrow) arrow = null;
                    var rubberband_label = paper?.project?.activeLayer?.rubberband_label;
                    if (rubberband_label) rubberband_label.visible = false;
                    rubberband = null;
                }
                saveMoveLabels();
                return;
            }
        };

        // paper.view.onFrame = function (event) {
        //     if (window.warning_icons)
        //         for (let raster of window.warning_icons) {
        //             if (raster.glow_up) raster.opacity += 0.01;
        //             else raster.opacity -= 0.01;
        //             if (raster.opacity < 0.5) raster.glow_up = true;
        //             if (raster.opacity > 0.7) raster.glow_up = false;
        //         }
        // };

        paper.view.onMouseUp = (e) => {
            // // this.wasDragged = false;
            // alert(e);

            if (e?.target?.name === "warning_icon") return;

            const UNLOCKED = this.props.app.designer[APP.UNLOCKED];
            const locked =
                (this.props?.job?.OrderStatus === "PENDING" ||
                    this.props?.job?.OrderStatus === "ACCEPTED" ||
                    this.props?.job?.App?.Locked) &&
                !UNLOCKED;

            var hitResult = paper.project.activeLayer.hitTest(e.point, hitOptions); // isPointInPath
            // console.log("hit", hitResult);
            let toolopen = this.props.app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            let SELECT_POINT_ALLOW_HIT_SELTYPE = this.props.app.designer.designer2D[APP.SELECT_POINT_ALLOW_HIT_SELTYPE];
            if (typeof SELECT_POINT_ALLOW_HIT_SELTYPE === "string")
                SELECT_POINT_ALLOW_HIT_SELTYPE = [SELECT_POINT_ALLOW_HIT_SELTYPE];

            if (locked) {
                this.props.showDesignerMessage("Job is locked and cannot be modified.");
                return;
            }

            if (SELECT_POINT === "MoveLabels") {
                if (e?.event?.button === 2) {
                    this.props.update2DDesigner(APP.SELECT_POINT, false);
                    if (SELECT_POINT !== "MoveLabels") this.props.update2DDesigner(APP.SELECTED_POINT, false);
                    let rubberband = paper?.project?.activeLayer?.rubberband;
                    if (rubberband) {
                        rubberband.removeSegments();
                        if (current) current.remove();
                        if (arrow) arrow = null;

                        if (rubberband_label) rubberband_label.visible = false;
                        rubberband = null;
                    }
                    paper.project.activeLayer.rubberband = null;

                    saveMoveLabels();
                }
                if (_this.last_hover) _this.last_hover.orig_point_offset = null;
                window.dragging = false;
                return;
            } else if (
                !window.dragging &&
                SELECT_POINT &&
                SELECT_POINT_ALLOW_HIT_SELTYPE &&
                hitResult &&
                hitResult.item &&
                SELECT_POINT_ALLOW_HIT_SELTYPE.includes(hitResult.item.sel_type)
            ) {
                this.togglePop(true, e.event.x, e.event.y, hitResult.item);
            } else if (!window.dragging && SELECT_POINT) {
                var rubberband = paper?.project?.activeLayer?.rubberband;
                var rubberband_label = paper?.project?.activeLayer?.rubberband_label;

                if (e?.event?.button === 2) {
                    this.props.update2DDesigner(APP.SELECT_POINT, false);
                    this.props.update2DDesigner(APP.SELECTED_POINT, false);
                    if (rubberband) {
                        rubberband.removeSegments();
                        if (current) current.remove();
                        if (arrow) arrow = null;

                        if (rubberband_label) rubberband_label.visible = false;
                    }
                    return;
                }

                let x = e.point.x;
                let y = e.point.y;
                if (window.paper_origin) {
                    x = x - window.paper_origin.x;
                    y = -(y - window.paper_origin.y);
                }

                if (toNumber(SELECT_POINT) <= 1) {
                    this.props.update2DDesigner(APP.SELECTED_POINT, { x: x, y: y });
                    // this.togglePop(true, e.event.x, e.event.y, { is_point: true, ref: "point", point: e.point, areaIndex: 0, areaNumber: 1 });
                } else {
                    if (rubberband && rubberband.segments.length > 0) {
                        rubberband.add(e.point);
                        if (SELECT_POINT.includes && SELECT_POINT.includes("Arrow")) arrow = new Arrow(e.point);
                    } else {
                        paper.project.activeLayer.rubberband = new paper.Path(e.point, e.point);
                        var rubberband = paper.project.activeLayer.rubberband;
                        rubberband.name = "rubberband";
                        rubberband.strokeColor = "blue";
                        rubberband.strokeWidth = 4;
                        rubberband.dashArray = [3, 3];
                        rubberband.visible = true;
                        rubberband.bringToFront();

                        paper.project.activeLayer.rubberband_label = new paper.PointText(e.point);
                        var rubberband_label = paper.project.activeLayer.rubberband_label;
                        rubberband_label.name = "rubberband label";
                        rubberband_label.justification = "center";
                        rubberband_label.justification = "center";
                        rubberband_label.fillColor = "#555555";
                        rubberband_label.content = "0mm";

                        if (SELECT_POINT.includes && SELECT_POINT.includes("Arrow")) arrow = new Arrow(e.point);
                    }

                    if (rubberband.segments.length > toNumber(SELECT_POINT)) {
                        let points = [];
                        for (let segment of rubberband.segments) {
                            console.log("segment", segment);
                            let x = segment.point.x;
                            let y = segment.point.y;
                            if (window.paper_origin) {
                                x = x - window.paper_origin.x;
                                y = -(y - window.paper_origin.y);
                            }

                            points.push({ x: x, y: y });
                        }
                        if (points.length > toNumber(SELECT_POINT)) points.pop();
                        // if (current) current.remove();
                        if (arrow) arrow = null;
                        this.props.update2DDesigner(APP.SELECTED_POINT, points);
                    }
                }
            } else if (!window.dragging && !hitResult) {
                const hitOptions2 = {
                    // Trigger hit only on 'fill' part of the path with 0 tolerance
                    segments: false,
                    stroke: true,
                    fill: true,
                    tolerance: 100,
                    match: (res) => {
                        return res.item.areaIndex !== undefined && res.item.areaIndex > -1;
                    },
                };

                var hitResult2 = paper.project.activeLayer.hitTest(e.point, hitOptions2); // isPointInPath

                console.log(e, hitResult2);
                if (hitResult2) {
                    console.log("hit2", hitResult2.item.areaIndex);
                } else {
                    hitResult2 = paper.project.activeLayer.hitTest(e.point, {
                        ...hitOptions2,
                        tolerance: 1000,
                    }); // isPointInPath
                    if (hitResult2) {
                        console.log("hit2a", hitResult2.item.areaIndex);
                    }
                }

                if (hitResult2) {
                    console.log("hit3", hitResult2.item.areaIndex);
                } else {
                    hitResult2 = paper.project.activeLayer.hitTest(e.point, {
                        ...hitOptions2,
                        tolerance: 2000,
                    }); // isPointInPath
                    if (hitResult2) {
                        console.log("hit3a", hitResult2.item.areaIndex);
                    }
                }

                if (hitResult2 && hitResult2.item.areaIndex !== undefined && hitResult2.item.areaIndex > -1) {
                    this.togglePop(true, e.event.x, e.event.y, {
                        is_point: true,
                        ref: "point",
                        point: e.point,
                        areaIndex: hitResult2.item.areaIndex,
                        areaNumber: hitResult2.item.areaIndex + 1,
                    });
                }
            } else if (!window.dragging && hitResult && hitResult.item) {
                let item = hitResult.item;
                paper.project.deselectAll();
                if (item.ref) {
                    _this.selected_item = item;
                    item.selected = true;
                }
                let areaIndex = item.areaIndex ? Number(item.areaIndex) : 0;
                item.click_point = e.point;
                this.togglePop(true, e.event.x, e.event.y, item);

                if (item.is_roofsheet) {
                    // if (skylight_type_in_areas[areaIndex] === "") {
                    //     this.setMessage(true, "Skylight is not set for this area");
                    // }
                    // else {
                    //     console.log("change to skylight");
                    //     item.is_skylight = item.is_skylight ? !item.is_skylight : true;
                    //     if (item.is_skylight) {
                    //         item.fillColor = new paper.Color(Paper.GetHTMLColour(Paper.GetSpec(areaIndex, ROOF_SHEETING, "SkylightColour")).split(',')[1]);
                    //         item.fillColor.alpha = 0.5;
                    //     }
                    //     paper.project.view.update();
                    //     this.UpdateRoofSheets(true);
                    // }
                    // if (toolopen !== SHAPE_TOOL) this.props.setToolSetArea(areaIndex, ROOFSHEET_TOOL);
                } else if (item.typeQQ && item.typeQQ === "sheet_label") {
                    // if (item?.content && item?.content.includes("°")) this.props.setToolSetArea(areaIndex, SHAPE_TOOL);
                    // else if (toolopen !== SHAPE_TOOL) this.props.setToolSetArea(areaIndex, ROOFSHEET_TOOL);
                } else if (item.is_beam) {
                    // if (toolopen !== SHAPE_TOOL) this.props.setToolSetArea(areaIndex, BEAMS_AND_POSTS_TOOL);
                } else if (item.is_gutter || (item.typeQQ && item.typeQQ === "gutter_label")) {
                    // this.togglePop(true, e.event.x, e.event.y, item);
                    // if (toolopen !== SHAPE_TOOL) this.props.setToolSetArea(areaIndex, GUTTERS_DOWNPIPES_TOOL);
                } else if (item.typeQQ && item.typeQQ === "area_label") {
                    // this.togglePop(true, e.event.x, e.event.y, item);

                    // paper.view.center = item.position.add(new paper.Point(-(item.bounds.width/2)+200, -(item.bounds.height/2)+500));
                    // tween(paper.view.center, {x:2000}, 2);

                    let new_postion = item.position.add(
                        new paper.Point(-(item.bounds.width / 2) + 300, -(item.bounds.height / 2) + 700)
                    );
                    var steps = 12;
                    let diff = paper.view.center.subtract(new_postion);
                    let shift = new paper.Point(diff.x / steps, diff.y / steps);
                    let shift_half = new paper.Point(diff.x / steps / 2, diff.y / steps / 2);
                    function move() {
                        setTimeout(function () {
                            if (steps < steps / 3) {
                                paper.view.center = paper.view.center.subtract(shift_half);
                                steps -= 0.5;
                            } else {
                                paper.view.center = paper.view.center.subtract(shift);
                                steps--;
                            }
                            if (steps > 0) move();
                        }, 1);
                    }
                    move();
                    // for (let i = 0; i < 200; i++)
                    // {
                    //     // paper.view.center.x += 1;

                    // paper.view.center = paper.view.center.add(shift);
                    // paper.project.view.update();
                    // }

                    // this.props.setToolSetArea(areaIndex);
                }
            } else {
                paper.project.deselectAll();
            }
            paper.view.element.style.setProperty("cursor", "crosshair");
            window.dragging = false;
        };

        var offset;
        var offsetSpeed;
        var offset_run = false;
        var offset_running = false;
        var offset_direction = "top";

        paper.view.onMouseMove = (e) => {
            let SELECT_POINT = this.props.app.designer.designer2D[APP.SELECT_POINT];
            let rubberband_to_point = e.point;
            if (SELECT_POINT && e.point) {
                var rubberband = paper.project?.activeLayer?.rubberband;
                var rubberband_label = paper.project?.activeLayer?.rubberband_label;

                if (rubberband && rubberband.segments.length > 0) {
                    rubberband.segments[rubberband.segments.length - 1].point = e.point;

                    //snap e.point to vector angle
                    let from_point = rubberband.segments[rubberband.segments.length - 2].point;
                    if (from_point) {
                        var vector_mouse = rubberband_to_point.subtract(from_point);
                        var new_vector = new paper.Point(0, 0);
                        var vector_last_line = new paper.Point(0, 0);

                        // console.log("vector_mouse.angle",vector_mouse.angle);
                        new_vector.length = vector_mouse.length;
                        var angle_relative_to_last_line = vector_mouse.angle - vector_last_line.angle;
                        var mod = Math.abs(angle_relative_to_last_line % 45);
                        // console.log("mod", mod);

                        var snap_tolerance = 3;
                        var snapped = false;
                        if (!e.modifiers.control) {
                            if (
                                (mod < snap_tolerance && mod > -snap_tolerance) ||
                                (mod > 45 - snap_tolerance && mod < 45 + snap_tolerance)
                            ) {
                                var angle = Math.round(angle_relative_to_last_line / 45) * 45 + vector_last_line.angle;
                                console.log("snap " + angle);
                                new_vector.angle = angle;
                                rubberband_to_point = from_point.add(new_vector);
                                snapped = true;
                            }
                        }

                        rubberband.segments[rubberband.segments.length - 1].point = rubberband_to_point;
                        var vector1 = rubberband_to_point.subtract(rubberband.segments[0].point);
                        var actual_angle_relative_to_last_line = vector1.angle - vector_last_line.angle;

                        if (rubberband_label) {
                            rubberband_label.point = e.point.add(
                                new paper.Point(90 / paper.view.zoom, -20 / paper.view.zoom)
                            );
                            rubberband_label.content =
                                Math.round(vector_mouse.length) +
                                "mm @" +
                                actual_angle_relative_to_last_line.toFixed(1) +
                                " degs\n" +
                                (snapped ? " *press ctrl to unsnap*" : "");
                            rubberband_label.fontSize = 12 / paper.view.zoom;
                        }

                        var scroll_tolerance = 100;
                        offsetSpeed = 2 / paper.view.zoom;
                        if (e.event.y < scroll_tolerance) {
                            offset_direction = "top";
                            offset_run = true;
                            if (e.event.x < scroll_tolerance * 2) {
                                offset_direction = "top-left";
                            } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance * 2) {
                                offset_direction = "top-right";
                            }

                            if (e.event.y < (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.y < scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.y < scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
                        } else if (e.event.y > paper.view.viewSize.height - scroll_tolerance) {
                            offset_direction = "bottom";
                            offset_run = true;
                            if (e.event.x < scroll_tolerance * 2) {
                                offset_direction = "bottom-left";
                            } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance * 2) {
                                offset_direction = "bottom-right";
                            }
                            if (e.event.y > paper.view.viewSize.height - (scroll_tolerance * 2) / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.y > paper.view.viewSize.height - scroll_tolerance / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.y > paper.view.viewSize.height - scroll_tolerance / 10)
                                offsetSpeed = offsetSpeed * 2;
                        } else if (e.event.x < scroll_tolerance) {
                            offset_direction = "left";
                            offset_run = true;
                            if (e.event.x < (scroll_tolerance * 2) / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.x < scroll_tolerance / 3) offsetSpeed = offsetSpeed * 2;
                            if (e.event.x < scroll_tolerance / 10) offsetSpeed = offsetSpeed * 2;
                        } else if (e.event.x > paper.view.viewSize.width - scroll_tolerance) {
                            offset_direction = "right";
                            offset_run = true;
                            if (e.event.x > paper.view.viewSize.width - (scroll_tolerance * 2) / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.x > paper.view.viewSize.width - scroll_tolerance / 3)
                                offsetSpeed = offsetSpeed * 2;
                            if (e.event.x > paper.view.viewSize.width - scroll_tolerance / 10)
                                offsetSpeed = offsetSpeed * 2;
                        } else {
                            offset_run = false;
                        }

                        if (offset_run && !offset_running) {
                            let offset_up = () => {
                                offset = new paper.Point(0, -offsetSpeed);
                                if (offset_direction === "top-left")
                                    offset = new paper.Point(-offsetSpeed, -offsetSpeed);
                                if (offset_direction === "top-right")
                                    offset = new paper.Point(offsetSpeed, -offsetSpeed);
                                if (offset_direction === "bottom") offset = new paper.Point(0, offsetSpeed);
                                if (offset_direction === "bottom-left")
                                    offset = new paper.Point(-offsetSpeed, offsetSpeed);
                                if (offset_direction === "bottom-right")
                                    offset = new paper.Point(offsetSpeed, offsetSpeed);
                                if (offset_direction === "left") offset = new paper.Point(-offsetSpeed, 0);
                                if (offset_direction === "right") offset = new paper.Point(offsetSpeed, 0);
                                paper.view.center = paper.view.center.add(offset);

                                // offset rubberband
                                if (rubberband?.segments?.[1])
                                    rubberband.segments[1].point = rubberband.segments[1].point.add(offset);
                                offset_grid(offset);
                                paper.view.draw();

                                if (offset_run)
                                    setTimeout(function () {
                                        offset_up();
                                    }, 20);
                                else offset_running = false;
                            };
                            offset_running = true;
                            offset_up();
                        }
                    }
                }

                if (current) current.remove();
                if (arrow && SELECT_POINT.includes && SELECT_POINT.includes("Arrow"))
                    current = arrow.draw(rubberband_to_point);
                // else if (rubberband.segments.length === 1) {
                //     rubberband.add(e.point);
                // }
            }
        };

        var bg_pos1 = new paper.Point(-50, -50);
        var bg_pos2 = new paper.Point(-50, -50);
        var orig_bg_zoom1 = 100;
        var orig_zoom = 1;
        var last_rounded = 100;

        function offset_grid(offset = new paper.Point(-0, -0)) {
            var change_ratio = (paper.view.zoom / orig_zoom) * 1;

            // var change_ratio = paper.view.zoom / orig_zoom;
            var rounded = orig_bg_zoom1 * change_ratio;
            var rounded_sm = rounded / 5;
            if (document.getElementById("qqCanvas")?.style)
                document.getElementById("qqCanvas").style.backgroundSize =
                    rounded +
                    "px " +
                    rounded +
                    "px, " +
                    rounded +
                    "px " +
                    rounded +
                    "px, " +
                    rounded_sm +
                    "px " +
                    rounded_sm +
                    "px, " +
                    rounded_sm +
                    "px " +
                    rounded_sm +
                    "px";

            if (rounded !== last_rounded) {
                offset = offset.add(new paper.Point(-(rounded - last_rounded) / 2, -(rounded - last_rounded) / 2));
            }
            // bg_pos1 = bg_pos1.subtract(new paper.Point(-(rounded-last_rounded)/2, -(rounded-last_rounded)/2));
            // // bg_pos1 = bg_pos1.subtract(rounded);
            // bg_pos1 = bg_pos1.subtract(offset);
            // bg_pos2 = bg_pos2.subtract(offset);
            if (offset) {
                offset.x = offset.x * change_ratio;
                offset.y = offset.y * change_ratio;
                bg_pos1 = bg_pos1.subtract(offset);
                bg_pos2 = bg_pos2.subtract(offset);
                document.getElementById("qqCanvas").style.backgroundPosition =
                    bg_pos1.x +
                    "px " +
                    bg_pos1.y +
                    "px, " +
                    bg_pos1.x +
                    "px " +
                    bg_pos1.y +
                    "px, " +
                    bg_pos2.x +
                    "px " +
                    bg_pos2.y +
                    "px, " +
                    bg_pos2.x +
                    "px " +
                    bg_pos2.y +
                    "px";
            }
            last_rounded = rounded;
        }

        var qqCanvas = document.getElementById("qqCanvas");
        if (qqCanvas)
            qqCanvas.addEventListener(
                "wheel",
                function (e) {
                    var delta = e.deltaY;
                    var zoom = paper.view.zoom * (1 - delta / 4500);

                    // zoom = zoom * (1 + delta / 5500);
                    // console.log(zoom + " " + delta);
                    if (zoom > 7) zoom = 7;
                    if (zoom < 0.03) zoom = 0.03;
                    paper.view.zoom = zoom;

                    offset_grid();

                    // e.preventDefault();
                    e.stopPropagation();
                },
                { passive: true }
            );
        if (qqCanvas)
            qqCanvas.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });

        // return;

        paper.view.onMouseDrag = function (e) {
            let SELECT_POINT = window?.app?.designer?.designer2D?.SELECT_POINT;

            var distance_dragged = _this.downPoint ? _this.downPoint.getDistance(e.point) : 0;
            var distance_screen_dragged = _this.downPointScreen.getDistance(new paper.Point(e.event.x, e.event.y));

            paper.view.element.style.setProperty("cursor", "all-scroll");

            if (SELECT_POINT === "MoveLabels" && _this.last_hover) {
                if (_this.last_hover && !_this.last_hover.orig_point_offset) {
                    // _this.last_hover.orig_point = new paper.Point(_this.last_hover.point);
                    _this.last_hover.orig_point_offset = _this.downPoint.subtract(_this.last_hover.point);
                    console.log("_this.last_hover", _this.last_hover);
                }
                if (distance_screen_dragged > 5) {
                    // console.log("start moving...", _this.last_hover);
                    window.dragging = true;
                    if (_this.last_hover) {
                        // var offset = _this.downPoint.subtract(e.point);
                        _this.last_hover.point = e.point.subtract(_this.last_hover.orig_point_offset);
                    }

                    // if (!paper.project.activeLayer.rubberband) {
                    //     paper.project.activeLayer.rubberband = new paper.Path(e.point, e.point);
                    //     var rubberband = paper.project.activeLayer.rubberband;
                    //     rubberband.name = "rubberband";
                    //     rubberband.strokeColor = "blue";
                    //     rubberband.strokeWidth = 4;
                    //     rubberband.dashArray = [3, 3];
                    //     rubberband.visible = true;
                    //     rubberband.bringToFront();

                    //     rubberband.add(e.point);
                    // } else {
                    // }
                }
            } else if (
                (distance_screen_dragged > 20 || (e.event.type === "touchmove" && distance_dragged)) &&
                !window.dragging
            ) {
                window.dragging = true;
            } else if (
                (_this.downButton === 0 ||
                    _this.downButton === 1 ||
                    _this.downButton === 2 ||
                    e.event.type === "touchmove") &&
                window.dragging
            ) {
                _this.dragging = true;
                var offset = _this.downPoint.subtract(e.point);
                paper.view.center = paper.view.center.add(offset);
                offset_grid(offset);
            }
        };

        var tool = new paper.Tool(); // Again manually. Life is much easier with script type="text/paperscript"
        tool.onMouseMove = function (event) {
            // Installig paperjs event

            let SELECT_POINT = window?.app?.designer?.designer2D?.SELECT_POINT;

            let _hitOptions = hitOptions;
            if (SELECT_POINT === "MoveLabels") {
                _hitOptions = {
                    // trigger only words
                    // class: paper.PointText,
                    tolerance: 100,
                    fill: true,
                    stroke: true,
                    tolerance: 6,
                    match: (res) => {
                        return res?.item ? Object.getPrototypeOf(res.item)?._class === "PointText" : false;
                    },
                };
            }

            var hitResult = paper.project.activeLayer.hitTest(event.point, _hitOptions); // isPointInPath

            // console.log("hitResult", hitResult);
            if (!hitResult && SELECT_POINT !== "MoveLabels") {
                const hitOptions2 = {
                    // Trigger hit only on 'fill' part of the path with 0 tolerance
                    segments: false,
                    stroke: true,
                    fill: true,
                    tolerance: 100,
                    match: (res) => {
                        return res.item.areaIndex !== undefined && res.item.areaIndex > -1;
                    },
                };

                hitResult = paper.project.activeLayer.hitTest(event.point, hitOptions2); // isPointInPath
                if (!hitResult) {
                    hitResult = paper.project.activeLayer.hitTest(event.point, {
                        ...hitOptions2,
                        tolerance: 1000,
                    }); // isPointInPath
                }
            }

            if (window.THREED_MODE && !window.THREED_MINI_MODE) return;
            if (SELECT_POINT === "MoveLabels") {
                if (hitResult && hitResult.item) {
                    paper.view.element.style.setProperty("cursor", "pointer");
                } else {
                    paper.view.element.style.setProperty("cursor", "crosshair");
                }
            } else if (SELECT_POINT) {
                let SELECT_POINT_ALLOW_HIT_SELTYPE =
                    window?.app?.designer?.designer2D?.[APP.SELECT_POINT_ALLOW_HIT_SELTYPE];
                if (typeof SELECT_POINT_ALLOW_HIT_SELTYPE === "string")
                    SELECT_POINT_ALLOW_HIT_SELTYPE = [SELECT_POINT_ALLOW_HIT_SELTYPE];

                if (
                    SELECT_POINT_ALLOW_HIT_SELTYPE &&
                    hitResult &&
                    hitResult.item &&
                    SELECT_POINT_ALLOW_HIT_SELTYPE.includes(hitResult.item.sel_type)
                ) {
                    paper.view.element.style.setProperty("cursor", "pointer");
                } else {
                    paper.view.element.style.setProperty("cursor", "crosshair");
                    hitResult = null;
                }
            } else {
                if (!window.dragging) paper.view.element.style.setProperty("cursor", "crosshair");
                if (window.dragging) paper.view.element.style.setProperty("cursor", "all-scroll");
            }
            var x = event.point.x;
            var y = event.point.y;

            // document.body.style.cursor = "default";
            if (_this.selected_item) return;

            // document.getElementById("xycoordinates").innerHTML = "Coordinates: (" + x + "," + y + ")";

            if (_this.last_hover && (!hitResult || hitResult.item !== _this.last_hover) && !window.dragging) {
                // console.log("resetiing", last_hover.opacity_o);
                _this.last_hover.shadowColor = null;
                _this.last_hover.shadowBlur = 0;
                if (_this.last_hover.fillColor)
                    _this.last_hover.fillColor.alpha = _this.last_hover.fillColorAlpha_o
                        ? _this.last_hover.fillColorAlpha_o
                        : 1;
                _this.last_hover = null;
                if (_this.last_hover_matches) {
                    _this.last_hover_matches.forEach(function (item_match) {
                        item_match.shadowColor = null;
                        item_match.shadowBlur = 0;
                        if (item_match.fillColor)
                            item_match.fillColor.alpha = item_match.fillColorAlpha_o ? item_match.fillColorAlpha_o : 1;
                    });
                }
            }

            if (hitResult && hitResult.item !== _this.last_hover && !window.dragging) {
                // console.log(hitResult.item);
                let name = GetName(hitResult.item);
                if ((name && hitResult.item.ref && hitResult.item.ref.length > 0) || SELECT_POINT === "MoveLabels") {
                    // document.body.style.cursor = "pointer";
                    paper.view.element.style.setProperty("cursor", "pointer");
                    var item = hitResult.item;
                    if (item.fillColor && item.fillColorAlpha_o === undefined)
                        item.fillColorAlpha_o = item.fillColor.alpha;
                    item.fillColor.alpha = item.fillColor.alpha * 0.75;
                    item.shadowColor = "green";
                    item.shadowBlur = 30;
                    item.shadowOffset = new paper.Point(0, 0);
                    _this.last_hover = item;

                    if (hitResult?.item?.ref4) {
                        //to highlight all matching beams that are spliced
                        _this.last_hover_matches = paper.project.getItems({ ref4: hitResult.item.ref4 });
                        _this.last_hover_matches.forEach(function (item_match) {
                            if (item_match.fillColor && item_match.fillColorAlpha_o === undefined)
                                item_match.fillColorAlpha_o = item_match.fillColor.alpha;
                            if (item_match?.fillColor?.alpha)
                                item_match.fillColor.alpha = item_match.fillColor.alpha * 0.75;
                            item_match.shadowColor = "green";
                            item_match.shadowBlur = 30;
                            item_match.shadowOffset = new paper.Point(0, 0);
                        });
                    }
                }
            } else if (hitResult && hitResult.item === _this.last_hover) {
                // document.body.style.cursor = "pointer";
                if (!window.dragging) paper.view.element.style.setProperty("cursor", "pointer");
            } else {
                if (!window.dragging) paper.view.element.style.setProperty("cursor", "crosshair");
                if (window.dragging) paper.view.element.style.setProperty("cursor", "all-scroll");
            }
        };

        function GetName(item) {
            if (item) {
                if (item.name) return item.name;
                if (item.parent && item.parent.name && !item.parent.name.startsWith("area")) return item.parent.name;
                if (item.parent.parent && item.parent.parent.name && !item.parent.parent.name.startsWith("area"))
                    return item.parent.parent.name;
            }
            return null;
        }

        var qqCanvas = document.getElementById("qqCanvas");
        if (qqCanvas)
            qqCanvas.addEventListener(
                "wheel",
                function (e) {
                    var delta = e.deltaY;
                    var zoom = paper.view.zoom * (1 - delta / 4500);

                    // zoom = zoom * (1 + delta / 5500);
                    // console.log(zoom + " " + delta);
                    if (zoom > 4.5) zoom = 4;
                    if (zoom < 0.005) zoom = 0.015;
                    paper.view.zoom = zoom;

                    offset_grid();

                    // e.preventDefault();
                    e.stopPropagation();
                },
                { passive: true }
            );
        if (qqCanvas)
            qqCanvas.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });
    }

    Contains(value, values_to_check) {
        if (typeof values_to_check === "string") {
            return value.includes(values_to_check);
        }
        if (Array.isArray(values_to_check)) {
            for (let val of values_to_check) {
                if (value.includes(val)) return true;
            }
        }
        return false;
    }
    // FormatSVGToJob() {
    //     if (window.svg) {
    //         for (let key in window.svg.children) {
    //             let item = window.svg.children[key];

    //             // setting defaults
    //             item.areaIndex = 1;
    //             item.ref = "";
    //             if (key.startsWith("selection_type:sheet")) {
    //                 item.is_roofsheet = true;
    //                 if (this.Contains(key, ["Ampelite", "Polycarbonate"])) item.is_skylight = true;

    //                 let kvps = key.split(',');
    //                 for (let kvp of kvps) {
    //                     let split = kvp.split(':');
    //                     let key = split[0];
    //                     let value = split[1];

    //                     if (key === "area") item.areaIndex = Number(value);
    //                     if (key === "ref") item.ref = value;
    //                 }
    //             }
    //             if (key.includes("name:sheet_section_")) item.remove();
    //         }
    //     }
    // }
    UpdateSkylights(from_babylon = false) {
        // UpdateItemsInDrawing("selection_type:sheet", "is_skylight", ROOF_SHEETING, "RoofColour", "Classic Cream");
        const THREED_MODE = this.props.app.designer[APP.THREED_MODE];
        const THREED_MINI_MODE = this.props.app.designer[APP.THREED_MINI_MODE];
        let skylights = from_babylon ? GetSkylights() : Paper.GetSkylights();
        console.log("skylights", THREED_MODE, "from_babylon", from_babylon, skylights);
        for (let area in skylights) {
            this.props.updateAreaSpecification(Number(area), "SKYLIGHTS", null, skylights[area]);
        }
        setTimeout(() => {
            if (THREED_MODE) {
                var success = updateSkylights3D();
                if (!success) {
                    setTimeout(() => {
                        success = updateSkylights3D();
                        if (!success) {
                            setTimeout(() => {
                                var success = updateSkylights3D();
                                updateColours(true);
                            }, 500);
                        } else {
                            updateColours(true);
                        }
                    }, 300);
                } else {
                    updateColours(true);
                }
            }

            if (!THREED_MODE || (THREED_MODE && THREED_MINI_MODE)) {
                Paper.UpdateSkylights2D();
            }
        }, 300);
    }

    UpdateItemsInDrawing(
        name_string_to_match,
        secondard_parameter_to_match = null,
        section,
        parameter,
        default_value = ""
    ) {
        if (window.svg) {
            let values_in_areas = this.GetSpecAllAreas(section, parameter, default_value);
            console.log(values_in_areas);

            if (parameter === "RoofSheetColour")
                values_in_areas.forEach(function (value, index, array) {
                    array[index] = GetHTMLColour(value)[1];
                });

            for (let key in window.svg.children) {
                if (key.startsWith(name_string_to_match)) {
                    console.log(key);
                    let item = window.svg.children[key];

                    if (key.includes("area:1")) item.fillColor = new paper.Color(values_in_areas[0]);
                    if (key.includes("area:2")) item.fillColor = new paper.Color(values_in_areas[1]);
                    // item.fillColor.alpha = 1;
                    // new_item.children[key].onMouseEnter = function (event) {
                    //         // document.querySelector(".QQ2DCanvas-qq2dCanvasContainer-578").style.cursor = "pointer";
                    //         console.log("entered!");
                    //     }
                }
            }
        }
    }

    GetSpec(areaIndex, Section, Parameter, default_value) {
        if (!window.job) return default_value;
        if (window.job) {
            if (
                window.job.AreaSpecifications &&
                window.job.AreaSpecifications[areaIndex] &&
                window.job.AreaSpecifications[areaIndex][Section] &&
                window.job.AreaSpecifications[areaIndex][Section][Parameter]
            ) {
                return window.job.AreaSpecifications[areaIndex][Section][Parameter];
            }
        }
        return default_value;
    }
    GetSpecAllAreas(Section, Parameter, default_value) {
        var values = [];
        if (!window.job) return values;
        if (window.job) {
            for (var area of window.job.AreaSpecifications) {
                if (area[Section] && area[Section][Parameter]) {
                    values.push(area[Section][Parameter]);
                } else {
                    values.push(default_value);
                }
            }
        }
        return values;
    }
}

QQ2DCanvas.propTypes = {
    classes: PropTypes.object.isRequired,
};

// function GetHTMLColour(colour) {
//     if (colour === "OTHER") return "#00FC00,#00FC00,#F5F5F5"; if (colour === "TBA") return "#00FC00,#00FC00,#000000"; if (colour === "NONE") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Blue Ridge") return "#6070A3,#6070A3,#F5F5F5"; if (colour === "Bushland") return "#89897C,#89897C,#F5F5F5"; if (colour === "Classic Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Cottage Green") return "#335142,#335142,#F5F5F5"; if (colour === "Deep Ocean") return "#474F60,#474F60,#F5F5F5"; if (colour === "Dune") return "#B5AFAA,#B5AFAA,#000000"; if (colour === "Headland") return "#96543F,#96543F,#F5F5F5"; if (colour === "Ironstone") return "#565960,#565960,#F5F5F5"; if (colour === "Jasper") return "#7F6D5B,#7F6D5B,#F5F5F5"; if (colour === "Manor Red") return "#BC4235,#BC4235,#F5F5F5"; if (colour === "Night Sky") return "#232326,#232326,#F5F5F5"; if (colour === "Pale Eucalypt") return "#77A577,#77A577,#000000"; if (colour === "Paperbark") return "#CCBFA8,#CCBFA8,#000000"; if (colour === "Plantation") return "#566360,#566360,#F5F5F5"; if (colour === "Sandbank") return "#CEB787,#CEB787,#000000"; if (colour === "Shale Grey") return "#BCBCBA,#BCBCBA,#000000"; if (colour === "Surfmist") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Wilderness") return "#63776B,#63776B,#F5F5F5"; if (colour === "Windspray") return "#919696,#919696,#000000"; if (colour === "Woodland Grey") return "#5B5B56,#5B5B56,#F5F5F5"; if (colour === "Galvanised") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Zincalume") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Galvanised") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Zinc") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Arctic White/Arctic White") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Rich Cream/Rich Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Sahara/Sahara") return "#CEB787,#CEB787,#000000"; if (colour === "Vanilla/Vanilla") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Vanilla/Heritage Red") return "#BC4235,#E2DBA5,#F5F5F5"; if (colour === "Vanilla/Rivergum") return "#63776B,#E2DBA5,#F5F5F5"; if (colour === "Vanilla/Slate Grey") return "#B5AFAA,#E2DBA5,#000000"; if (colour === "Arctic White") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Graphite") return "#5B5B56,#5B5B56,#F5F5F5"; if (colour === "Heritage Green") return "#335142,#335142,#F5F5F5"; if (colour === "Hunter Red") return "#BC4235,#BC4235,#F5F5F5"; if (colour === "Rich Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Sahara") return "#CEB787,#CEB787,#000000"; if (colour === "Vanilla") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Opal") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Gumleaf") return "#4C7A4F,#4C7A4F,#F5F5F5"; if (colour === "Ocean Blue") return "#638291,#638291,#F5F5F5"; if (colour === "Classic Cream") return "#FCF4BC,#FCF4BC,#000000"; if (colour === "Grey Tint (Trans)") return "#565960,#565960,#F5F5F5"; if (colour === "Bronze Tint (Trans)") return "#7F6D5B,#7F6D5B,#F5F5F5"; if (colour === "Clear (Trans)") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Opal") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Platinum (Trans)") return "#566360,#566360,#F5F5F5"; if (colour === "Steel (Trans)") return "#565960,#565960,#F5F5F5"; if (colour === "Olive Mica (Trans)") return "#63776B,#63776B,#F5F5F5"; if (colour === "Gun Metal (Trans)") return "#72726B,#72726B,#F5F5F5"; if (colour === "Eucalypt") return "#63776B,#63776B,#F5F5F5"; if (colour === "Alpine Blue") return "#638291,#638291,#F5F5F5"; if (colour === "Satin Cream") return "#CCBFA8,#CCBFA8,#000000"; if (colour === "Satin Sage") return "#63776B,#63776B,#F5F5F5"; if (colour === "Designer Light TWO") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Metallic Ice TWO") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Metallic Grey TWO") return "#72726B,#72726B,#F5F5F5"; if (colour === "Grey Tint TWO") return "#565960,#565960,#F5F5F5"; if (colour === "Clear Tint") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Aqua Tint") return "#638291,#638291,#F5F5F5"; if (colour === "Grey Tint") return "#565960,#565960,#F5F5F5"; if (colour === "Metallic Grey") return "#72726B,#72726B,#F5F5F5"; if (colour === "Opal Tint") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Clear Tint") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Grey Tint") return "#565960,#565960,#F5F5F5"; if (colour === "Stone") return "#FCC6BC,#FCC6BC,#000000"; if (colour === "Arctic Ice") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Metallic Bronze (Trans)") return "#8E6638,#8E6638,#F5F5F5"; if (colour === "Ivory") return "#CEB787,#CEB787,#000000"; if (colour === "Cream (Fibreglass)") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Pale Eucalypt/Surfmist") return "#E0E0DD,#77A577,#000000"; if (colour === "Pale Terracotta/Surfmist") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Classic Cream/Surfmist") return "#E0E0DD,#E2DBA5,#000000"; if (colour === "Paperbark/Surfmist") return "#E0E0DD,#CCBFA8,#000000"; if (colour === "Surfmist/Surfmist") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Sahara/Slate Grey") return "#B5AFAA,#CEB787,#000000"; if (colour === "Cedar Bronze ST") return "#8E6638,#8E6638,#F5F5F5"; if (colour === "Clear ST") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Mist Green ST") return "#63776B,#63776B,#F5F5F5"; if (colour === "Opal ST") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Smooth Cream ST") return "#FCF4BC,#FCF4BC,#000000"; if (colour === "Solar Grey ST") return "#565960,#565960,#F5F5F5"; if (colour === "Grey ST") return "#565960,#565960,#F5F5F5"; if (colour === "Diffused Grey ST") return "#565960,#565960,#F5F5F5"; if (colour === "Diffused Ice ST") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Evening Haze") return "#CCBFA8,#CCBFA8,#000000"; if (colour === "Loft") return "#232326,#232326,#F5F5F5"; if (colour === "Monument") return "#232326,#232326,#F5F5F5"; if (colour === "Pitch Black") return "#232326,#232326,#F5F5F5"; if (colour === "Stone") return "#FCC6BC,#FCC6BC,#000000"; if (colour === "Bronze Olive") return "#7F6D5B,#7F6D5B,#F5F5F5"; if (colour === "Zincalume/Grey") return "#B5AFAA,#E0E0E5,#000000"; if (colour === "Blue Ridge/Grey") return "#B5AFAA,#6070A3,#000000"; if (colour === "Bushland/Grey") return "#B5AFAA,#89897C,#000000"; if (colour === "Classic Cream/Grey") return "#B5AFAA,#E2DBA5,#000000"; if (colour === "Cottage Green/Grey") return "#B5AFAA,#335142,#000000"; if (colour === "Deep Ocean/Grey") return "#B5AFAA,#474F60,#000000"; if (colour === "Dune/Grey") return "#B5AFAA,#B5AFAA,#000000"; if (colour === "Evening Haze/Grey") return "#B5AFAA,#CCBFA8,#000000"; if (colour === "Headland/Grey") return "#B5AFAA,#96543F,#000000"; if (colour === "Ironstone/Grey") return "#B5AFAA,#565960,#000000"; if (colour === "Jasper/Grey") return "#B5AFAA,#7F6D5B,#000000"; if (colour === "Loft/Grey") return "#B5AFAA,#232326,#000000"; if (colour === "Manor Red/Grey") return "#B5AFAA,#BC4235,#000000"; if (colour === "Monument/Grey") return "#B5AFAA,#232326,#000000"; if (colour === "Night Sky/Grey") return "#B5AFAA,#232326,#000000"; if (colour === "Pale Eucalypt/Grey") return "#B5AFAA,#77A577,#000000"; if (colour === "Paperbark/Grey") return "#B5AFAA,#CCBFA8,#000000"; if (colour === "Plantation/Grey") return "#B5AFAA,#566360,#000000"; if (colour === "Sandbank/Grey") return "#B5AFAA,#CEB787,#000000"; if (colour === "Shale Grey/Grey") return "#B5AFAA,#BCBCBA,#000000"; if (colour === "Surfmist/Grey") return "#B5AFAA,#E0E0DD,#000000"; if (colour === "Wilderness/Grey") return "#B5AFAA,#63776B,#000000"; if (colour === "Windspray/Grey") return "#B5AFAA,#919696,#000000"; if (colour === "Woodland Grey/Grey") return "#B5AFAA,#5B5B56,#000000"; if (colour === "Heritage Red") return "#BC4235,#BC4235,#F5F5F5"; if (colour === "Slate Grey") return "#B5AFAA,#B5AFAA,#000000"; if (colour === "Dune/Surfmist") return "#E0E0DD,#B5AFAA,#000000"; if (colour === "Headland/Surfmist") return "#E0E0DD,#96543F,#000000"; if (colour === "Clear") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Light Bronze") return "#7F6D5B,#7F6D5B,#F5F5F5"; if (colour === "Grey") return "#565960,#565960,#F5F5F5"; if (colour === "Opal") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Green") return "#63776B,#63776B,#F5F5F5"; if (colour === "Wheat") return "#B5AFAA,#B5AFAA,#000000"; if (colour === "Dark Tint") return "#232326,#232326,#F5F5F5"; if (colour === "Smooth Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Mist Green") return "#63776B,#63776B,#F5F5F5"; if (colour === "Pearl Ice") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Silver Mist") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Plain") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Bronze") return "#7F6D5B,#7F6D5B,#F5F5F5"; if (colour === "Clear") return "#E0E0E5,#E0E0E5,#000000"; if (colour === "Grey") return "#565960,#565960,#F5F5F5"; if (colour === "Metallic Grey") return "#565960,#565960,#F5F5F5"; if (colour === "Opal") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Grey") return "#565960,#565960,#F5F5F5"; if (colour === "Opal") return "#FCFCFC,#FCFCFC,#000000"; if (colour === "Rivergum") return "#63776B,#63776B,#F5F5F5"; if (colour === "Domain") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Terrace") return "#CEB787,#CEB787,#000000"; if (colour === "Riversand") return "#CEB787,#CEB787,#000000"; if (colour === "Willow") return "#77A577,#77A577,#000000"; if (colour === "Grey Ridge") return "#5B5B56,#5B5B56,#F5F5F5"; if (colour === "Basalt") return "#72726B,#72726B,#F5F5F5"; if (colour === "Cove") return "#89897C,#89897C,#F5F5F5"; if (colour === "Gully") return "#7F7F72,#7F7F72,#F5F5F5"; if (colour === "Mangrove") return "#72726B,#72726B,#F5F5F5"; if (colour === "Terrain") return "#96543F,#96543F,#F5F5F5"; if (colour === "Wallaby") return "#7F7F72,#7F7F72,#F5F5F5"; if (colour === "Basalt/Grey") return "#B5AFAA,#72726B,#000000"; if (colour === "Cove/Grey") return "#B5AFAA,#89897C,#000000"; if (colour === "Gully/Grey") return "#B5AFAA,#7F7F72,#000000"; if (colour === "Mangrove/Grey") return "#B5AFAA,#72726B,#000000"; if (colour === "Terrain/Grey") return "#B5AFAA,#96543F,#000000"; if (colour === "Wallaby/Grey") return "#B5AFAA,#7F7F72,#000000"; if (colour === "Classic Cream/Classic Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Paperbark/Gully") return "#7F7F72,#CCBFA8,#F5F5F5"; if (colour === "Classic Cream/Mangrove") return "#72726B,#E2DBA5,#F5F5F5"; if (colour === "Classic Cream/Monument") return "#232326,#E2DBA5,#F5F5F5"; if (colour === "Paperbark/Paperbark") return "#CCBFA8,#CCBFA8,#000000"; if (colour === "Surfmist/Surfmist") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Classic Cream/Woodland Grey") return "#5B5B56,#E2DBA5,#F5F5F5"; if (colour === "Paperbark/Woodland Grey") return "#5B5B56,#CCBFA8,#F5F5F5"; if (colour === "Basalt/Surfmist") return "#E0E0DD,#72726B,#000000"; if (colour === "Jasper/Surfmist") return "#E0E0DD,#7F6D5B,#000000"; if (colour === "Shale Grey/Surfmist") return "#E0E0DD,#BCBCBA,#000000"; if (colour === "Surfmist/Monument") return "#232326,#E0E0DD,#F5F5F5"; if (colour === "Woodland Grey/Surfmist") return "#E0E0DD,#5B5B56,#000000"; if (colour === "Pale Eucalypt/Classic Cream") return "#E2DBA5,#77A577,#000000"; if (colour === "Classic Cream/Classic Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Paperbark/Classic Cream") return "#E2DBA5,#CCBFA8,#000000"; if (colour === "Surfmist/Classic Cream") return "#E2DBA5,#E0E0DD,#000000"; if (colour === "Dune/Classic Cream") return "#E2DBA5,#B5AFAA,#000000"; if (colour === "Headland/Classic Cream") return "#E2DBA5,#96543F,#000000"; if (colour === "Basalt/Classic Cream") return "#E2DBA5,#72726B,#000000"; if (colour === "Jasper/Classic Cream") return "#E2DBA5,#7F6D5B,#000000"; if (colour === "Shale Grey/Classic Cream") return "#E2DBA5,#BCBCBA,#000000"; if (colour === "Woodland Grey/Classic Cream") return "#E2DBA5,#5B5B56,#000000"; if (colour === "Classic Cream") return "#E2DBA5,#E2DBA5,#000000"; if (colour === "Surfmist") return "#E0E0DD,#E0E0DD,#000000"; if (colour === "Pale Terracotta/Classic Cream") return "#E2DBA5,#E0E0DD,#000000"; if (colour === "Monument/Monument") return "#232326,#232326,#F5F5F5"; if (colour === "Classic Cream/Manor Red") return "#BC4235,#E2DBA5,#F5F5F5";
//     return "";
// }

var arrow;
var current;

function Arrow(mouseDownPoint) {
    this.start = mouseDownPoint;
    this.headLength = 120;
    this.tailLength = 45;
    this.headAngle = 25;
    this.tailAngle = 92;
}

Arrow.prototype.draw = function (point) {
    var end = this.start;
    var arrowVec = point.subtract(end);

    // parameterize {headLength: 20, tailLength: 6, headAngle: 35, tailAngle: 110}
    // construct the arrow
    var arrowHead = arrowVec.normalize(this.headLength);
    var arrowTail = arrowHead.normalize(this.tailLength);

    var p3 = end; // arrow point

    var p2 = end.add(arrowHead.rotate(-this.headAngle)); // leading arrow edge angle
    var p4 = end.add(arrowHead.rotate(this.headAngle)); // ditto, other side

    var p1 = p2.add(arrowTail.rotate(this.tailAngle)); // trailing arrow edge angle
    var p5 = p4.add(arrowTail.rotate(-this.tailAngle)); // ditto

    // specify all but the last segment, closed does that
    this.path = new paper.Path(point, p1, p2, p3, p4, p5);
    this.path.closed = true;

    this.path.strokeWidth = 1;
    this.path.strokColor = "#B200B2";
    this.path.fillColor = "#B200B2";

    return this.path;
};

export function ClearScratch() {
    if (current) current.remove();
    if (arrow) arrow = null;

    var rubberband = paper?.project?.activeLayer?.rubberband;
    if (rubberband) rubberband.removeSegments();
    var rubberband_label = paper?.project?.activeLayer?.rubberband_label;
    if (rubberband_label) rubberband_label.visible = false;
}

function tween(o, props, durationSecs, onComplete, easef) {
    var fps = 30,
        count = 0,
        stopAt = fps * durationSecs,
        startVals = {},
        endVals = {},
        easef = easef || Quad_easeOut;
    for (var p in props) startVals[p] = tween_getProperty(o, p);
    for (var p in props) endVals[p] = props[p];
    var f = function () {
        count++;
        if (count >= stopAt) {
            tween_stop(o);
            tween_setProps(o, endVals);
            if (onComplete) onComplete();
        } else {
            for (var p in props) tween_setProperty(o, p, easef(count, startVals[p], endVals[p] - startVals[p], stopAt));
        }
    };
    clearInterval(o._tween_int);
    o._tween_int = setInterval(f, (durationSecs * 1000) / fps);
}
function tween_stop(o) {
    clearInterval(o._tween_int);
}
function tween_setProps(o, props) {
    for (var p in props) tween_setProperty(o, p, props[p]);
}
function tween_setProperty(o, p, value) {
    o.style[p] = value + "px";
}
function tween_getProperty(o, p) {
    var v;
    if (document.defaultView && document.defaultView.getComputedStyle) {
        var cs = document.defaultView.getComputedStyle(o, null);
        if (cs && cs.getPropertyValue) v = cs.getPropertyValue(p);
    } else v = o.currentStyle[p];
    v = Number(String(v).split("px")[0]);
    return v;
}
//R.Penner Quart easing t=time,b=start,c=delta,d=duration
function Quad_easeIn(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
}
function Quad_easeOut(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
}
function Quad_easeInOut(t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
    return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}

// export default withStyles(styles)(QQ2DCanvas);
export default connect(mapStateToProps, importedActions)(withStyles(styles)(QQ2DCanvas));
